// SkipTraceUnifiedModal.jsx (ES5-style, no optional chaining)
import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Modal, ButtonToolbar } from 'reactstrap';
import Button from '@material-ui/core/Button';
import { Tooltip } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import SkipTractIcon from 'mdi-react/AccountBoxOutlineIcon';
import ActiveIcon from 'mdi-react/CheckCircleOutlineIcon';
import CompanyIcon from 'mdi-react/DomainIcon';
import EducationIcon from 'mdi-react/SchoolIcon';
import ACRISIcon from 'mdi-react/MagnifyIcon';
import TaxIcon from 'mdi-react/FileOutlineIcon';

// Icons
import EmailOutlineIcon from 'mdi-react/EmailOutlineIcon';
import PhoneIcon from 'mdi-react/PhoneIcon';
import MapMarkerIcon from 'mdi-react/MapMarkerOutlineIcon';
import ChevronRightIcon from 'mdi-react/ChevronRightIcon';

import AccountCircleIcon from 'mdi-react/AccountCircleOutlineIcon';

import LinearLoading from './../LinearLoading';
import { _axiosCall } from '../../helpers/apicalls';
import { _hasPermission } from '../../helpers/access';
import PremiumCreditIcon from 'mdi-react/PlusCircleMultipleOutlineIcon';
import SnackBar from '../SimpleSnackBar';
import QuickStartGuide from '../QuickStartGuide';

import PremiumCreditsPurchaseModal, {
	premiumCreditServices
} from '../premium_credits/PremiumCreditsPurchaseModal';

import {
	_capitalizeText,
	_formatNumber,
	_formatPrice,
	_isHouse,
	isCompanyName
} from "../../helpers/utils";
import { connect } from 'react-redux';

import { setUserProfile } from '../../../redux/actions/authActions';
import {
	_getUserSSO,
	_setSSOToken,
	_getSSOToken,
	_getSSOOrg
} from '../auth/sso/ssoutils';
import { pickBestPerson, mapPersonToOwnerFormat, pickBestWorkplaceRecord, formatAddress, _ensureHttp, _toStr } from './skipTraceMatchUtils';
import ProfileLoadingCard from './ProfileLoadingCard';
import './SkipTraceUnifiedModal.scss';
import { Publisher } from '../../pubsub/publisher';

var apiRoot = process.env.API_ROOT;
var aiAnalyzeRoot = process.env.AI_DOCUMENT_API_ROOT;
function _formatMonthYear(d) {
	if (!d || isNaN(d.getTime())) return '';
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	return months[d.getMonth()] + ' ' + d.getFullYear();
}
const CREDITS_ARTICLE_URL = 'http://help.marketproof.com/en/articles/13454433-understanding-credits-in-marketproof-pro';
class SkipTraceUnifiedModal extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			modal: false,

			// person
			simple_loading: false,
			simple_error: null,
			simple_person: null,

			deep_loading: false,
			deep_error: null,
			deep_persons: [],

			// workplace
			workplace_loading: false,
			workplace_error: null,
			workplace_records: [],

			// track request state
			request_state: this.props.state || '',

			// company
			company_loading: false,
			company_error: null,
			company_result: null,

			company_lookup_started: false,
			owner_lookup_started: false,
			last_owner_bbl: null,

			deep_expanded: {},            // map of { index: true/false } for deep results
			wp_by_index: {},              // map of { index: [workplaceRecords] }
			wp_loading_index: null,       // index currently loading workplace
			wp_error_by_index: {},        // map of { index: 'error message' }

			pendingOpenAfterPurchase: null, // 'contact' | 'full' | null
			lookup_mode: null,             // 'contact' | 'full' | null
			hasSearched: false,

			ai_loading: false,
			ai_error: null,
			ai_profile: null,

			pdl_result: null,
			pdl_loading: false,

			// saved-to-account lookup
			saved_loading: false,
			saved_error: null,
			saved_record: null,

			active_request_id: null,
			saved_this_request: false,

			acris_loading: false,
			acris_error: null,
			acris_result: null,
			acris_lookup_started: false,

			acris_status: '',
			acris_progress: null,
			acris_streaming: false,

			snackShow: false,
			snackMessage: '',
			snackType: 'success',
			snackDuration: 6000,

			acris_background_started: false,

			acris_streaming: false,

			owner_loading: false,

			company_mode: null, // 'basic' | 'deep' | null
			upgrading_from_basic: false, // flag to track if upgrading from basic to deep



		};

		// top-level controls
		this.toggle = this.toggle.bind(this);
		this._openFlow = this._openFlow.bind(this);

		// company flow
		this._fmtDate = this._fmtDate.bind(this);
		this._runCompanyLookup = this._runCompanyLookup.bind(this);
		this._renderCompanySection = this._renderCompanySection.bind(this);

		// person flow
		this._runSimple = this._runSimple.bind(this);
		this._runDeep = this._runDeep.bind(this);
		this._runWorkplaceTrace = this._runWorkplaceTrace.bind(this);
		this._runDeepAll = this._runDeepAll.bind(this);

		// split renderers
		this._renderPersonFlow = this._renderPersonFlow.bind(this);
		this._renderCompanyFlow = this._renderCompanyFlow.bind(this);

		// shared format + links
		this._formatAddressSimple = this._formatAddressSimple.bind(this);
		this._mailto = this._mailto.bind(this);
		this._tel = this._tel.bind(this);
		this._mapsSearch = this._mapsSearch.bind(this);
		this._formatPhoneDisplay = this._formatPhoneDisplay.bind(this);

		// deep person helpers
		this._renderDeepSection = this._renderDeepSection.bind(this);
		this._formatAddressFullDeep = this._formatAddressFullDeep.bind(this);
		this._formatPhoneLine = this._formatPhoneLine.bind(this);
		this._renderList = this._renderList.bind(this);

		// workplace helpers
		this._renderWorkplaceSection = this._renderWorkplaceSection.bind(this);
		this._renderEmployment = this._renderEmployment.bind(this);
		this._normalizeWorkExp = this._normalizeWorkExp.bind(this);
		this._renderEducation = this._renderEducation.bind(this);

		// small presentational helper
		this._ListItem = this._ListItem.bind(this);

		// flow detection

		// clear + init helpers
		this._resetCompanyState = this._resetCompanyState.bind(this);
		this._resetPersonState = this._resetPersonState.bind(this);
		this._initCompanyFlow = this._initCompanyFlow.bind(this);
		this._initPersonFlow = this._initPersonFlow.bind(this);

		this._toggleDeepRow = this._toggleDeepRow.bind(this);
		this._runWorkplaceForIndex = this._runWorkplaceForIndex.bind(this);
		this._renderDeepResultsList = this._renderDeepResultsList.bind(this);

		this._renderSimpleContactCard = this._renderSimpleContactCard.bind(this);
		this._toSimpleShapeFromDeep = this._toSimpleShapeFromDeep.bind(this);
		this._renderShowFullProfileLink = this._renderShowFullProfileLink.bind(this);

		this._handleTriggerClick = this._handleTriggerClick.bind(this);
		this._getUserPremiumCredits = this._getUserPremiumCredits.bind(this);
		this._getRequiredCreditsForContact = this._getRequiredCreditsForContact.bind(this);
		this._openPremiumCreditsModal = this._openPremiumCreditsModal.bind(this);
		this._handlePremiumPurchaseConfirm = this._handlePremiumPurchaseConfirm.bind(this);

		this._getInitialsFromPerson = this._getInitialsFromPerson.bind(this);

		// new helpers for mode selection
		this._ensureCredits = this._ensureCredits.bind(this);
		this._handleStartContactOnly = this._handleStartContactOnly.bind(this);
		this._handleStartFullProfile = this._handleStartFullProfile.bind(this);
		this._startContactOnlyInternal = this._startContactOnlyInternal.bind(this);
		this._startFullProfileInternal = this._startFullProfileInternal.bind(this);

		// new AI helpers
		this._buildProfileAIPayload = this._buildProfileAIPayload.bind(this);
		this._runProfileAI = this._runProfileAI.bind(this);
		this._renderAISummary = this._renderAISummary.bind(this);
		// in constructor
		this._inferLanguagesFromAI = this._inferLanguagesFromAI.bind(this);

		this._buildSavedIdentity = this._buildSavedIdentity.bind(this);
		this._fetchSavedSkipTrace = this._fetchSavedSkipTrace.bind(this);
		this._hydrateFromSavedRecord = this._hydrateFromSavedRecord.bind(this);
		this._saveSkipTraceToAccount = this._saveSkipTraceToAccount.bind(this);

		this._deductCreditsAfterSave = this._deductCreditsAfterSave.bind(this);
		this._applyCreditsToUser = this._applyCreditsToUser.bind(this);

		this._runAcrisAnalyze = this._runAcrisAnalyze.bind(this);
		this._renderAcrisOwnersSection = this._renderAcrisOwnersSection.bind(this);
		this._fetchPreferredAcrisDocForProperty = this._fetchPreferredAcrisDocForProperty.bind(this);

		this._acrisAbortController = null;
		this._acrisStreamActive = false;

		this._handleStartCompanyBasic = this._handleStartCompanyBasic.bind(this);
		this._handleStartCompanyDeep = this._handleStartCompanyDeep.bind(this);
		this._handleUpgradeToCompanyDeep = this._handleUpgradeToCompanyDeep.bind(this);
		this._startCompanyBasicInternal = this._startCompanyBasicInternal.bind(this);
		this._startCompanyDeepInternal = this._startCompanyDeepInternal.bind(this);
		this._upgradeToCompanyDeepInternal = this._upgradeToCompanyDeepInternal.bind(this);


	}


	_renderSearchContextBanner(matchSummary) {
		var isCompany = isCompanyName(this.props.triggerDisplay);
		var property = this.props.property || {};

		var nameLabel = isCompany
			? (this.props.business_name || this.props.triggerDisplay)
			: ((this.props.first_name || '') + ' ' + (this.props.last_name || '')).trim();



		var addressLine = formatAddress(property);

		return (
			<div className="skiptrace-search-context">

				<div className="context-primary">
					{(this.state.saved_record || this.props.saved_record) ? "Saved" : "Search"} results for <strong>{_capitalizeText(nameLabel)}</strong>
					{addressLine ? ' at ' + addressLine : ''}.
				</div>
				{matchSummary && (
					<div className="context-secondary">
						{matchSummary}
					</div>
				)}
			</div>
		);
	}


	_handleStartCompanyBasic() {
		var required = this._getRequiredCreditsForContact('company_basic');
		var self = this;

		this._ensureCredits(required, 'company_basic', function () {
			self._startCompanyBasicInternal();
		});
	}

	_handleStartCompanyDeep() {
		var required = this._getRequiredCreditsForContact('company_advanced');
		var self = this;

		this._ensureCredits(required, 'company_advanced', function () {
			self._startCompanyDeepInternal();
		});
	}


	_startCompanyBasicInternal() {
		var self = this;
		var rid = this._newRequestId();

		this.setState({
			company_mode: 'company_basic',
			active_request_id: rid,
			saved_this_request: false,
			hasSearched: true
		}, function () {
			// 1) Try saved (you’ll need backend support for this skip_trace_type)
			self._fetchSavedSkipTrace('company_basic', function (found) {
				if (found) return;

				// 2) Otherwise run the non-ACRIS pipeline
				self._runCompanyLookup()
					.then(function () { return self._runCompanyOwnerLookup(); })
					.then(function () {
						self._saveSkipTraceToAccount('company_basic', {
							extended_data: self.state && self.state.company_result ? self.state.company_result : null

						}).then(function () {
							return self._deductCreditsAfterSave('company_basic');
						})
							.catch(function (err) {
								console.log('save skip trace error:', err && err.message ? err.message : err);
							});
					})
					.catch(function (err) {
						self.setState({
							company_error: (err && err.message) ? err.message : 'Company basic search failed'
						});
					});
			});
		});
	}


	_startCompanyDeepInternal() {
		var self = this;
		var rid = this._newRequestId();

		this.setState({
			company_mode: 'company_advanced',
			active_request_id: rid,
			saved_this_request: false,
			hasSearched: true
		}, function () {
			// 1) Try saved deep result (your current company saved logic is built around 'company_advanced')
			self._fetchSavedSkipTrace('company_advanced', function (found) {
				if (found) return;

				// 2) Otherwise run the pipeline that ends in ACRIS
				self._runCompanyLookupThenOwnerThenAcris();
			});
		});
	}

	_handleUpgradeToCompanyDeep() {
		var required = this._getRequiredCreditsForContact('company_advanced');
		var self = this;

		this._ensureCredits(required, 'company_advanced', function () {
			self._upgradeToCompanyDeepInternal();
		});
	}

	_upgradeToCompanyDeepInternal() {
		var self = this;

		// Mark that we're upgrading from basic (already paid for basic)
		this.setState({
			company_mode: 'company_advanced',
			upgrading_from_basic: true,
			saved_this_request: false
		}, function () {
			// Save basic first if not already saved
			self._saveCompanyBasicIfNeeded()
				.then(function () {
					// Now run ACRIS lookup
					return self._runCompanyLookupThenOwnerThenAcris();
				})
				.catch(function (err) {
					console.log('Upgrade to deep failed:', err && err.message ? err.message : err);
					self.setState({
						acris_error: (err && err.message) ? err.message : 'Failed to upgrade to deep research'
					});
				});
		});
	}


	_saveCompanyBasicIfNeeded() {
		var self = this;

		// avoid double save in same request
		if (self.state.saved_this_request) return Promise.resolve(null);

		var payloadToSave = {
			extended_data: self.state.company_result || null,
			// include any other fields you already store for company basic path
		};

		return self._saveSkipTraceToAccount('company_basic', payloadToSave)
			.then(function () {
				self.setState({ saved_this_request: true });
				return self._deductCreditsAfterSave('company_basic');
			})
			.catch(function (err) {
				// Don’t crash UI if save fails; show error or log
				console.log('company_basic save failed:', err && err.message ? err.message : err);
				return null;
			});
	}

	_handlePremiumPurchaseConfirm(selectedPack, done) {
		var self = this;

		if (done && typeof done === 'function') done();

		var mode = this.state.pendingOpenAfterPurchase;

		if (mode === 'contact') {
			this.setState({ pendingOpenAfterPurchase: null }, function () {
				self._startContactOnlyInternal();
			});
			return;
		}

		if (mode === 'full') {
			this.setState({ pendingOpenAfterPurchase: null }, function () {
				self._startFullProfileInternal();
			});
			return;
		}

		if (mode === 'company_basic') {
			this.setState({ pendingOpenAfterPurchase: null }, function () {
				self._startCompanyBasicInternal();
			});
			return;
		}

		if (mode === 'company_advanced') {
			this.setState({ pendingOpenAfterPurchase: null }, function () {
				self._startCompanyDeepInternal();
			});
			return;
		}

		this.setState({ pendingOpenAfterPurchase: null });
	}







	componentDidMount() {
		this._mounted = true;
	}


	_abortAcrisStream() {
		try {
			this._acrisStreamActive = false;
			if (this._acrisAbortController) {
				this._acrisAbortController.abort();
				this._acrisAbortController = null;
			}
		} catch (e) { }
	}

	_isAcrisAbortedError(err) {
		try {
			if (!err) return false;
			if (err.name === 'AbortError') return true;
			if (err.code === 'ACRIS_STREAM_ABORTED') return true;
			var msg = err.message ? String(err.message) : '';
			return msg.indexOf('aborted') !== -1 || msg.indexOf('AbortError') !== -1;
		} catch (e) {
			return false;
		}
	}
	componentWillUnmount() {
		this._mounted = false;
		this._abortAcrisStream();
	}

	_sendAcrisToBackground(opts) {
		opts = opts || {};

		if (this.state.acris_background_started) return Promise.resolve({ ok: true, skipped: true });

		var self = this;

		// SNAPSHOT BEFORE ANY OTHER ACTIONS
		var companyResultSnapshot = this.state.company_result;

		this._abortAcrisStream();

		this.setState({
			acris_loading: false,
			acris_streaming: false,
			acris_status: '',
			acris_progress: null,
			acris_background_started: true
		});

		return this._fetchPreferredAcrisDocForProperty().then(function (payload) {
			if (!payload || !payload.doc_id || !payload.doc_type) {
				if (self._mounted) self.setState({ acris_error: 'No matching ACRIS doc found.', acris_background_started: false });
				return { ok: false };
			}

			var userData = {
				url: apiRoot + '/skip/acris-analyze-job/start',
				method: 'post',
				query: {
					user: self.props.user,
					identity: self._buildSavedIdentity ? self._buildSavedIdentity() : null,
					doc_id: payload.doc_id,
					doc_type: payload.doc_type,
					settings: payload.settings || null,
					// USE SNAPSHOT, NOT self.state.company_result
					extended_data: companyResultSnapshot || null,
					property: self.props.property || null
				}
			};

			return _axiosCall(userData)
				.then(function () {
					if (self._mounted) {

						return self._deductCreditsAfterSave('company_advanced').then(function (r) {
							self.setState({
								snackShow: true,
								snackType: 'success',
								snackMessage: 'Owner research sent to background. We’ll email you when complete.',
								snackDuration: 6000
							});
							if (opts.closeModal) self.toggle(); // see fix #2
							return { ok: true };
						});

					}


				})
				.catch(function (err) {
					if (self._mounted) {
						self.setState({
							acris_background_started: false,
							snackShow: true,
							snackType: 'error',
							snackMessage: (err && err.message) ? err.message : 'Failed to start background job',
							snackDuration: 6000
						});
					}
					return { ok: false };
				});
		});
	}





	_applyCreditsToUser(payload) {
		if (!payload) return;

		var creditsAfter = (typeof payload.credits_after === 'number') ? payload.credits_after : null;
		if (creditsAfter === null) return;

		var updateUser = Object.assign({}, this.props.user);
		updateUser.premiumCredits = creditsAfter;

		this.props.dispatch(setUserProfile(updateUser));
	}

	_deductCreditsAfterSave(skipTraceType) {
		var self = this;

		function _postDeduct(type, credits) {
			if (!credits || credits <= 0) return Promise.resolve();

			return _axiosCall({
				url: apiRoot + '/skip/credits/deduct',
				method: 'post',
				query: {
					credit_type: 'premium',
					credits_used: credits,
					reason: 'skip_trace_saved',
					skip_trace_type: type,
					identity: self._buildSavedIdentity(),
					user: self.props.user
				}
			})
				.then(function (res) {
					self._applyCreditsToUser(res && res.data ? res.data : res);
				})
				.catch(function (err) {
					console.log('credit deduct failed:', err);
				});
		}

		// Person
		if (skipTraceType === 'contact') {
			return _postDeduct('contact', this._getRequiredCreditsForContact('contact'));
		}

		if (skipTraceType === 'profile') {
			var c = this._getRequiredCreditsForContact('contact');
			var p = this._getRequiredCreditsForContact('profile');
			return _postDeduct('profile', c + p);
		}

		// Company Basic
		if (skipTraceType === 'company_basic') {
			return _postDeduct('company_basic', this._getRequiredCreditsForContact('company_basic'));
		}

		// Company Deep (ACRIS)
		if (skipTraceType === 'company_advanced') {
			var basic = this._getRequiredCreditsForContact('company_basic');
			var adv = this._getRequiredCreditsForContact('company_advanced');

			// If upgrading from basic, only deduct advanced credits (basic already paid)
			if (this.state.upgrading_from_basic) {
				// Reset the flag after deducting
				this.setState({ upgrading_from_basic: false });
				return _postDeduct('company_advanced', adv);
			}

			// Otherwise deduct both basic + advanced
			return _postDeduct('company_advanced', basic + adv)
		}

		return Promise.resolve();
	}




	_newRequestId() {
		return String(Date.now()) + ':' + String(Math.random()).slice(2);
	}

	_buildSavedIdentity() {

		var isCompany = isCompanyName(this.props.triggerDisplay);
		var property = this.props.property || {};
		if (isCompany) {
			return {
				business_name: this.props.business_name || this.props.triggerDisplay || '',
				address_1: property.display_full_street_address || '',
				address_2: property.address_2_normalized || '',
				city: property.city || '',
				state: property.state || '',
				zip: property.zip || ''
			};
		}
		return {
			first_name: this.props.first_name || '',
			last_name: this.props.last_name || '',
			address_1: property.display_full_street_address || '',
			address_2: property.address_2_normalized || '',
			city: property.city || '',
			state: property.state || '',
			zip: property.zip || '',
			email: this.props.email || '',
			phone: this.props.phone || '',
			location: this.props.location || '',
			company: this.props.company || '',
			linkedin_url: this.props.linkedin_url || ''
		};
	}

	_fetchSavedSkipTrace(skipTraceType, onDone) {
		// skipTraceType: 'contact' | 'profile' | 'company'
		if (this.state.saved_loading) return;

		var self = this;
		var identity = this._buildSavedIdentity();

		self.setState({
			saved_loading: true,
			saved_error: null,
			saved_record: null
		});

		function _finish(found, record) {
			if (found && record) {
				self._hydrateFromSavedRecord(record, skipTraceType);
				self.setState({ saved_loading: false, saved_record: record });
				if (typeof onDone === 'function') onDone(true, record);
				return;
			}

			self.setState({ saved_loading: false, saved_record: null });
			if (typeof onDone === 'function') onDone(false, null);
		}

		function _fail(err) {
			var msg = err && err.message ? err.message : 'Failed to load saved skip trace';
			self.setState({
				saved_loading: false,
				saved_error: msg,
				saved_record: null
			});
			if (typeof onDone === 'function') onDone(false, null);
		}

		// For company: backend expects owner_key = preferred ACRIS doc_id
		var ownerKeyPromise =
			skipTraceType === 'company_advanced'
				? self._fetchPreferredAcrisDocForProperty().then(function (payload) {
					return payload ? payload : null;
				})
				: Promise.resolve(null);

		ownerKeyPromise
			.then(function (doc) {
				// If company and we cannot resolve doc_id, we cannot hit "saved" reliably.
				// Treat as not found and let the pipeline run.
				if (skipTraceType === 'company_advanced' && !doc) {
					_finish(false, null);
					return;
				}

				var query = {
					skip_trace_type: skipTraceType,
					identity: identity,
					user: self.props.user
				};

				if (skipTraceType === 'company_advanced') {
					query.doc_id = doc.doc_id;
					query.doc_type = doc.doc_type;
				}

				var userData = {
					url: apiRoot + '/skip/skip-trace-saved/get',
					method: 'post',
					query: query
				};

				_axiosCall(userData)
					.then(function (res) {
						var found = res && res.found ? true : false;
						var record = res && res.record ? res.record : null;
						_finish(found, record);
					})
					.catch(_fail);
			})
			.catch(_fail);
	}


	_hydrateFromSavedRecord(record, skipTraceType) {
		var data = record && record.data ? record.data : {};

		// COMPANY FLOW

		// COMPANY BASIC
		if (skipTraceType === 'company_basic') {
			this.setState({
				hasSearched: true,
				company_mode: 'company_basic',

				company_result: data.extended_data || data.company_result_data || data.company || null,
				company_error: null,
				company_loading: false,
				company_lookup_started: true,

				owner_lookup_started: true,

				// make sure ACRIS is not shown as "started"
				acris_result: null,
				acris_error: null,
				acris_loading: false,
				acris_lookup_started: false,
				acris_status: '',
				acris_progress: null,
				acris_streaming: false,

				owner_loading: false,
			});

			return;
		}

		if (skipTraceType === 'company_advanced') {
			this.setState({
				hasSearched: true,
				company_mode: 'company_advanced',
				// company lookups
				company_result: data.extended_data || data.company_result_data || data.company || null,
				company_error: null,
				company_loading: false,
				company_lookup_started: true,

				// owner lookup (avoid re-running)
				owner_lookup_started: true,

				// ACRIS (owners behind LLC)
				acris_result: data.result || data.acris || null,
				acris_error: null,
				acris_loading: false,
				acris_lookup_started: true,
				acris_status: '',
				acris_progress: null,
				acris_streaming: false,

				owner_loading: false,
			});

			return;
		}

		// PERSON FLOW (existing behavior)
		var mode = (skipTraceType === 'profile') ? 'full' : 'contact';

		this.setState({
			hasSearched: true,
			lookup_mode: mode,

			simple_person: data.simple_person || data.owner || null,
			workplace_records: data.workplace_records || [],
			pdl_result: data.pdl_result || null,

			ai_profile: data.ai_profile || null,
			ai_error: null,
			ai_loading: false,

			simple_loading: false,
			deep_loading: false,
			workplace_loading: false
		});
	}


	_saveSkipTraceToAccount(skipTraceType, payloadToSave) {
		var self = this;

		const { property } = self.props;
		if (property && property.key) {
			payloadToSave.property = property;
			payloadToSave.building = property.building ? property.building : false;
		}
		var creditsUsed = 0;

		if (skipTraceType === 'contact') {
			creditsUsed = this._getRequiredCreditsForContact('contact');
		} else if (skipTraceType === 'profile') {
			var c = this._getRequiredCreditsForContact('contact');
			var p = this._getRequiredCreditsForContact('profile');
			creditsUsed = c + p;
		} else if (skipTraceType === 'company_basic') {
			creditsUsed = this._getRequiredCreditsForContact('company_basic');
		} else if (skipTraceType === 'company_advanced') {
			var b = this._getRequiredCreditsForContact('company_basic');
			var a = this._getRequiredCreditsForContact('company_advanced');
			creditsUsed = b + a;
		}
		var userData = {
			url: apiRoot + '/skip/skip-trace-saved/save',
			method: 'post',
			query: {
				skip_trace_type: skipTraceType,
				identity: self._buildSavedIdentity(),
				data: payloadToSave,
				user: self.props.user,
				credits_used: creditsUsed,
			app_source: 'mp-pipe'
			}
		};

		// return the promise so callers can chain "then"
		return _axiosCall(userData);
	}



	_buildManualAIProfileFromPayload(payload) {
		if (!payload) {
			return null;
		}

		function _valueOrNull(val) {
			if (typeof val === 'undefined' || val === undefined || val === null) return null;
			if (typeof val === 'string' && val.trim() === '') return null;
			return val;
		}



		function _normEmail(e) {
			return _toStr(e).trim().toLowerCase();
		}

		function _digitsOnly(v) {
			return _toStr(v).replace(/\D/g, '');
		}

		function _dedupeStrings(arr) {
			var out = [];
			var seen = {};
			var i;
			for (i = 0; i < arr.length; i++) {
				var s = _toStr(arr[i]).trim();
				if (!s) continue;
				var k = s.toLowerCase();
				if (seen[k]) continue;
				seen[k] = true;
				out.push(s);
			}
			return out;
		}

		function _pushEmail(list, raw) {
			var s = _toStr(raw).trim();
			if (!s) return;
			list.push(s);
		}

		function _pushPhone(list, raw) {
			var s = _toStr(raw).trim();
			if (!s) return;
			list.push(s);
		}




		function _safeArr(a) {
			return Array.isArray(a) ? a : [];
		}

		// Accept multiple input shapes:
		// 1) "slim" payload (core/contact/addresses/work/education/socialProfiles/meta)
		// 2) "raw" payload used by _runProfileAI: { person: simple_person, enhanced_data: pdl_result }
		// 3) saved-record-ish: { simple_person, pdl_result } or { data: { simple_person, pdl_result } }
		var simple =
			payload.person ||
			payload.simple_person ||
			(payload.data && payload.data.simple_person) ||
			null;

		var enhanced =
			payload.enhanced_data ||
			payload.pdl_result ||
			(payload.data && payload.data.pdl_result) ||
			null;

		// If caller already passed slim payload, keep using it as a baseline
		var baseContact = payload.contact || {};
		var baseEmails = _safeArr(baseContact.emails);
		var basePhones = _safeArr(baseContact.phones);
		var baseAddresses = _safeArr(payload.addresses);
		var baseWork = _safeArr(payload.work);
		var baseEducation = _safeArr(payload.education);
		var baseSocial = _safeArr(payload.socialProfiles);
		var baseMeta = payload.meta || {};

		// Collect raw sources (simple_person)
		var spEmails = simple && Array.isArray(simple.emails) ? simple.emails : [];
		var spPhones = simple && Array.isArray(simple.phones) ? simple.phones : [];
		var spAddresses = simple && Array.isArray(simple.addresses) ? simple.addresses : [];

		// -------------------------
		// EMAILS (merge + normalize)
		// -------------------------
		var allEmails = [];

		// From slim payload
		var i;
		for (i = 0; i < baseEmails.length; i++) {
			if (baseEmails[i] && baseEmails[i].email) _pushEmail(allEmails, baseEmails[i].email);
			else if (typeof baseEmails[i] === 'string') _pushEmail(allEmails, baseEmails[i]);
		}

		// From simple_person
		for (i = 0; i < spEmails.length; i++) {
			if (spEmails[i] && spEmails[i].email) _pushEmail(allEmails, spEmails[i].email);
		}

		// From PDL (handle multiple possible shapes)
		if (enhanced) {
			// common: enhanced.emails could be array of strings or objects
			if (Array.isArray(enhanced.emails)) {
				for (i = 0; i < enhanced.emails.length; i++) {
					var pe = enhanced.emails[i];
					if (!pe) continue;
					if (typeof pe === 'string') _pushEmail(allEmails, pe);
					else if (pe.address) _pushEmail(allEmails, pe.address);
					else if (pe.email) _pushEmail(allEmails, pe.email);
				}
			}

			// some PDL shapes: personal_emails / work_emails arrays
			if (Array.isArray(enhanced.personal_emails)) {
				for (i = 0; i < enhanced.personal_emails.length; i++) {
					_pushEmail(allEmails, enhanced.personal_emails[i]);
				}
			}
			if (Array.isArray(enhanced.work_emails)) {
				for (i = 0; i < enhanced.work_emails.length; i++) {
					_pushEmail(allEmails, enhanced.work_emails[i]);
				}
			}
		}

		allEmails = _dedupeStrings(allEmails);

		// -------------------------
		// PHONES (merge + normalize)
		// -------------------------
		var allPhones = [];

		// From slim payload
		for (i = 0; i < basePhones.length; i++) {
			if (!basePhones[i]) continue;
			if (basePhones[i].number) _pushPhone(allPhones, basePhones[i].number);
			else if (basePhones[i].phoneNumber) _pushPhone(allPhones, basePhones[i].phoneNumber);
			else if (typeof basePhones[i] === 'string') _pushPhone(allPhones, basePhones[i]);
		}

		// From simple_person
		for (i = 0; i < spPhones.length; i++) {
			if (spPhones[i] && spPhones[i].number) _pushPhone(allPhones, spPhones[i].number);
		}

		// From PDL (handle multiple possible shapes)
		if (enhanced) {
			if (Array.isArray(enhanced.phone_numbers)) {
				for (i = 0; i < enhanced.phone_numbers.length; i++) {
					var pp = enhanced.phone_numbers[i];
					if (!pp) continue;
					if (typeof pp === 'string') _pushPhone(allPhones, pp);
					else if (pp.number) _pushPhone(allPhones, pp.number);
					else if (pp.phone_number) _pushPhone(allPhones, pp.phone_number);
				}
			}
			if (enhanced.mobile_phone && typeof enhanced.mobile_phone === 'string') {
				_pushPhone(allPhones, enhanced.mobile_phone);
			}
			if (enhanced.primary_phone && typeof enhanced.primary_phone === 'string') {
				_pushPhone(allPhones, enhanced.primary_phone);
			}
		}

		allPhones = _dedupeStrings(allPhones);

		// -------------------------
		// PRIMARY EMAIL selection
		// -------------------------
		var primaryEmail = null;
		var otherEmails = [];

		var preferredEmail = baseMeta && baseMeta.primary_email ? _normEmail(baseMeta.primary_email) : null;

		if (!preferredEmail && enhanced && enhanced.recommended_personal_email && typeof enhanced.recommended_personal_email === 'string') {
			preferredEmail = _normEmail(enhanced.recommended_personal_email);
		}

		if (preferredEmail) {
			for (i = 0; i < allEmails.length; i++) {
				if (_normEmail(allEmails[i]) === preferredEmail) {
					primaryEmail = allEmails[i];
					break;
				}
			}
		}

		// fallback: pick a "validated" from simple_person if present
		if (!primaryEmail && spEmails.length > 0) {
			for (i = 0; i < spEmails.length; i++) {
				var se = spEmails[i];
				if (se && se.email && se.isValidated) {
					primaryEmail = se.email;
					break;
				}
			}
		}

		// fallback: first email
		if (!primaryEmail && allEmails.length > 0) primaryEmail = allEmails[0];

		for (i = 0; i < allEmails.length; i++) {
			if (primaryEmail && allEmails[i] === primaryEmail) continue;
			otherEmails.push(allEmails[i]);
		}
		// keep it readable
		otherEmails = otherEmails.slice(0, 6);

		// -------------------------
		// PRIMARY PHONE selection
		// -------------------------
		var primaryPhone = null;
		var otherPhones = [];

		var preferredPhoneDigits = baseMeta && baseMeta.primary_phone ? _digitsOnly(baseMeta.primary_phone) : null;

		function _scorePhoneObj(p) {
			if (!p) return 0;
			var num = p.number || p.phoneNumber || p.phone_number || p;
			if (!num) return 0;

			var score = 0;
			var type = (p.type || p.phone_type || '').toLowerCase();

			if (type === 'mobile' || type === 'cell' || type === 'wireless') score += 3;
			else if (type === 'landline') score += 1;

			// connected flags show up in simple_person
			if (p.isConnected) score += 2;

			// verified / primary flags show up in some vendor shapes
			if (p.is_primary || p.primary) score += 2;
			if (p.is_validated || p.validated) score += 1;

			return score;
		}

		// Try to match meta primary phone against allPhones
		if (preferredPhoneDigits) {
			for (i = 0; i < allPhones.length; i++) {
				if (_digitsOnly(allPhones[i]) === preferredPhoneDigits) {
					primaryPhone = allPhones[i];
					break;
				}
			}
		}

		// If we do not have it yet, score simple_person phone objects (best signal)
		if (!primaryPhone && spPhones.length > 0) {
			var best = null;
			for (i = 0; i < spPhones.length; i++) {
				var s = _scorePhoneObj(spPhones[i]);
				if (!best || s > _scorePhoneObj(best)) best = spPhones[i];
			}
			if (best) primaryPhone = best.number || best.phoneNumber || best.phone_number || null;
		}

		// fallback: first phone
		if (!primaryPhone && allPhones.length > 0) primaryPhone = allPhones[0];

		for (i = 0; i < allPhones.length; i++) {
			if (primaryPhone && allPhones[i] === primaryPhone) continue;
			otherPhones.push(allPhones[i]);
		}
		otherPhones = otherPhones.slice(0, 6);

		// -------------------------
		// BEST CHANNEL
		// -------------------------
		var bestChannel = null;
		if (primaryPhone) bestChannel = 'Mobile phone';
		else if (primaryEmail) bestChannel = 'Email';

		// -------------------------
		// ADDRESSES (merge)
		// -------------------------
		var addresses = [];

		// Keep slim addresses if provided
		for (i = 0; i < baseAddresses.length; i++) {
			if (baseAddresses[i]) addresses.push(baseAddresses[i]);
		}

		// Convert simple_person addresses into ai_profile-ish shape and append
		for (i = 0; i < spAddresses.length; i++) {
			var a0 = spAddresses[i] || {};
			addresses.push({
				label: 'home',
				street: a0.street || null,
				unit: a0.unit || null,
				city: a0.city || null,
				state: a0.state || null,
				zip: a0.zip || null,
				country: null,
				tag: null,
				firstSeen: a0.firstReportedDate || null,
				lastSeen: a0.lastReportedDate || null
			});
		}

		// Add a PDL “current location” address if it is materially present
		if (enhanced) {
			var locStreet = enhanced.location_street_address || enhanced.job_company_location_street_address || null;
			var locCity = enhanced.location_locality || enhanced.job_company_location_locality || null;
			var locState = enhanced.location_region || enhanced.job_company_location_region || null;
			var locZip = enhanced.location_postal_code || enhanced.job_company_location_postal_code || null;

			// Sometimes these fields can be boolean true (as in your example), so guard for strings
			if (typeof locStreet !== 'string') locStreet = null;
			if (typeof locCity !== 'string') locCity = null;
			if (typeof locState !== 'string') locState = null;
			if (typeof locZip !== 'string') locZip = null;

			if (locStreet || (locCity && locState)) {
				addresses.push({
					label: 'current',
					street: locStreet,
					unit: null,
					city: locCity,
					state: locState,
					zip: locZip,
					country: enhanced.location_country || enhanced.job_company_location_country || null,
					tag: 'pdl',
					firstSeen: null,
					lastSeen: enhanced.location_last_updated || null
				});
			}
		}

		// Normalize + de-dupe addresses by street+unit+city+state+zip
		function _addrKey(a) {
			a = a || {};
			return (
				_toStr(a.street).toLowerCase() + '|' +
				_toStr(a.unit).toLowerCase() + '|' +
				_toStr(a.city).toLowerCase() + '|' +
				_toStr(a.state).toLowerCase() + '|' +
				_toStr(a.zip).toLowerCase()
			).trim();
		}

		var seenAddr = {};
		var normalizedAddresses = [];
		for (i = 0; i < addresses.length; i++) {
			var addr = addresses[i] || {};
			var k = _addrKey(addr);
			if (!k || k === '||||') continue;
			if (seenAddr[k]) continue;
			seenAddr[k] = true;

			normalizedAddresses.push({
				label: _valueOrNull(addr.label),
				street: _valueOrNull(addr.street || addr.addressLine1 || addr.AddressLine1),
				unit: _valueOrNull(addr.unit || addr.addressLine2 || addr.AddressLine2),
				city: _valueOrNull(addr.city || addr.City),
				state: _valueOrNull(addr.state || addr.State),
				zip: _valueOrNull(addr.zip || addr.Zip || addr.postalCode || addr.PostalCode),
				country: _valueOrNull(addr.country),
				tag: _valueOrNull(addr.tag),
				firstSeen: _valueOrNull(addr.firstSeen || addr.firstReportedDate),
				lastSeen: _valueOrNull(addr.lastSeen || addr.lastReportedDate)
			});
		}

		// -------------------------
		// WORK (merge)
		// -------------------------
		var work = [];
		for (i = 0; i < baseWork.length; i++) {
			if (baseWork[i]) work.push(baseWork[i]);
		}

		// From PDL: experience[]
		if (enhanced && Array.isArray(enhanced.experience)) {
			for (i = 0; i < enhanced.experience.length; i++) {
				var ex = enhanced.experience[i] || {};
				var comp = ex.company || {};
				var titleObj = ex.title || {};
				var locNames = Array.isArray(ex.location_names) ? ex.location_names : [];
				var locStr = '';

				if (locNames.length > 0) locStr = locNames[0];
				else if (comp && comp.location && comp.location.locality && comp.location.region) locStr = comp.location.locality + ', ' + comp.location.region;

				work.push({
					company: comp.name || null,
					title: titleObj.name || null,
					industry: comp.industry || null,
					level: (titleObj.levels && titleObj.levels.length > 0) ? titleObj.levels[0] : null,
					isCurrent: ex.end_date ? false : true,
					location: locStr || null,
					startDate: ex.start_date || null,
					endDate: ex.end_date || null
				});
			}
		} else if (enhanced) {
			// fallback: top-level job fields if experience is missing
			if (enhanced.job_company_name || enhanced.job_title) {
				var jobLoc = '';
				if (enhanced.job_company_location_locality && enhanced.job_company_location_region) {
					jobLoc = enhanced.job_company_location_locality + ', ' + enhanced.job_company_location_region;
				} else if (enhanced.job_company_location_name && typeof enhanced.job_company_location_name === 'string') {
					jobLoc = enhanced.job_company_location_name;
				}
				work.push({
					company: enhanced.job_company_name || null,
					title: enhanced.job_title || null,
					industry: enhanced.job_company_industry || enhanced.industry || null,
					level: (Array.isArray(enhanced.job_title_levels) && enhanced.job_title_levels.length > 0) ? enhanced.job_title_levels[0] : null,
					isCurrent: true,
					location: jobLoc || null,
					startDate: enhanced.job_start_date || null,
					endDate: null
				});
			}
		}

		// Normalize work and lightly de-dupe (company+title+start+end)
		function _workKey(w) {
			w = w || {};
			return (
				_toStr(w.company).toLowerCase() + '|' +
				_toStr(w.title).toLowerCase() + '|' +
				_toStr(w.startDate).toLowerCase() + '|' +
				_toStr(w.endDate).toLowerCase()
			).trim();
		}

		var seenWork = {};
		var normalizedWork = [];
		for (i = 0; i < work.length; i++) {
			var wk = work[i] || {};
			var wkKey = _workKey(wk);
			if (!wkKey || wkKey === '|||') continue;
			if (seenWork[wkKey]) continue;
			seenWork[wkKey] = true;

			normalizedWork.push({
				company: _valueOrNull(wk.company),
				title: _valueOrNull(wk.title),
				industry: _valueOrNull(wk.industry),
				level: _valueOrNull(wk.level),
				isCurrent: !!wk.isCurrent,
				location: _valueOrNull(wk.location),
				startDate: _valueOrNull(wk.startDate),
				endDate: _valueOrNull(wk.endDate)
			});
		}

		// Put current roles first
		normalizedWork.sort(function (a, b) {
			if (a.isCurrent && !b.isCurrent) return -1;
			if (!a.isCurrent && b.isCurrent) return 1;
			return 0;
		});

		// -------------------------
		// EDUCATION (merge)
		// -------------------------
		var education = [];
		for (i = 0; i < baseEducation.length; i++) {
			if (baseEducation[i]) education.push(baseEducation[i]);
		}

		if (enhanced && Array.isArray(enhanced.education)) {
			for (i = 0; i < enhanced.education.length; i++) {
				var ed0 = enhanced.education[i] || {};
				var school = ed0.school || {};
				var degrees = Array.isArray(ed0.degrees) ? ed0.degrees : [];
				var majors = Array.isArray(ed0.majors) ? ed0.majors : [];

				education.push({
					school: school.name || null,
					degree: degrees.length > 0 ? degrees[0] : null,
					field: majors.length > 0 ? majors[0] : null,
					startYear: ed0.start_date ? String(ed0.start_date).slice(0, 4) : null,
					endYear: ed0.end_date ? String(ed0.end_date).slice(0, 4) : null
				});
			}
		}

		var normalizedEducation = [];
		for (i = 0; i < education.length; i++) {
			var ed = education[i] || {};
			normalizedEducation.push({
				school: _valueOrNull(ed.school),
				degree: _valueOrNull(ed.degree),
				field: _valueOrNull(ed.field),
				startYear: _valueOrNull(ed.startYear),
				endYear: _valueOrNull(ed.endYear)
			});
		}

		// -------------------------
		// SOCIAL (merge)
		// -------------------------
		var socialProfiles = [];
		for (i = 0; i < baseSocial.length; i++) {
			if (baseSocial[i]) socialProfiles.push(baseSocial[i]);
		}

		if (enhanced && Array.isArray(enhanced.profiles)) {
			for (i = 0; i < enhanced.profiles.length; i++) {
				var sp = enhanced.profiles[i] || {};
				socialProfiles.push({
					network: sp.network || null,
					url: sp.url ? _ensureHttp(sp.url) : null,
					handle: sp.username || null
				});
			}
		} else if (enhanced) {
			// fallback: top-level profile urls (common in PDL)
			if (enhanced.linkedin_url) {
				socialProfiles.push({ network: 'linkedin', url: _ensureHttp(enhanced.linkedin_url), handle: enhanced.linkedin_username || null });
			}
			if (enhanced.facebook_url) {
				socialProfiles.push({ network: 'facebook', url: _ensureHttp(enhanced.facebook_url), handle: enhanced.facebook_username || null });
			}
			if (enhanced.twitter_url) {
				socialProfiles.push({ network: 'twitter', url: _ensureHttp(enhanced.twitter_url), handle: enhanced.twitter_username || null });
			}
		}

		// normalize + dedupe social by network+url
		var seenSocial = {};
		var normalizedSocial = [];
		for (i = 0; i < socialProfiles.length; i++) {
			var so = socialProfiles[i] || {};
			var net = _toStr(so.network).toLowerCase();
			var url = _toStr(so.url);
			var key = net + '|' + url.toLowerCase();
			if (!net && !url) continue;
			if (seenSocial[key]) continue;
			seenSocial[key] = true;

			normalizedSocial.push({
				network: _valueOrNull(so.network),
				url: _valueOrNull(so.url),
				handle: _valueOrNull(so.handle)
			});
		}

		// -------------------------
		// NAME + AGE
		// -------------------------
		var nameObj = (payload.core && payload.core.name) ? payload.core.name : (simple && simple.name ? simple.name : {});
		var fullName =
			((_toStr(nameObj.firstName) + ' ' + _toStr(nameObj.lastName)).replace(/\s+/g, ' ').trim()) ||
			(enhanced && enhanced.full_name ? enhanced.full_name : '');

		var age = null;
		if (payload.core && payload.core.age) age = payload.core.age;
		else if (simple && simple.age) age = simple.age;

		// -------------------------
		// SUMMARY (more robust, still deterministic)
		// -------------------------
		var summaryParts = [];

		if (fullName) summaryParts.push(fullName + (age ? ' is ' + age + ' years old.' : ' has a structured contact profile.'));
		else summaryParts.push('Structured contact profile based on skip-trace and enrichment data.');

		// Location sentence (prefer the most recent address)
		if (normalizedAddresses.length > 0) {
			var a1 = normalizedAddresses[0];
			if (a1 && a1.city && a1.state) {
				summaryParts.push('Recent address history includes ' + a1.city + ', ' + a1.state + '.');
			}
		}

		// Work sentence (current role)
		if (normalizedWork.length > 0) {
			var cw = normalizedWork[0];
			if (cw && (cw.title || cw.company)) {
				var workLine = '';
				if (cw.title && cw.company) workLine = cw.title + ' at ' + cw.company;
				else workLine = (cw.title || cw.company);
				if (cw.industry) workLine += ' (' + cw.industry + ')';
				summaryParts.push('Work history includes ' + workLine + '.');
			}
		} else if (enhanced && enhanced.industry && typeof enhanced.industry === 'string') {
			summaryParts.push('Industry: ' + enhanced.industry + '.');
		}

		// Contact sentence
		if (primaryPhone || primaryEmail) {
			var cBits = [];
			if (primaryPhone) cBits.push('primary phone ' + primaryPhone);
			if (primaryEmail) cBits.push('primary email ' + primaryEmail);
			summaryParts.push('Best starting point is ' + cBits.join(' and ') + '.');
		}

		// Social sentence (top 1-2)
		if (normalizedSocial.length > 0) {
			var nets = [];
			for (i = 0; i < normalizedSocial.length; i++) {
				if (normalizedSocial[i] && normalizedSocial[i].network) nets.push(normalizedSocial[i].network);
				if (nets.length >= 3) break;
			}
			nets = _dedupeStrings(nets);
			if (nets.length > 0) summaryParts.push('Social profiles appear on ' + nets.join(', ') + '.');
		}

		// Skills sentence (PDL)
		if (enhanced && Array.isArray(enhanced.skills) && enhanced.skills.length > 0) {
			var topSkills = [];
			for (i = 0; i < enhanced.skills.length; i++) {
				if (enhanced.skills[i]) topSkills.push(enhanced.skills[i]);
				if (topSkills.length >= 6) break;
			}
			topSkills = _dedupeStrings(topSkills);
			if (topSkills.length > 0) summaryParts.push('Skills include ' + topSkills.slice(0, 5).join(', ') + '.');
		}

		var summary = summaryParts.join(' ');

		// -------------------------
		// META
		// -------------------------
		var nowIso = new Date().toISOString();

		var aiVersion =
			(baseMeta && baseMeta.aiVersion) ? baseMeta.aiVersion :
				(enhanced && enhanced.dataset_version ? enhanced.dataset_version : null);

		return {
			summary: summary,
			contact: {
				primaryEmail: _valueOrNull(primaryEmail),
				primaryPhone: _valueOrNull(primaryPhone),
				otherEmails: otherEmails,
				otherPhones: otherPhones,
				bestChannel: _valueOrNull(bestChannel),
				bestTimeToReach: null
			},
			addresses: normalizedAddresses.slice(0, 10),
			work: normalizedWork.slice(0, 10),
			education: normalizedEducation.slice(0, 10),
			socialProfiles: normalizedSocial.slice(0, 12),
			notes: [],
			meta: {
				aiVersion: aiVersion ? String(aiVersion) + ' + manual' : 'manual',
				generatedAt: (baseMeta && baseMeta.generatedAt) ? baseMeta.generatedAt : nowIso
			}
		};
	}




	_getInitialsFromPerson() {
		var first = this.props.first_name || '';
		var last = this.props.last_name || '';
		var initial1 = first && first.length > 0 ? first.charAt(0).toUpperCase() : '';
		var initial2 = last && last.length > 0 ? last.charAt(0).toUpperCase() : '';
		var combined = (initial1 + initial2).trim();

		if (!combined && this.props.triggerDisplay) {
			var parts = String(this.props.triggerDisplay).split(' ');
			if (parts.length > 0 && parts[0]) initial1 = parts[0].charAt(0).toUpperCase();
			if (parts.length > 1 && parts[1]) initial2 = parts[1].charAt(0).toUpperCase();
			combined = (initial1 + initial2).trim();
		}

		return combined || '?';
	}

	_inferLanguagesFromAI(ai) {
		if (!ai) return [];
		var meta = ai.meta || {};
		// Prefer explicit list if present
		if (meta.languages && meta.languages.length > 0) {
			return meta.languages;
		}
		// Fallback single language string
		if (meta.language) {
			return [meta.language];
		}
		return [];
	}

	_resetPersonState() {
		return {
			simple_loading: false,
			simple_error: null,
			simple_person: null,

			deep_loading: false,
			deep_error: null,
			deep_persons: [],

			workplace_loading: false,
			workplace_error: null,
			workplace_records: [],
			hasSearched: false,
			lookup_mode: null,

			ai_loading: false,
			ai_error: null,
			ai_profile: null,

			pdl_result: null,
			pdl_loading: false,

			// saved lookup state
			saved_loading: false,
			saved_error: null,
			saved_record: null,
			active_request_id: null,
			saved_this_request: false
		};
	}

	_buildProfileAIPayload() {
		var person = this.state.simple_person || null;
		var workplace = this.state.workplace_records || [];

		if (!person && (!workplace || !workplace.length)) {
			return null;
		}

		function _safeArray(arr) {
			return Array.isArray(arr) ? arr : [];
		}

		function _dedupeStrings(list) {
			var out = [];
			var seen = {};
			for (var i = 0; i < list.length; i++) {
				var val = list[i];
				if (!val) {
					continue;
				}
				var key = String(val).toLowerCase();
				if (!seen[key]) {
					seen[key] = true;
					out.push(val);
				}
			}
			return out;
		}

		function _dedupePhones(list) {
			var out = [];
			var seen = {};
			for (var i = 0; i < list.length; i++) {
				var p = list[i];
				if (!p || !p.number) {
					continue;
				}
				var key = String(p.number).replace(/\D/g, "") + "|" + (p.type || "");
				if (!seen[key]) {
					seen[key] = true;
					out.push(p);
				}
			}
			return out;
		}

		// PERSON-LEVEL FIELDS
		function _extractPersonName(personObj) {
			if (!personObj || !personObj.name) {
				return { firstName: null, middleName: null, lastName: null };
			}
			return {
				firstName: personObj.name.firstName || null,
				middleName: personObj.name.middleName || null,
				lastName: personObj.name.lastName || null
			};
		}

		function _extractPersonEmails(personObj) {
			var result = [];
			if (!personObj || !personObj.emails) {
				return result;
			}
			var list = _safeArray(personObj.emails);
			for (var i = 0; i < list.length; i++) {
				var e = list[i];
				if (e && e.email) {
					result.push({
						email: e.email,
						isBusiness: !!e.isBusiness,
						isValidated: !!e.isValidated,
						source: "person"
					});
				}
			}
			return result;
		}

		function _extractPersonPhones(personObj) {
			var result = [];
			if (!personObj || !personObj.phones) {
				return result;
			}
			var list = _safeArray(personObj.phones);
			for (var i = 0; i < list.length; i++) {
				var p = list[i];
				if (p && p.number) {
					result.push({
						number: p.number,
						type: p.type || null,
						isConnected: !!p.isConnected,
						firstSeen: p.firstReportedDate || null,
						lastSeen: p.lastReportedDate || null,
						source: "person"
					});
				}
			}
			return result;
		}

		function _extractPersonAddresses(personObj) {
			var result = [];
			if (!personObj || !personObj.addresses) {
				return result;
			}
			var list = _safeArray(personObj.addresses);
			for (var i = 0; i < list.length; i++) {
				var a = list[i];
				if (!a) {
					continue;
				}
				if (!a.street && !a.city && !a.state && !a.zip) {
					continue;
				}
				result.push({
					label: "home",
					street: a.street || null,
					unit: a.unit || null,
					city: a.city || null,
					state: a.state || null,
					zip: a.zip || null,
					country: null,
					tag: null,
					firstSeen: a.firstReportedDate || null,
					lastSeen: a.lastReportedDate || null,
					source: "person"
				});
			}
			return result;
		}

		// WORKPLACE-LEVEL FIELDS
		function _collectWorkplaceEmails(wr) {
			var result = [];
			if (!wr) {
				return result;
			}

			var tahoe = wr.tahoeAppend;
			if (tahoe && tahoe.emails && tahoe.emails.length) {
				var tEmails = _safeArray(tahoe.emails);
				for (var i = 0; i < tEmails.length; i++) {
					var em = tEmails[i];
					if (em) {
						result.push({
							email: em,
							isBusiness: true,
							isValidated: false,
							source: "workplace"
						});
					}
				}
			}

			var emailAddresses = _safeArray(wr.emailAddresses);
			for (var j = 0; j < emailAddresses.length; j++) {
				var em2 = emailAddresses[j];
				if (em2) {
					result.push({
						email: em2,
						isBusiness: true,
						isValidated: false,
						source: "workplace"
					});
				}
			}

			return result;
		}

		function _collectWorkplacePhones(wr) {
			var result = [];
			if (!wr) {
				return result;
			}

			var tahoe = wr.tahoeAppend;
			function _push(num, type) {
				if (!num) {
					return;
				}
				result.push({
					number: num,
					type: type || null,
					isConnected: null,
					firstSeen: null,
					lastSeen: null,
					source: "workplace"
				});
			}

			if (tahoe) {
				var mobile = _safeArray(tahoe.mobilePhones);
				for (var i = 0; i < mobile.length; i++) {
					_push(mobile[i], "mobile");
				}
				var land = _safeArray(tahoe.landlinePhones);
				for (var j = 0; j < land.length; j++) {
					_push(land[j], "landline");
				}
			}

			var phoneNumbers = _safeArray(wr.phoneNumbers);
			for (var k = 0; k < phoneNumbers.length; k++) {
				_push(phoneNumbers[k], null);
			}

			var phoneTypes = wr.phoneTypes || {};
			if (phoneTypes.desk) {
				_push(phoneTypes.desk, "desk");
			}
			if (phoneTypes.corporate) {
				_push(phoneTypes.corporate, "corporate");
			}
			if (phoneTypes.cell) {
				_push(phoneTypes.cell, "mobile");
			}

			return result;
		}

		function _extractWorkplaceAddresses(wr) {
			var result = [];
			if (!wr || !wr.addresses) {
				return result;
			}
			var list = _safeArray(wr.addresses);
			for (var i = 0; i < list.length; i++) {
				var a = list[i];
				if (!a) {
					continue;
				}

				var street = a.addressLine1 || a.fullAddress || null;
				if (!street && !a.city && !a.state && !a.zip && !a.zip4) {
					continue;
				}

				result.push({
					label: "work",
					street: street,
					unit: null,
					city: a.city || null,
					state: a.state || null,
					zip: a.zip || a.zip4 || null,
					country: null,
					tag: null,
					firstSeen: null,
					lastSeen: null,
					source: "workplace"
				});
			}
			return result;
		}

		function _extractWorkFromCurrentEmployment(wr) {
			var result = [];
			if (!wr || !wr.currentEmployment) {
				return result;
			}
			var list = _safeArray(wr.currentEmployment);
			for (var i = 0; i < list.length; i++) {
				var e = list[i];
				if (!e) {
					continue;
				}
				var loc = null;
				if (e.city || e.state) {
					loc = (e.city || "") + (e.city && e.state ? ", " : "") + (e.state || "");
				} else if (e.headquarters) {
					loc = e.headquarters;
				}

				result.push({
					company: e.employer || null,
					title: e.jobTitle || null,
					industry: e.industry || null,
					level: e.level || null,
					isCurrent: true,
					location: loc,
					startDate: e.startDate || null,
					endDate: e.endDate || null
				});
			}
			return result;
		}

		function _extractWorkFromHistory(wr) {
			var result = [];
			if (!wr || !wr.workExperience) {
				return result;
			}
			var list = _safeArray(wr.workExperience);
			for (var i = 0; i < list.length; i++) {
				var e = list[i];
				if (!e) {
					continue;
				}

				var companyObj = e.company || {};
				var loc = companyObj.companyHeadQuarters || null;

				result.push({
					company: e.expCompany || null,
					title: e.expJobTitle || null,
					industry: companyObj.companyIndustry || null,
					level: null,
					isCurrent: false,
					location: loc,
					startDate: null,
					endDate: null
				});
			}
			return result;
		}

		function _extractEducation(wr) {
			var result = [];
			if (!wr || !wr.education) {
				return result;
			}
			var list = _safeArray(wr.education);
			for (var i = 0; i < list.length; i++) {
				var e = list[i];
				if (!e) {
					continue;
				}
				result.push({
					school: e.school || null,
					degree: e.degree || null,
					field: e.major || null,
					startYear: e.startDate || null,
					endYear: e.endDate || null
				});
			}
			return result;
		}

		function _extractSocialProfiles(wr) {
			var result = [];
			if (!wr || !wr.personUrls) {
				return result;
			}
			var urls = _safeArray(wr.personUrls);
			for (var i = 0; i < urls.length; i++) {
				var url = urls[i];
				if (!url) {
					continue;
				}

				var network = null;
				var lower = url.toLowerCase();
				if (lower.indexOf("linkedin.com") !== -1) {
					network = "LinkedIn";
				} else if (lower.indexOf("facebook.com") !== -1) {
					network = "Facebook";
				} else if (lower.indexOf("twitter.com") !== -1 || lower.indexOf("x.com") !== -1) {
					network = "Twitter";
				} else if (lower.indexOf("instagram.com") !== -1) {
					network = "Instagram";
				}

				result.push({
					network: network,
					url: url,
					handle: null
				});
			}
			return result;
		}

		// DISPLAY NAME / PRIMARYS FOR META
		var nameObj = person && person.name ? person.name : {};
		var first = this.props.first_name || nameObj.firstName || "";
		var last = this.props.last_name || nameObj.lastName || "";
		var displayName = (first + " " + last).replace(/\s+/g, " ").trim();

		var primaryEmail = "";
		if (person && person.emails && person.emails.length > 0) {
			var e0 = person.emails[0];
			if (e0 && e0.email) {
				primaryEmail = e0.email;
			}
		}

		var primaryPhone = "";
		if (person && person.phones && person.phones.length > 0) {
			var p0 = person.phones[0];
			if (p0 && p0.number) {
				primaryPhone = p0.number;
			}
		}

		// BUILD AGGREGATED, TRIMMED PAYLOAD
		var name = _extractPersonName(person);
		var age = person && person.age ? person.age : null;

		var allEmails = [];
		var allPhones = [];
		var allAddresses = [];
		var allWork = [];
		var allEducation = [];
		var allSocialProfiles = [];

		// Person-level
		allEmails = allEmails.concat(_extractPersonEmails(person));
		allPhones = allPhones.concat(_extractPersonPhones(person));
		allAddresses = allAddresses.concat(_extractPersonAddresses(person));

		// Workplace-level from each record
		var wrList = _safeArray(workplace);
		for (var w = 0; w < wrList.length; w++) {
			var wr = wrList[w];
			if (!wr) {
				continue;
			}

			allEmails = allEmails.concat(_collectWorkplaceEmails(wr));
			allPhones = allPhones.concat(_collectWorkplacePhones(wr));
			allAddresses = allAddresses.concat(_extractWorkplaceAddresses(wr));
			allWork = allWork.concat(_extractWorkFromCurrentEmployment(wr));
			allWork = allWork.concat(_extractWorkFromHistory(wr));
			allEducation = allEducation.concat(_extractEducation(wr));
			allSocialProfiles = allSocialProfiles.concat(_extractSocialProfiles(wr));
		}

		// Deduplicate basic lists
		var emailStrings = [];
		for (var emIdx = 0; emIdx < allEmails.length; emIdx++) {
			emailStrings.push(allEmails[emIdx].email);
		}
		var dedupEmailStrings = _dedupeStrings(emailStrings);

		// Keep only one object per unique email
		var dedupEmails = [];
		var emailSeen = {};
		for (var iEm = 0; iEm < allEmails.length; iEm++) {
			var emailObj = allEmails[iEm];
			if (!emailObj || !emailObj.email) {
				continue;
			}
			var keyEm = emailObj.email.toLowerCase();
			if (!emailSeen[keyEm] && dedupEmailStrings.indexOf(emailObj.email) !== -1) {
				emailSeen[keyEm] = true;
				dedupEmails.push(emailObj);
			}
		}

		var dedupPhones = _dedupePhones(allPhones);

		// Addresses are usually smaller. Keep as-is but already trimmed.
		var payload = {
			core: {
				name: name,
				age: age
			},
			contact: {
				emails: dedupEmails,
				phones: dedupPhones
			},
			addresses: allAddresses,
			work: allWork,
			education: allEducation,
			socialProfiles: allSocialProfiles,
			meta: {
				display_name: displayName || "",
				primary_email: primaryEmail || "",
				primary_phone: primaryPhone || "",
				source: "skip-trace-simple + workplace"
			}
		};

		return payload;
	}


	_runProfileAI() {
		var payload;

		if (this.state.pdl_result && !this.state.workplace_records) {
			payload = {
				person: this.state.simple_person,
				enhanced_data: this.state.pdl_result
			}
		} else {
			payload = this._buildProfileAIPayload();
			if (this.state.pdl_result) {
				payload['enhanced_data'] = this.state.pdl_result;
			}
		}
		console.log(payload)
		if (!payload) return;

		var self = this;

		var aiUrl = this.props.aiApiUrl || (apiRoot + '/ai/chat');
		var model = this.props.openAIModel || 'gpt-4.1-nano';
		const SKIP_AI = false;
		if (SKIP_AI) {
			var manualProfile = self._buildManualAIProfileFromPayload(payload);
			self.setState({
				ai_profile: manualProfile,
				ai_loading: false

			});
			// 	if (self.state.lookup_mode !== 'full') return;
			// 	
			// 	if (self.state.saved_this_request) return;
			// 	
			// 	self.setState({ saved_this_request: true });	
			//   self._saveSkipTraceToAccount('profile', {
			// 	// everything “as a whole”
			// 	simple_person: self.state.simple_person,
			// 	workplace_records: self.state.workplace_records,
			// 	pdl_result: self.state.pdl_result,
			// 	ai_profile: manualProfile,
			// 
			// 	// optional: keep what you sent to AI (debuggable)
			// 	// ai_input_payload: payload
			//   }).then(function () {
			// 	return self._deductCreditsAfterSave('profile');
			// 	
			// 	
			// 	
			//   })
			//   .catch(function (err) {
			// 	console.log('save skip trace error:', err && err.message ? err.message : err);
			//   });
			//   
			//   return false;
		}

		var displayName =
			payload.meta && payload.meta.display_name
				? payload.meta.display_name
				: '(unknown)';

		var prompt =
			'You are given person-level contact, address, work, education, and workplace enrichment data ' +
			'collected from skip-trace and similar services.\n\n' +
			'Turn this noisy input into a clean JSON profile for a real estate professional who wants to contact and understand the owner.\n\n' +
			'Return a single JSON object with this exact structure:\n\n' +
			'{\n' +
			'  "summary": string,                         // 4-6 sentences about who this person is and how best to reach them,\n' +
			'  "contact": {\n' +
			'    "primaryEmail": string | null,\n' +
			'    "primaryPhone": string | null,\n' +
			'    "otherEmails": string[],\n' +
			'    "otherPhones": string[],\n' +
			'    "bestChannel": string | null,\n' +
			'    "bestTimeToReach": string | null\n' +
			'  },\n' +
			'  "addresses": [\n' +
			'    {\n' +
			'      "label": string | null,\n' +
			'      "street": string | null,\n' +
			'      "unit": string | null,\n' +
			'      "city": string | null,\n' +
			'      "state": string | null,\n' +
			'      "zip": string | null,\n' +
			'      "country": string | null,\n' +
			'      "tag": string | null,\n' +
			'      "firstSeen": string | null,\n' +
			'      "lastSeen": string | null\n' +
			'    }\n' +
			'  ],\n' +
			'  "work": [\n' +
			'    {\n' +
			'      "company": string | null,\n' +
			'      "title": string | null,\n' +
			'      "industry": string | null,\n' +
			'      "level": string | null,\n' +
			'      "isCurrent": boolean,\n' +
			'      "location": string | null,\n' +
			'      "startDate": string | null,\n' +
			'      "endDate": string | null\n' +
			'    }\n' +
			'  ],\n' +
			'  "education": [\n' +
			'    {\n' +
			'      "school": string | null,\n' +
			'      "degree": string | null,\n' +
			'      "field": string | null,\n' +
			'      "startYear": string | null,\n' +
			'      "endYear": string | null\n' +
			'    }\n' +
			'  ],\n' +
			'  "socialProfiles": [\n' +
			'    {\n' +
			'      "network": string | null,\n' +
			'      "url": string | null,\n' +
			'      "handle": string | null\n' +
			'    }\n' +
			'  ],\n' +
			'  "notes": string[],\n' +
			'  "meta": {\n' +
			'    "aiVersion": string | null,\n' +
			'    "generatedAt": string | null\n' +
			'  }\n' +
			'}\n\n' +
			'Important rules:\n' +
			'- Data may contain incorrect matches, filter out obviously incorrect information.\n' +
			'- enhanced_data.experience contains current and previous work history.  Include history of workplace and experience.\n' +
			'- Deduplicate obvious duplicates.\n' +
			'- Remove duplicate addresses, if two or more addresses have the same street address keep the one with unit number or the last reported.\n' +
			'- Prefer recent and higher quality fields when choosing primaries.\n' +
			'- Use null instead of empty strings when values are clearly unknown.\n' +
			'- Keep text concise and readable.\n' +
			'- Return only valid JSON. No comments and no extra text.\n\n' +
			'Person display name: ' + displayName + '\n\n' +
			'Raw profile data:\n' + JSON.stringify(payload);

		var queryData = {
			messages: [
				{
					role: 'system',
					content:
						'You are a contact enrichment assistant that turns noisy skip-trace and workplace data into clean JSON profiles and short natural-language summaries for real estate professionals.'
				},
				{
					role: 'user',
					content: prompt
				}
			],
			model: model,
			response_format: { type: 'json_object' }
		};

		var axiosData = {
			url: aiUrl,
			method: 'post',
			query: queryData
		};

		//this.setState({ ai_loading: true, ai_error: null });

		_axiosCall(axiosData)
			.then(function (res) {
				var content = null;

				if (
					res &&
					res.choices &&
					res.choices[0] &&
					res.choices[0].message &&
					res.choices[0].message.content
				) {
					content = res.choices[0].message.content;
				} else if (
					res &&
					res.data &&
					res.data.choices &&
					res.data.choices[0] &&
					res.data.choices[0].message &&
					res.data.choices[0].message.content
				) {
					content = res.data.choices[0].message.content;
				}

				if (!content) {
					self.setState({
						ai_error: 'Empty AI response',
						ai_loading: false
					});
					return;
				}

				var parsed = null;
				try {
					parsed = typeof content === 'string' ? JSON.parse(content) : content;
				} catch (e) {
					self.setState({
						ai_error: 'Failed to parse AI JSON',
						ai_loading: false
					});
					return;
				}

				self.setState({
					ai_profile: parsed,
					ai_loading: false
				}, function () {
					// Only save for the active full-profile request, and only once
					if (self.state.lookup_mode !== 'full') return;

					if (self.state.saved_this_request) return;

					self.setState({ saved_this_request: true });

					self._saveSkipTraceToAccount('profile', {
						// everything “as a whole”
						simple_person: self.state.simple_person,
						workplace_records: self.state.workplace_records,
						pdl_result: self.state.pdl_result,
						ai_profile: parsed,

						// optional: keep what you sent to AI (debuggable)
						// ai_input_payload: payload
					}).then(function () {
						return self._deductCreditsAfterSave('profile');
					})
						.catch(function (err) {
							console.log('save skip trace error:', err && err.message ? err.message : err);
						});
				});

			})
			.catch(function (err) {
				var msg = err && err.message ? err.message : 'Failed to generate AI profile';
				self.setState({
					ai_error: msg,
					ai_loading: false
				});
			});
	}


	_renderAISummary() {
		var ai = this.state.ai_profile;
		if (!ai || !ai.summary) return null;

		return (
			<div className="skiptrace-section skiptrace-section--ai-summary" style={{ marginTop: 16 }}>
				<div className="skiptrace-section-title">
					AI Summary
				</div>
				<p style={{ marginBottom: 0 }}>{ai.summary}</p>
			</div>
		);
	}




	// How many premium credits the user currently has
	_getUserPremiumCredits(user) {
		if (!user) return 0;
		if (typeof user.premiumCredits === 'number') return user.premiumCredits;
		if (user.profile && typeof user.profile.premiumCredits === 'number') {
			return user.profile.premiumCredits;
		}
		return 0;
	}

	// How many credits the skip-trace service needs by id
	_getRequiredCreditsForContact(creditType) {
		var fallback = 1;
		if (!premiumCreditServices || !premiumCreditServices.length) return fallback;

		var i;
		for (i = 0; i < premiumCreditServices.length; i++) {
			var svc = premiumCreditServices[i];
			if (svc && svc.id === creditType && typeof svc.creditsRequired === 'number') {
				return svc.creditsRequired;
			}
		}
		return fallback;
	}

	_openPremiumCreditsModal() {
		if (this.premiumCreditsModal &&
			typeof this.premiumCreditsModal.toggle === 'function') {
			this.premiumCreditsModal.toggle();
		}
	}

	// Generic credit checker for mode actions
	_ensureCredits(required, pendingMode, onSuccess) {
		var user = this.props.user || {};
		var available = this._getUserPremiumCredits(user);
		if (available < required) {
			this.setState(
				{ pendingOpenAfterPurchase: pendingMode },
				this._openPremiumCreditsModal
			);
			return;
		}
		if (typeof onSuccess === 'function') onSuccess();
	}

	_handleStartContactOnly() {
		var contactCredits = this._getRequiredCreditsForContact('contact');
		var self = this;
		this._ensureCredits(contactCredits, 'contact', function () {
			self._startContactOnlyInternal();
		});
	}

	_handleStartFullProfile() {
		var contactCredits = this._getRequiredCreditsForContact('contact');
		var profileCredits = this._getRequiredCreditsForContact('profile');
		var total = contactCredits + profileCredits;
		var self = this;
		this._ensureCredits(total, 'full', function () {
			self._startFullProfileInternal();
		});
	}

	_startContactOnlyInternal() {
		var self = this;
		var rid = this._newRequestId();

		this.setState({
			lookup_mode: 'contact',
			active_request_id: rid,
			saved_this_request: false
		}, function () {
			// if you already implemented saved lookup fetch, call it here first
			self._fetchSavedSkipTrace('contact', function (found) { if (found) return; self._runSimple(false, rid); });

		});
	}


	_startFullProfileInternal() {
		var self = this;

		this.setState({ lookup_mode: 'full' }, function () {
			self._fetchSavedSkipTrace('profile', function (found) {
				if (found) return; // UI is hydrated with saved data
				self._runSimple(true);
			});
		});
	}


	// Called when user clicks the trigger link/icon
	_handleTriggerClick(e, isCompany) {
		if (e && e.preventDefault) {
			e.preventDefault();
			e.stopPropagation();
		}

		// Track skip trace modal open event
		var eventSubType = isCompany ? 'company' : 'individual';
		Publisher.publish('track-mp.skiptraceModalOpen.' + eventSubType, {
			user: this.props.user,
			property: this.props.property,
			customData: {
				triggerDisplay: this.props.triggerDisplay,
				isCompany: isCompany
			}
		});

		var self = this;
		this.setState({ pendingOpenAfterPurchase: null }, function () {
			self.toggle();
		});
	}


	// Called after successful premium purchase
	_handlePremiumPurchaseConfirm(selectedPack, done) {
		var self = this;

		if (done && typeof done === 'function') {
			done();
		}

		var mode = this.state.pendingOpenAfterPurchase;
		if (mode === 'contact') {
			this.setState({ pendingOpenAfterPurchase: null }, function () {
				self._startContactOnlyInternal();
			});
		} else if (mode === 'full') {
			this.setState({ pendingOpenAfterPurchase: null }, function () {
				self._startFullProfileInternal();
			});
		} else {
			this.setState({ pendingOpenAfterPurchase: null });
		}
	}


	componentDidUpdate(prevProps, prevState) {
		var wasOpen = typeof prevProps.isOpen === 'boolean' ? prevProps.isOpen : prevState.modal;
		var isOpen = typeof this.props.isOpen === 'boolean' ? this.props.isOpen : this.state.modal;
		var isCompany = isCompanyName(this.props.triggerDisplay);

		// Opened
		if (!wasOpen && isOpen) {
			var self = this;

			var doHydrate = function () {
				if (self.props.saved_record && self.props.saved_record.data) {
					var skipType = self.props.saved_skip_trace_type || (isCompany ? 'company_advanced' : 'contact');
					self._hydrateFromSavedRecord(self.props.saved_record, skipType);
				}
			};

			if (isCompany && typeof this._resetCompanyState === 'function') {
				this.setState(this._resetCompanyState(), doHydrate);
				return;
			}

			if (!isCompany && typeof this._resetPersonState === 'function') {
				this.setState(this._resetPersonState(), doHydrate);
				return;
			}

			doHydrate();
		}

	}




	// Centralized open handler that decides the path
	_openFlow() {
		console.log("open flow")
		var isCompany = isCompanyName(this.props.triggerDisplay);
		if (isCompany) {
			this._initCompanyFlow();
		} else {
			this._initPersonFlow();
		}
	}

	toggle(e) {
		if (e && e.preventDefault) { e.preventDefault(); e.stopPropagation(); }

		var isControlled = typeof this.props.isOpen === 'boolean';
		var isOpen = isControlled ? this.props.isOpen : this.state.modal;

		var isCompany = isCompanyName(this.props.triggerDisplay);

		// If the user is closing while ACRIS is still running, queue it in background.
		// (same behavior as clicking "Run in background")
		var acrisStillRunning =
			isCompany &&
			isOpen &&
			(this.state.acris_loading || this.state.acris_streaming) &&
			!this.state.acris_result &&
			!this.state.acris_background_started;

		if (acrisStillRunning) {
			// Fire and forget. We do not block modal close.
			this._sendAcrisToBackground({ closeModal: false });
		}

		if (isControlled) {
			if (this.props.isOpen && typeof this.props.onClose === 'function') {
				this.props.onClose();
			} else if (!this.props.isOpen && typeof this.props.onOpen === 'function') {
				this.props.onOpen();
			}
			return;
		}

		var next = !this.state.modal;
		this.setState({ modal: next });
	}


	_toSimpleShapeFromDeep(p) {
		if (!p) return null;

		var first = p && p.name && p.name.firstName ? p.name.firstName : '';
		var last = p && p.name && p.name.lastName ? p.name.lastName : '';
		var age = p.age || (p.dob && p.dob.age) || '';

		var emails = [];
		if (p.emailAddresses && p.emailAddresses.length > 0) {
			for (var i = 0; i < p.emailAddresses.length; i++) {
				var em = p.emailAddresses[i] && p.emailAddresses[i].emailAddress ? p.emailAddresses[i].emailAddress : '';
				if (em) emails.push({ email: em });
			}
		}

		var phones = [];
		if (p.phoneNumbers && p.phoneNumbers.length > 0) {
			for (var j = 0; j < p.phoneNumbers.length; j++) {
				var ph = p.phoneNumbers[j];
				var raw = ph && (ph.phoneNumber || ph.number) ? (ph.phoneNumber || ph.number) : '';
				var type = ph && (ph.phoneType || ph.type) ? (ph.phoneType || ph.type) : '';
				phones.push({ number: raw, type: type });
			}
		}

		var addrs = [];
		if (p.addresses && p.addresses.length > 0) {
			for (var k = 0; k < p.addresses.length; k++) {
				var a = p.addresses[k] || {};
				var street = a.addressLine1 || a.streetLine1 || a.FullAddress || a.fullAddress || '';
				var unit = a.addressLine2 || a.streetLine2 || '';
				var city = a.city || a.City || '';
				var state = a.state || a.State || '';
				var zip = a.zip || a.Zip || a.postalCode || a.PostalCode || '';
				var firstReportedDate = a.firstReportedDate || '';
				var lastReportedDate = a.lastReportedDate || '';
				addrs.push({
					street: street,
					unit: unit,
					city: city,
					state: state,
					zip: zip,
					firstReportedDate: firstReportedDate,
					lastReportedDate: lastReportedDate
				});
			}
		}

		return {
			name: { firstName: first, lastName: last },
			age: age,
			emails: emails,
			phones: phones,
			addresses: addrs
		};
	}

	_renderSimpleContactCard(personLike) {
		if (!personLike) return null;

		var personLikeName = personLike && personLike.name ? personLike.name : '';
		var firstName = this.props.first_name || personLikeName.firstName || "";
		var lastName = this.props.last_name || personLikeName.lastName || "";
		var age = (typeof personLike.age !== 'undefined' && personLike.age !== null) ? String(personLike.age) : '';

		var primaryEmail = '';
		if (personLike.emails && personLike.emails.length > 0) {
			primaryEmail = personLike.emails[0] && personLike.emails[0].email ? personLike.emails[0].email : '';
		}

		var rawPrimaryPhone = '';
		if (personLike.phones && personLike.phones.length > 0) {
			rawPrimaryPhone = personLike.phones[0] && personLike.phones[0].number ? personLike.phones[0].number : '';
		}
		var primaryPhone = this._formatPhoneDisplay(rawPrimaryPhone);

		var primaryAddress = '';
		var primaryCityState = '';
		var addressRange = '';
		if (personLike.addresses && personLike.addresses.length > 0) {
			var a0 = personLike.addresses[0];
			primaryAddress = this._formatAddressSimple(a0);
			var city = a0 && a0.city ? a0.city : '';
			var state = a0 && a0.state ? a0.state : '';
			primaryCityState = (city || state) ? (city + (city && state ? ', ' : '') + state) : '';

			var f = a0 && a0.firstReportedDate ? new Date(a0.firstReportedDate) : null;
			var l = a0 && a0.lastReportedDate ? new Date(a0.lastReportedDate) : null;
			var fStr = f ? _formatMonthYear(f) : '';
			var lStr = l ? _formatMonthYear(l) : '';
			if (fStr || lStr) {
				addressRange = (fStr || '') + ' – ' + (lStr || '');
			}
		}

		var initials = this._getInitialsFromPerson(personLike);

		return (
			<div className="skiptrace-profile-card">
				{/* Header / avatar row */}
				<div className="skiptrace-profile-header">
					<div className="skiptrace-profile-avatar">
						<span>{initials}</span>
					</div>

					<div className="skiptrace-profile-header-main">
						<div className="skiptrace-profile-name-row">
							<span className="skiptrace-profile-name">
								{firstName || lastName ? ((firstName || '') + ' ' + (lastName || '')).trim() : 'Unknown contact'}
							</span>
							{age ? (
								<span className="skiptrace-pill skiptrace-pill--light">
									Age {age}
								</span>
							) : null}
						</div>

						<div className="skiptrace-profile-meta">
							{primaryEmail ? (
								<div className="skiptrace-profile-meta-item">
									<EmailOutlineIcon size={16} />
									<a
										href={this._mailto(primaryEmail)}
										className="skiptrace-profile-link"
										target="_blank"
										rel="noopener noreferrer"
									>
										{primaryEmail}
									</a>
								</div>
							) : null}

							{primaryPhone ? (
								<div className="skiptrace-profile-meta-item">
									<PhoneIcon size={16} />
									{rawPrimaryPhone ? (
										<a
											href={this._tel(rawPrimaryPhone)}
											className="skiptrace-profile-link"
											target="_blank"
											rel="noopener noreferrer"
										>
											{primaryPhone}
										</a>
									) : (
										<span>{primaryPhone}</span>
									)}
								</div>
							) : null}

							{primaryAddress ? (
								<div className="skiptrace-profile-meta-item">
									<MapMarkerIcon size={16} />
									<a
										href={this._mapsSearch(personLike.addresses[0])}
										className="skiptrace-profile-link"
										target="_blank"
										rel="noopener noreferrer"
									>
										{primaryAddress}
									</a>
									{primaryCityState ? (
										<span className="skiptrace-profile-meta-sub">
											{primaryCityState}
										</span>
									) : null}
									{addressRange ? (
										<span className="skiptrace-profile-meta-sub">
											{addressRange}
										</span>
									) : null}
								</div>
							) : null}
						</div>
					</div>
				</div>

				{/* Details grid */}
				<div className="skiptrace-profile-body">
					{/* Emails */}
					<div className="skiptrace-section">
						<div className="skiptrace-section-title">
							<EmailOutlineIcon size={18} />
							<span>Email(s)</span>
						</div>
						{personLike.emails && personLike.emails.length > 0 ? (
							<ul className="skiptrace-list">
								{personLike.emails.map(function (e, i) {
									var email = e && e.email ? e.email : '';
									return (
										<this._ListItem
											key={'simp_e_' + i}
											icon={null}
											href={email ? this._mailto(email) : null}
											target="_blank"
										>
											{email || '-'}
										</this._ListItem>
									);
								}.bind(this))}
							</ul>
						) : (
							<p className="skiptrace-empty">-</p>
						)}
					</div>

					{/* Phones */}
					<div className="skiptrace-section">
						<div className="skiptrace-section-title">
							<PhoneIcon size={18} />
							<span>Phone(s)</span>
						</div>
						{personLike.phones && personLike.phones.length > 0 ? (
							<ul className="skiptrace-list">
								{personLike.phones.map(function (p, i) {
									var raw = p && p.number ? p.number : '';
									var display = this._formatPhoneDisplay(raw);
									var type = p && p.type ? p.type : '';
									var isMobile = type && (type.toLowerCase().indexOf('mobile') > -1 || type.toLowerCase().indexOf('cell') > -1);
									var badge = isMobile ? 'Mobile' : (type ? _capitalizeText(type) : '');
									return (
										<this._ListItem
											key={'simp_p_' + i}
											icon={null}
											href={raw ? this._tel(raw) : null}
											meta={badge ? <span className="small-text light-text">({badge})</span> : null}
											target="_blank"
										>
											{display || '-'}
										</this._ListItem>
									);
								}.bind(this))}
							</ul>
						) : (
							<p className="skiptrace-empty">-</p>
						)}
					</div>

					{/* Addresses */}
					<div className="skiptrace-section">
						<div className="skiptrace-section-title">
							<MapMarkerIcon size={18} />
							<span>Address(es)</span>
						</div>
						{personLike.addresses && personLike.addresses.length > 0 ? (
							<ul className="skiptrace-list">
								{personLike.addresses.map(function (a, i) {
									var addr = this._formatAddressSimple(a);
									var f = a && a.firstReportedDate ? new Date(a.firstReportedDate) : null;
									var l = a && a.lastReportedDate ? new Date(a.lastReportedDate) : null;
									var fStr = f ? _formatMonthYear(f) : '';
									var lStr = l ? _formatMonthYear(l) : '';
									var range = (fStr || lStr) ? ' (' + (fStr || '') + '–' + (lStr || '') + ')' : '';
									var href = this._mapsSearch(a);
									return (
										<this._ListItem
											key={'simp_a_' + i}
											icon={null}
											href={href}
											target="_blank"
											meta={range ? <span className="small-text light-text">{range}</span> : null}
										>
											{addr || '-'}
										</this._ListItem>
									);
								}.bind(this))}
							</ul>
						) : (
							<p className="skiptrace-empty">-</p>
						)}
					</div>
				</div>
			</div>
		);
	}

	_renderAIFullProfileCard() {
		var s_person = this.state.simple_person;
		var ai = this.state.ai_profile;

		if (!s_person || !ai) {
			return this._renderSimpleContactCard(s_person);
		}

		var nameObj = s_person && s_person.name ? s_person.name : {};
		var firstName = this.props.first_name || nameObj.firstName || "";
		var lastName = this.props.last_name || nameObj.lastName || "";

		var initials = this._getInitialsFromPerson(s_person);

		var age = (typeof s_person.age !== 'undefined' && s_person.age !== null)
			? String(s_person.age)
			: '';

		var contact = ai.contact || {};
		var primaryEmail = contact.primaryEmail || contact.primary_email || '';
		var primaryPhone = contact.primaryPhone || contact.primary_phone || '';
		var otherEmails = contact.otherEmails || contact.other_emails || [];
		var otherPhones = contact.otherPhones || contact.other_phones || [];
		var bestChannel = contact.bestChannel || contact.best_channel || '';
		var bestTimeToReach = contact.bestTimeToReach || contact.best_time_to_reach || '';

		var addresses = ai.addresses || [];
		var work = ai.work || [];
		var education = ai.education || [];
		var socialProfiles = ai.socialProfiles || ai.social_profiles || [];
		var notes = ai.notes || [];
		var summary = ai.summary || '';

		var languages = this._inferLanguagesFromAI(ai);

		// Current role from first work entry
		var currentRole = '';
		if (work && work.length > 0) {
			var w0 = work[0];
			var title = w0 && w0.title ? w0.title : '';
			var company = w0 && w0.company ? w0.company : '';
			if (title && company) currentRole = title + ' at ' + company;
			else if (title) currentRole = title;
			else if (company) currentRole = company;
		}

		// Short location from first address
		var primaryLocation = formatAddress(this.props);

		return (
			<div className="skiptrace-profile-card skiptrace-profile-card--ai">
				{/* HEADER – same structure as simple, full width */}
				<div className="skiptrace-profile-header">
					<div className="skiptrace-profile-avatar">
						<span>{initials}</span>
					</div>

					<div className="skiptrace-profile-header-main">
						<div className="skiptrace-profile-name-row">
							<span className="skiptrace-profile-name">
								{firstName || lastName
									? ((firstName || '') + ' ' + (lastName || '')).trim()
									: 'Unknown contact'}
							</span>
							{age ? (
								<span className="skiptrace-pill skiptrace-pill--light">
									Age {age}
								</span>
							) : null}
						</div>

						{currentRole ? (
							<div className="skiptrace-profile-meta-row">
								<CompanyIcon size={16} />
								<span className="skiptrace-profile-meta-label">
									{currentRole}
								</span>
							</div>
						) : null}

						{primaryLocation ? (
							<div className="skiptrace-profile-meta-row">
								<MapMarkerIcon size={16} />
								<span className="skiptrace-profile-meta-label">
									{primaryLocation}
								</span>
							</div>
						) : null}
					</div>

					{/* Primary contact chips on the right */}
					<div className="skiptrace-profile-header-side">
						{primaryEmail ? (
							<div className="skiptrace-chip">
								<EmailOutlineIcon size={14} />
								<a
									href={this._mailto(primaryEmail)}
									className="skiptrace-chip-link"
									target="_blank"
									rel="noopener noreferrer"
								>
									{primaryEmail}
								</a>
							</div>
						) : null}
						{primaryPhone ? (
							<div className="skiptrace-chip">
								<PhoneIcon size={14} />
								<a
									href={this._tel(primaryPhone)}
									className="skiptrace-chip-link"
								>
									{this._formatPhoneDisplay(primaryPhone)}
								</a>
							</div>
						) : null}
						{(bestChannel || bestTimeToReach) ? (
							<div className="skiptrace-chip skiptrace-chip--muted">
								<span>
									{bestChannel ? ('Best via ' + bestChannel) : ''}
									{bestChannel && bestTimeToReach ? ' • ' : ''}
									{bestTimeToReach ? bestTimeToReach : ''}
								</span>
							</div>
						) : null}
					</div>
				</div>

				<div className="skiptrace-profile-divider" />

				{/* BODY – two columns: left (wide) + right (narrow) */}
				<div className="skiptrace-profile-body skiptrace-profile-body--two-col">
					{/* LEFT COLUMN */}
					<div className="skiptrace-profile-col skiptrace-profile-col--main">
						{/* Summary card */}
						{summary ? (
							<div className="skiptrace-section skiptrace-section--summary">
								<div className="skiptrace-section-title">
									<span>Summary</span>
								</div>
								<p className="skiptrace-profile-summary">
									{summary}
								</p>
							</div>
						) : null}

						{/* WORK HISTORY SECTION */}
						{work && work.length > 0 ? (
							<div className="skiptrace-section">
								<div className="skiptrace-section-title">
									<CompanyIcon size={18} />
									<span>Work history</span>
								</div>

								<ul className="skiptrace-list">
									{work.map(function (w, idx) {
										if (!w) return null;

										var title = w.title || '';
										var company = w.company || '';
										var location = w.location || '';
										var start = w.startDate || '';
										var end = w.endDate || '';
										var line = '';
										var range = '';

										if (title && company) line = title + ' at ' + company;
										else if (title) line = title;
										else if (company) line = company;
										else line = 'Role not specified';

										if (start || end) range = (start || '') + ' - ' + (end || 'Present');

										return (
											<this._ListItem
												key={'ai_w_' + idx}
												icon={null}
												noBullet
												className="skiptrace-line-item"
											>
												<div>
													<div className="skiptrace-line-primary">{_capitalizeText(line.toString().toLowerCase())}</div>

													{location || range ? (
														<div className="skiptrace-meta-sub">
															{location}
															{location && range ? ' • ' : ''}
															{range}
														</div>
													) : null}
												</div>
											</this._ListItem>
										);
									}.bind(this))}
								</ul>
							</div>
						) : null}



						{/* EDUCATION SECTION */}
						{education && education.length > 0 ? (
							<div className="skiptrace-section" style={{ marginTop: 24 }}>
								<div className="skiptrace-section-title">
									<EducationIcon size={18} />
									<span>Education</span>
								</div>

								<ul className="skiptrace-list">
									{education.map(function (ed, idx) {
										if (!ed) return null;

										var school = ed.school || 'School not specified';
										var degreeParts = [];
										if (ed.degree) degreeParts.push(ed.degree);
										if (ed.field) degreeParts.push(ed.field);

										var years = '';
										if (ed.startYear || ed.endYear) {
											years = (ed.startYear || '') + ' - ' + (ed.endYear || '');
										}

										return (
											<this._ListItem
												key={'ai_ed_' + idx}
												icon={null}
												noBullet
												className="skiptrace-line-item"
											>
												<div>
													<div className="skiptrace-line-primary">{_capitalizeText(school.toString().toLowerCase())}</div>

													{degreeParts.length > 0 ? (
														<div className="skiptrace-meta-sub">
															{degreeParts.join(', ')}
														</div>
													) : null}

													{years ? (
														<div className="skiptrace-meta-sub">{years}</div>
													) : null}
												</div>
											</this._ListItem>
										);
									}.bind(this))}
								</ul>
							</div>
						) : null}



						{/* Address history */}
						<div className="skiptrace-section">
							<div className="skiptrace-section-title">
								<MapMarkerIcon size={18} />
								<span>Address history</span>
							</div>
							{addresses && addresses.length > 0 ? (
								<ul className="skiptrace-list">
									{addresses.map(function (a, idx) {
										if (!a) return null;
										var street = a.street || '';
										var unit = a.unit || '';
										var label = a.label || a.tag || '';
										var city = a.city || '';
										var state = a.state || '';
										var zip = a.zip || '';
										var line1 = street + (unit ? ', ' + unit : '');
										var line2 =
											(city || state || zip)
												? city +
												(city && state ? ', ' : '') +
												state +
												(zip ? ' ' + zip : '')
												: '';
										var range = '';
										if (a.firstSeen || a.lastSeen) {
											range =
												(a.firstSeen || '') + ' - ' + (a.lastSeen || 'Present');
										}

										return (
											<this._ListItem key={'ai_addr_' + idx} icon={null} noBullet>
												<div>
													<div>
														<div className="skiptrace-line-primary">{line1 || line2 || 'Address not specified'}
															{label ? (
																<span
																	className="skiptrace-pill skiptrace-pill--light"
																	style={{ marginLeft: 6 }}
																>
																	{label}
																</span>
															) : null}
														</div>

													</div>
													{line2 ? (
														<div className="skiptrace-meta-sub">{line2}</div>
													) : null}
													{range ? (
														<div className="skiptrace-meta-sub">{range}</div>
													) : null}
												</div>
											</this._ListItem>
										);
									}.bind(this))}
								</ul>
							) : (
								<p className="skiptrace-empty">No address history</p>
							)}
						</div>
					</div>

					{/* RIGHT COLUMN */}
					<div className="skiptrace-profile-col skiptrace-profile-col--side">
						{/* Outreach notes */}
						{notes && notes.length > 0 ? (
							<div className="skiptrace-section">
								<div className="skiptrace-section-title">
									<SkipTractIcon size={18} />
									<span>Outreach notes</span>
								</div>
								<ul className="skiptrace-list">
									{notes.map(function (n, idx) {
										if (!n) return null;
										return (
											<this._ListItem key={'ai_note_' + idx} icon={null} noBullet>
												{n}
											</this._ListItem>
										);
									}.bind(this))}
								</ul>
							</div>
						) : null}
						{/* Social profiles */}
						{socialProfiles && socialProfiles.length > 0 ? (
							<div className="skiptrace-section">
								<div className="skiptrace-section-title">
									<SkipTractIcon size={18} />
									<span>Social</span>
								</div>
								<ul className="skiptrace-list">
									{socialProfiles.map(function (sp, idx) {
										if (!sp) return null;
										var network = sp.network || 'Profile';
										var url = sp.url || '';
										var handle = sp.handle || '';
										return (
											<this._ListItem
												key={'ai_sp_' + idx}
												icon={null}
												href={_ensureHttp(url) || null}
												target={url ? '_blank' : null}
											>
												<span>
													{network}
													{handle ? ' • ' + handle : ''}
												</span>
											</this._ListItem>
										);
									}.bind(this))}
								</ul>
							</div>
						) : null}
						{/* Languages */}
						{languages && languages.length > 0 ? (
							<div className="skiptrace-section">
								<div className="skiptrace-section-title">
									<span>Languages</span>
								</div>
								<ul className="skiptrace-list">
									{languages.map(function (lang, idx) {
										if (!lang) return null;
										return (
											<this._ListItem key={'ai_lang_' + idx} icon={null} noBullet>
												{lang}
											</this._ListItem>
										);
									}.bind(this))}
								</ul>
							</div>
						) : null}

						{/* Emails */}
						{(primaryEmail || (otherEmails && otherEmails.length > 0)) ? (
							<div className="skiptrace-section">
								<div className="skiptrace-section-title">
									<EmailOutlineIcon size={18} />
									<span>Emails</span>
								</div>
								<ul className="skiptrace-list">
									{primaryEmail ? (
										<this._ListItem
											key="ai_email_primary"
											icon={null}
											href={this._mailto(primaryEmail)}
											target="_blank"
										>
											{primaryEmail}
										</this._ListItem>
									) : null}
									{otherEmails && otherEmails.length > 0
										? otherEmails.map(function (e, idx) {
											var val = e || '';
											if (!val) return null;
											return (
												<this._ListItem
													key={'ai_email_other_' + idx}
													icon={null}
													href={this._mailto(val)}
													target="_blank"
												>
													{val}
												</this._ListItem>
											);
										}.bind(this))
										: null}
								</ul>
							</div>
						) : null}

						{/* Phones */}
						{(primaryPhone || (otherPhones && otherPhones.length > 0)) ? (
							<div className="skiptrace-section">
								<div className="skiptrace-section-title">
									<PhoneIcon size={18} />
									<span>Phones</span>
								</div>
								<ul className="skiptrace-list">
									{primaryPhone ? (
										<this._ListItem
											key="ai_phone_primary"
											icon={null}
											href={this._tel(primaryPhone)}
										>
											{this._formatPhoneDisplay(primaryPhone)}
										</this._ListItem>
									) : null}
									{otherPhones && otherPhones.length > 0
										? otherPhones.map(function (p, idx) {
											var val = p || '';
											if (!val) return null;
											return (
												<this._ListItem
													key={'ai_phone_other_' + idx}
													icon={null}
													href={this._tel(val)}
												>
													{this._formatPhoneDisplay(val)}
												</this._ListItem>
											);
										}.bind(this))
										: null}
								</ul>
							</div>
						) : null}


					</div>
				</div>
			</div>
		);
	}




	_renderShowFullProfileLink(idx, person) {
		var self = this;
		return (
			<div style={{ marginTop: 6 }}>
				<a href="javascript:void(0)" className="link-text"
					onClick={function (e) { e.preventDefault(); e.stopPropagation(); self._toggleDeepRow('full_' + idx); }}>
					{self.state.deep_expanded['full_' + idx] ? 'Hide full profile' : 'Show full profile'}
				</a>
				{self.state.deep_expanded['full_' + idx] ? (
					<div style={{ marginTop: 10 }}>{self._renderDeepSection(person)}</div>
				) : null}
			</div>
		);
	}


	// ---------- flow split helpers ----------
	_resetCompanyState() {
		return {
			company_loading: false,
			company_error: null,
			company_result: null,
			company_lookup_started: false,
			owner_lookup_started: false,
			last_owner_bbl: null,

			// acris (owners behind LLC)
			acris_loading: false,
			acris_error: null,
			acris_result: null,
			acris_lookup_started: false,

			acris_status: '',
			acris_progress: null,
			acris_streaming: false,

			company_mode: null,
		};
	}


	_fetchPreferredAcrisDocForProperty() {
		var self = this;

		var propertyKey =
			(this.props.property && this.props.property.key) ||
			(this.state.company_result && this.state.company_result.property && this.state.company_result.property.key) ||
			null;


		const { property } = this.props;


		if (!propertyKey) return Promise.resolve(null);

		function _quote(str) {
			return '"' + String(str).replace(/"/g, '\\"') + '"';
		}

		//var q = 'property:' + _quote(propertyKey);
		var q = `(alternate_addresses:("${property.alternate_addresses.join('" OR "')}") AND zip:${property.zip})`;
		if (property.address_2_normalized) {
			q += ` AND address_2_normalized:"${property.address_2_normalized}"`
		}
		if (property.borough_code && property.block && property.lot) {
			q += `(${q}) OR (borough_code:${property.borough_code} AND block:${property.block} AND lot:${property.lot})`
		}
		var fq = ['doc_type:(pat OR deed OR mtge)'];

		var lastSoldTs =
			this.props.property &&
				this.props.property.last_sold_date &&
				this.props.property.last_sold_date > 0
				? Number(this.props.property.last_sold_date)
				: null;

		if (lastSoldTs) {
			// last_sold_date is unix seconds
			var THIRTY_DAYS_SEC = 30 * 24 * 60 * 60;

			var startTs = lastSoldTs - THIRTY_DAYS_SEC;
			var endTs = lastSoldTs + THIRTY_DAYS_SEC;

			// Solr date range must be ISO strings
			var startISO = new Date(startTs * 1000).toISOString();
			var endISO = new Date(endTs * 1000).toISOString();

			fq.push('document_date:[' + startISO + ' TO ' + endISO + ']');
		}

		var axiosData = {
			url: apiRoot + '/query/we3-acris-real-property',
			method: 'post',
			query: {
				q: q,
				fq: fq,
				fl: 'document_id,document_date,recorded_datetime,doc_type',
				sort: 'document_date desc, recorded_datetime desc',
				wt: 'json',
				rows: 25,
				start: 0
			}
		};

		return _axiosCall(axiosData).then(function (res) {
			var docs =
				res &&
					res.docs &&
					Array.isArray(res.docs)
					? res.docs
					: [];

			if (!docs.length) return null;

			// newest-first already; first seen per type is latest for that type
			var latestByType = { pat: null, mtge: null, deed: null };

			for (var i = 0; i < docs.length; i++) {
				var d = docs[i];
				var t = d && d.doc_type;
				if (!t || !latestByType.hasOwnProperty(t)) continue;
				if (!latestByType[t]) latestByType[t] = d;
				if (latestByType.pat && latestByType.mtge && latestByType.deed) break;
			}

			// Priority selection: poa → mtge → deed
			var chosen = latestByType.pat || latestByType.mtge || latestByType.deed;
			if (!chosen) return null;

			return {
				doc_id: chosen.document_id,
				// analyzer expects: acris-poa / acris-mtge / acris-deed
				doc_type: 'acris-' + chosen.doc_type,
				// optional debugging info
				_meta: {
					property: propertyKey,
					chosen_doc_type: chosen.doc_type,
					chosen_document_date: chosen.document_date
				}
			};
		});
	}


	_runAcrisAnalyze() {
		if (this.state.acris_lookup_started) return;

		this.setState({
			acris_lookup_started: true,
			acris_loading: true,
			acris_error: null,
			acris_result: null,
			acris_status: '',
			acris_progress: null,
			acris_streaming: false
		});

		var self = this;

		this._fetchPreferredAcrisDocForProperty()
			.then(function (payload) {
				if (!payload || !payload.doc_id || !payload.doc_type) {
					self.setState({
						acris_error: 'No matching ACRIS document found (poa, mtge, deed) for this property.',
						acris_loading: false
					});
					self._saveSkipTraceToAccount('company_basic', {
						extended_data: self.state && self.state.company_result ? self.state.company_result : null

					}).then(function () {
						return self._deductCreditsAfterSave('company_basic');
					})
						.catch(function (err) {
							console.log('save skip trace error:', err && err.message ? err.message : err);
						});
					return;
				}

				var baseUrl = self.props.acrisAnalyzeUrl || (aiAnalyzeRoot + '/acris/analyze');

				var query = {
					doc_id: payload.doc_id,
					doc_type: payload.doc_type
				};

				// Try streaming first
				return self._runAcrisAnalyzeStream(query)
					.catch(function (e) {
						// If user aborted (Run in background), do nothing.
						if (self._isAcrisAbortedError(e)) return;

						// Otherwise treat as real error (or keep your existing fallback logic if you want)
						self.setState({
							acris_error: e && e.message ? e.message : 'ACRIS stream failed',
							acris_loading: false,
							acris_streaming: false,
							acris_status: '',
							acris_progress: null
						});
					});
			})
			.catch(function (err) {
				var msg = err && err.message ? err.message : 'ACRIS analyze request failed';
				if (err && err.data) {
					try { msg = JSON.stringify(err.data); } catch (e) { }
				}
				self.setState({
					acris_error: msg,
					acris_loading: false,
					acris_streaming: false
				});
			});
	}


	_runAcrisAnalyzeStream(query) {
		var self = this;

		// Stop any prior stream
		if (self._acrisAbortController) {
			try { self._acrisAbortController.abort(); } catch (e) { }
		}

		var controller = new AbortController();
		self._acrisAbortController = controller;

		// UI state
		self.setState({
			acris_loading: true,
			acris_streaming: true,
			acris_error: null,
			acris_status: 'Starting…',
			acris_progress: null
		});

		// Build POST payload for your main API (storage happens here)
		// NOTE: extended_data is stored in skiptrace.js only; it never goes to server.mjs
		var postBody = {
			user: self.props.user || null,

			// TODO: if you already build identity for ACRIS, keep your existing identity builder
			// identity: self._buildIdentityForSaved ? self._buildIdentityForSaved() : null,
			identity: self._buildSavedIdentity ? self._buildSavedIdentity() : null,

			doc_id: query && query.doc_id ? query.doc_id : null,
			doc_type: query && query.doc_type ? query.doc_type : null,
			settings: query && query.settings ? query.settings : null,

			// TODO: replace with whatever object you want to store for later retrieval
			// This can be large
			extended_data: self.state && self.state.company_result ? self.state.company_result : null,
			property: self.props.property || null
		};

		var streamUrl = apiRoot + '/skip/acris-analyze-job/stream';

		function _parseSSEBlock(block) {
			// block is a string without the trailing \n\n
			var lines = block.split('\n');
			var eventName = 'message';
			var dataStr = '';

			for (var i = 0; i < lines.length; i++) {
				var line = lines[i];

				if (line.indexOf('event:') === 0) {
					eventName = line.slice(6).trim();
				} else if (line.indexOf('data:') === 0) {
					// some servers send multiple data: lines; concatenate
					dataStr += line.slice(5).trim();
				}
			}

			if (!dataStr) return null;

			var payload = null;
			try { payload = JSON.parse(dataStr); }
			catch (e) { payload = { message: dataStr }; }

			return { eventName: eventName, payload: payload };
		}

		function _handleSSEEvent(eventName, payload) {
			if (eventName === 'job') {
				// Save job_id if you want to support resume / status checks later
				if (payload && payload.job_id) {
					self.setState({ acris_job_id: payload.job_id });
				}
				return;
			}

			if (eventName === 'progress') {
				// If your progress payload differs, adjust these keys
				var msg = (payload && payload.message) ? payload.message : 'Working…';
				var cur = payload && (payload.pageIndex || payload.page_index || payload.current || payload.cur);
				var tot = payload && (payload.pageCount || payload.page_count || payload.total || payload.tot);

				self.setState({
					acris_status: msg,
					acris_progress: (cur && tot) ? { current: cur, total: tot } : self.state.acris_progress
				});
				return;
			}

			if (eventName === 'done') {
				// Terminal: stop stream + store result
				try { controller.abort(); } catch (e) { }
				return self._deductCreditsAfterSave('company_advanced').then(function (r) {
					self.setState({
						acris_result: payload,
						acris_loading: false,
						acris_streaming: false,
						acris_status: '',
						acris_progress: null
					});
					return;
				});


			}

			if (eventName === 'error') {
				// Terminal: stop stream + show error
				try { controller.abort(); } catch (e) { }

				var errMsg = (payload && (payload.error || payload.message)) ? (payload.error || payload.message) : 'Stream error';

				self.setState({
					acris_error: errMsg,
					acris_loading: false,
					acris_streaming: false,
					acris_status: '',
					acris_progress: null
				});
				return;
			}

			// Optional: handle other events
			// console.log('SSE:', eventName, payload);
		}

		// Start the streaming request
		return fetch(streamUrl, {
			method: 'POST',
			credentials: 'include',
			headers: {
				'Accept': 'text/event-stream',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(postBody),
			signal: controller.signal
		})
			.then(function (resp) {
				if (!resp || !resp.ok) {
					var code = resp ? resp.status : 0;
					throw new Error('Streaming request failed (' + code + ')');
				}
				if (!resp.body) throw new Error('No response body for stream');

				var reader = resp.body.getReader();
				var decoder = new TextDecoder('utf-8');
				var buffer = '';

				function pump() {
					return reader.read().then(function (r) {
						if (r.done) return;

						buffer += decoder.decode(r.value || new Uint8Array(), { stream: true });

						// SSE events are separated by blank lines
						var parts = buffer.split('\n\n');
						buffer = parts.pop() || '';

						for (var i = 0; i < parts.length; i++) {
							var parsed = _parseSSEBlock(parts[i]);
							if (!parsed) continue;
							_handleSSEEvent(parsed.eventName, parsed.payload);
						}

						return pump();
					});
				}

				return pump();
			})
			.catch(function (err) {
				// Abort is expected when user closes modal
				if (err && err.name === 'AbortError') {
					// Only clear streaming flags; don’t treat as error
					self.setState({
						acris_loading: false,
						acris_streaming: false,
						acris_status: '',
						acris_progress: null
					});
					return;
				}

				self.setState({
					acris_error: (err && err.message) ? err.message : String(err || 'stream_failed'),
					acris_loading: false,
					acris_streaming: false,
					acris_status: '',
					acris_progress: null
				});
			})
			.finally(function () {
				if (self._acrisAbortController === controller) {
					self._acrisAbortController = null;
				}
			});
	}






	_initCompanyFlow() {
		var self = this;

		this.setState(function () {
			var next = self._resetCompanyState();
			next.request_state = self.props.state || '';

			// clear person/workplace
			next.simple_loading = false;
			next.simple_error = null;
			next.simple_person = null;
			next.deep_loading = false;
			next.deep_error = null;
			next.deep_persons = [];
			next.workplace_loading = false;
			next.workplace_error = null;
			next.workplace_records = [];

			// show company chooser first
			next.hasSearched = false;
			next.company_mode = null;

			return next;
		});
	}

	_renderCompanyResearchPicker(opts) {
		opts = opts || {};

		var availableCredits = Number(opts.availableCredits || 0);

		var basicCredits = Number(opts.basicCredits || 0);
		var advCredits = Number(opts.advCredits || 0);
		var deepCredits = Number(opts.deepCredits || (basicCredits + advCredits));

		var hasBasic = !!opts.hasBasic;
		var hasDeep = !!opts.hasDeep;

		var onBasic = opts.onBasic;
		var onDeep = opts.onDeep;
		var onTopUp = opts.onTopUp;

		function _onCardClick(fn, enabled, e) {
			if (e && e.preventDefault) e.preventDefault();
			if (!enabled) return;
			if (fn) fn();
		}

		function _onKeyDown(fn, enabled, e) {
			if (!e) return;
			if (e.key === 'Enter' || e.key === ' ') {
				if (e.preventDefault) e.preventDefault();
				_onCardClick(fn, enabled, e);
			}
		}

		return (
			<div className="premium-dashboard">
				<div className="premium-grid3">
					{/* Left benefits column */}
					<div className="premium-benefits">
						<div className="premium-benefits__brandRow">
							<div className="premium-benefits__badge">
								{this.props.property.building_name ? _capitalizeText(this.props.property.building_name) : _capitalizeText(this.props.property.display_full_street_address)}{this.props.property.address_2_normalized ? `, ${this.props.property.address_2_normalized.toUpperCase().replace("APT", "Apt")}` : ""}
							</div>
						</div>

						<div className="premium-benefits__title">{this.props.triggerDisplay}</div>

						<ul className="premium-benefits__list">
							<li><span className="premium-check">✓</span> NY DOS entity research</li>
							<li><span className="premium-check">✓</span> Intelligent name and address matching</li>
							<li><span className="premium-check">✓</span> AI-assisted deep research</li>
							<li><span className="premium-check">✓</span> Results saved for export anytime</li>
						</ul>

						<hr />

						<div className="premium-credit_avail">
							Premium Credits: <strong>{availableCredits}</strong>
							<a
								href="javascript:void(0)"
								className="link-text top-credit"

								onClick={function (e) {
									e.preventDefault();
									e.stopPropagation();
									this._openPremiumCreditsModal();
								}.bind(this)}
							>
								Purchase Credits
							</a>

						</div>
						<QuickStartGuide
							link="http://help.marketproof.com/en/articles/13454433-understanding-credits-in-marketproof-pro"
							copy="What are premium credits?"
							linkCopy="Learn More"
						/>
					</div>

					{/* Basic card */}
					<div
						className={
							'premium-miniCard premium-miniCard--contact' +
							(hasBasic ? '' : ' premium-miniCard--disabled')
						}
						role="button"
						tabIndex={0}
						onClick={_onCardClick.bind(null, onBasic, hasBasic)}
						onKeyDown={_onKeyDown.bind(null, onBasic, hasBasic)}
					>
						<div className="premium-miniCard__top">
							<div className="premium-miniCard__logoRow">
								<div className="premium-miniCard__icon">
									{/* simple building icon */}
									<svg width="40" height="40" viewBox="0 0 24 24" fill="none" aria-hidden="true">
										<path d="M4 21V3h10v18H4z" stroke="currentColor" strokeWidth="1.8" />
										<path d="M14 9h6v12h-6" stroke="currentColor" strokeWidth="1.8" />
										<path d="M7 7h4M7 11h4M7 15h4" stroke="currentColor" strokeWidth="1.8" />
									</svg>
								</div>
								<div className="premium-miniCard__label">CORP SEARCH</div>
							</div>

							<div className="premium-miniCard__desc">
								Corp registration & tax search.
							</div>

							<ul className="premium-miniCard__bullets">
								<li>NY DOS registration signals</li>
								<li>Corporate formation details</li>
								<li>Tax bill name and address search</li>
								<li>{basicCredits} premium credit{basicCredits === 1 ? '' : 's'}</li>
							</ul>
						</div>
						<div className="premium-context-desc">Unlock info for {this.props.triggerDisplay}</div>
						<div className="premium-miniCard__bottom">
							{hasBasic ? <Button
								onClick={function (e) {
									e.preventDefault();
									e.stopPropagation();
									if (hasBasic && onBasic) onBasic();
								}}
								variant="contained"
								color="primary"
								className="premium-miniCard__cta"
								disabled={!hasBasic}
							>
								Run Basic Search
							</Button> : (
								<>
									<Button
										variant="contained"
										color="primary"
										className="premium-miniCard__cta"
										onClick={function (e) {
											e.preventDefault();
											e.stopPropagation();
											if (onTopUp) onTopUp();
										}}
									>
										Get Premium Credits
									</Button>

								</>
							)}

						</div>
					</div>

					{/* Deep card */}
					<div
						className={
							'premium-miniCard premium-miniCard--full' +
							(hasDeep ? '' : ' premium-miniCard--disabled')
						}
						role="button"
						tabIndex={0}
						onClick={_onCardClick.bind(null, onDeep, hasDeep)}
						onKeyDown={_onKeyDown.bind(null, onDeep, hasDeep)}
					>
						<div className="premium-miniCard__top">
							<div className="premium-miniCard__logoRow">
								<div className="premium-miniCard__icon">
									{/* "AI/doc" icon */}
									<svg width="40" height="40" viewBox="0 0 24 24" fill="none" aria-hidden="true">
										<path d="M6 3h8l4 4v14H6V3z" stroke="currentColor" strokeWidth="1.8" />
										<path d="M14 3v5h5" stroke="currentColor" strokeWidth="1.8" />
										<path d="M8 12h8M8 16h8" stroke="currentColor" strokeWidth="1.8" />
										<path d="M11 9h2" stroke="currentColor" strokeWidth="1.8" />
									</svg>
								</div>
								<div className="premium-miniCard__label">AI RESEARCH</div>
							</div>

							<div className="premium-miniCard__desc">
								AI-assisted deep research.
							</div>

							<ul className="premium-miniCard__bullets">
								<li>Everything in Corp Search</li>
								<li>Signatories and legal reps</li>
								<li>True owner research</li>
								<li>{deepCredits} premium credits</li>
							</ul>
						</div>
						<div className="premium-context-desc">Unlock details for {this.props.triggerDisplay}</div>
						<div className="premium-miniCard__bottom">
							{hasDeep ? <Button
								onClick={function (e) {
									e.preventDefault();
									e.stopPropagation();
									if (hasDeep && onDeep) onDeep();
								}}
								variant="contained"
								color="primary"
								className="premium-miniCard__cta"
								disabled={!hasDeep}
							>
								Run Deep Research
							</Button> : (
								<>
									<Button
										variant="contained"
										color="primary"
										className="premium-miniCard__cta"
										onClick={function (e) {
											e.preventDefault();
											e.stopPropagation();
											if (onTopUp) onTopUp();
										}}
									>
										Get Premium Credits
									</Button>

								</>
							)}
						</div>
					</div>
				</div>
			</div>
		);
	}



	// ===============================
	// Company flow renderer (UPDATED)
	// ===============================
	_renderCompanyFlow() {
		var c_loading = this.state.company_loading;
		var c_error = this.state.company_error;
		var c_result = this.state.company_result;
		var g_loading = this.state.saved_loading;

		var user = this.props.user || {};
		var available = this._getUserPremiumCredits(user);

		var basicCredits = this._getRequiredCreditsForContact('company_basic');
		var advCredits = this._getRequiredCreditsForContact('company_advanced');
		var deepCredits = basicCredits + advCredits;

		var hasBasic = available >= basicCredits;
		var hasDeep = available >= deepCredits;

		var mode = this.state.company_mode; // 'basic' | 'deep' | null

		if (!mode) {
			return (
				<div>


					{this._renderCompanyResearchPicker({
						availableCredits: available,
						basicCredits: basicCredits,
						advCredits: advCredits,
						deepCredits: deepCredits,
						hasBasic: hasBasic,
						hasDeep: hasDeep,
						onBasic: this._handleStartCompanyBasic,
						onDeep: this._handleStartCompanyDeep,
						onTopUp: this._openPremiumCreditsModal ? this._openPremiumCreditsModal.bind(this) : null
					})}
				</div>
			);
		}

		var isCompanyLoading = !!c_loading || !!g_loading;



		return (
			<div>
				{this._renderSearchContextBanner()}

				{isCompanyLoading || !c_result ? (
					<ProfileLoadingCard
						data={this.props ? this.props : {}}
						messageType="company"
						stepMs={2500}
						LinearLoading={LinearLoading}
						MapMarkerIcon={MapMarkerIcon}
						capitalizeText={_capitalizeText}
						getInitials={this._getInitialsFromPerson}
						formatAddress={formatAddress}
					/>
				) : null}


				{c_error ? (
					<div style={{ marginTop: 10 }}>
						<p style={{ color: 'red' }}>{c_error}</p>
						{this._renderAcrisOwnersSection()}
					</div>
				) : null}
				{/* Owners Behind LLC */}
				{(!c_loading && !c_error && c_result) ? this._renderCompanySection(c_result) : null}

				{/* Upgrade to Deep Research option (only for basic mode) */}
				{mode === 'company_basic' && !c_loading && !c_error && c_result ? (
					<div
						className="dashboard"
						style={{ textAlign: 'center', marginTop: 16 }}
					>
						{this.state.acris_loading ? (
							<div style={{ maxWidth: 260, margin: '0 auto' }}>
								<LinearLoading />
								<p>Running deep research…</p>
							</div>
						) : !this.state.acris_result ? (
							<>
								<div className="premium-context-desc">
									Unlock ACRIS ownership records and detailed entity information for {this.props.triggerDisplay}.
									Uses <strong>{advCredits}</strong> additional premium credits
								</div>
								<Button
									onClick={this._handleUpgradeToCompanyDeep}
									variant="contained"
									color="primary"
									className="premium-miniCard__cta"
									disabled={available < advCredits}
									style={{ minWidth: 200, width: 250 }}
								>
									{available >= advCredits ? 'Get Deep Research' : 'Not enough credits'}
								</Button>
							</>
						) : null}
						{this.state.acris_error ? <p style={{ color: 'red' }}>{this.state.acris_error}</p> : null}
					</div>
				) : null}

			</div>
		);
	}


	// =====================================
	// Company section renderer (RESTORED HEADER + SECTION TITLES)
	// =====================================
	_renderCompanySection(result) {
		if (!result) return null;

		var c_loading = this.state.company_loading;
		var c_error = this.state.company_error;
		var c_result = this.state.company_result;

		var top = result.topMatch || {};
		var det = result.detail || {};
		var gi = det.entityGeneralInfo || {};
		var sop = det.sopAddress || {};
		var ra = det.registeredAgent || {};
		var esopName = det.electronicServiceOfProcessStatusName || '';

		function _safeStr(v) {
			if (v === null || typeof v === 'undefined') return '';
			return String(v).trim();
		}

		function _getInitialsFromCompany(name) {
			var s = _safeStr(name);
			if (!s) return 'C';
			var parts = s.replace(/\s+/g, ' ').split(' ');
			var first = parts[0] ? parts[0].charAt(0).toUpperCase() : '';
			var second = '';
			if (parts.length > 1 && parts[1]) second = parts[1].charAt(0).toUpperCase();
			if (!second && parts[0] && parts[0].length > 1) second = parts[0].charAt(1).toUpperCase();
			return (first + second).trim() || 'C';
		}

		function addrBlock(a) {
			if (!a) return '';
			var ad = a.address || {};
			var line1 = _safeStr(ad.streetAddress || ad.streetAddress1);
			var line2 = _safeStr(ad.addressLine2 || ad.streetAddress2);
			var city = _safeStr(ad.city);
			var st = _safeStr(ad.state);
			var zp = _safeStr(ad.zipCode);
			var parts = [];
			if (line1) parts.push(line1);
			if (line2) parts.push(line2);
			var cityState = (city || st) ? (city + (city && st ? ', ' : '') + st) : '';
			if (cityState) parts.push(cityState);
			if (zp) parts.push(zp);
			return parts.join(', ');
		}

		function getOwnerExtractData(ownerExtract) {
			if (!ownerExtract) return null;
			var dataObj = ownerExtract && typeof ownerExtract.data === 'object'
				? ownerExtract.data
				: ownerExtract;

			var name = _safeStr(dataObj && (dataObj.owner_name || dataObj.owner || dataObj.name));
			var addr = _safeStr(dataObj && (dataObj.mailing_address || dataObj.address));

			if (!name && !addr) return null;
			return { owner_name: name, mailing_address: addr };
		}

		var owner_loading = this.state.owner_loading;
		var ownerData = getOwnerExtractData(result.ownerExtract);

		var companyName = _safeStr(top.entityName || gi.entityName) || this.props.triggerDisplay || 'Company';
		var initials = _getInitialsFromCompany(companyName);

		var dosId = _safeStr(top.dosID || gi.dosID);
		var status = _safeStr(top.entityStatus || gi.entityStatus);
		var entityType = _safeStr(top.entityType || gi.entityType);

		var formed = this._fmtDate(gi.dateOfInitialDosFiling || top.initialFilingDate) || '';
		var county = _safeStr(top.county || gi.county);
		var jurisdiction = _safeStr(top.jurisdiction || gi.jurisdiction);

		var sopName = _safeStr(sop.name);
		var sopAddr =
			(ownerData && ownerData.mailing_address)
				? ownerData.mailing_address
				: addrBlock(sop);

		var raName = _safeStr(ra && ra.name);
		var raAddr = addrBlock(ra);

		var sopHref = sopAddr ? this._mapsSearch(sopAddr) : null;
		var raHref = raAddr ? this._mapsSearch(raAddr) : null;

		return (
			<div style={{ marginTop: 12 }}>
				<div className="skiptrace-profile-card skiptrace-profile-card--ai">

					{/* NICE HEADER (restored) */}
					<div className="skiptrace-profile-header">
						<div className="skiptrace-profile-avatar">
							<span>{initials}</span>
						</div>

						<div className="skiptrace-profile-header-main">
							<div className="skiptrace-profile-name-row">
								<span className="skiptrace-profile-name">{companyName}</span>

								{status ? (
									<span className="skiptrace-pill skiptrace-pill--light">
										{status}
									</span>
								) : null}
							</div>

							{entityType ? (
								<div className="skiptrace-profile-meta-row">
									<CompanyIcon size={16} />
									<span className="skiptrace-profile-meta-label">{entityType}</span>
								</div>
							) : null}

							{(county || jurisdiction || formed) ? (
								<div className="skiptrace-profile-meta-row">
									<MapMarkerIcon size={16} />
									<span className="skiptrace-profile-meta-label">
										{county ? county : ''}
										{county && jurisdiction ? ' • ' : ''}
										{jurisdiction ? jurisdiction : ''}
										{(county || jurisdiction) && formed ? ' • ' : ''}
										{formed ? ('Formed ' + formed) : ''}
									</span>
								</div>
							) : null}
						</div>

						<div className="skiptrace-profile-header-side">
							{dosId ? (
								<div className="skiptrace-chip skiptrace-chip--muted">
									<span>DOS ID: {dosId}</span>
								</div>
							) : null}

							{sopAddr ? (
								<div className="skiptrace-chip">
									<MapMarkerIcon size={14} />
									{sopHref ? (
										<a
											href={sopHref}
											className="skiptrace-chip-link"
											target="_blank"
											rel="noopener noreferrer"
										>
											{_safeStr(sopAddr) || '-'}
										</a>
									) : (
										<span>Mailing Address</span>
									)}
								</div>
							) : null}

							{raAddr ? (
								<div className="skiptrace-chip">
									<MapMarkerIcon size={14} />
									{raHref ? (
										<a
											href={raHref}
											className="skiptrace-chip-link"
											target="_blank"
											rel="noopener noreferrer"
										>
											Registered Agent
										</a>
									) : (
										<span>Registered Agent</span>
									)}
								</div>
							) : null}
						</div>
					</div>

					<div className="skiptrace-profile-divider" />

					{this._renderAcrisOwnersSection()}

					{/* BODY SECTIONS */}
					<div>

						{/* Company Details (FULL ROW) */}
						<div className="skiptrace-profile-card" style={{ marginTop: 10 }}>
							<div className="skiptrace-section-title">
								<CompanyIcon style={{ marginTop: -3, marginRight: 5 }} />
								<span>NYS Corporate Registration</span>
							</div>
							<div className="skiptrace-section-subtitle">
								Official New York State Department of State registration details, including entity status and formation data.
							</div>
							<div className="skiptrace-profile-divider" />
							<div className="skiptrace-profile-body">

								<div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, width: '70%' }}>
									<div>
										<div style={{ marginBottom: 10 }}>
											<strong>Company Name</strong><br />
											<span>{companyName || '-'}</span>
										</div>

										<div style={{ marginBottom: 10 }}>
											<strong>Company ID (DOS ID)</strong><br />
											<span>{dosId || '-'}</span>
										</div>

										<div style={{ marginBottom: 10 }}>
											<strong>Status</strong><br />
											<span>{status || '-'}</span>
										</div>

										<div style={{ marginBottom: 10 }}>
											<strong>Business Type</strong><br />
											<span>{entityType || '-'}</span>
										</div>
									</div>

									<div>
										<div style={{ marginBottom: 10 }}>
											<strong>Date Formed</strong><br />
											<span>{formed || '-'}</span>
										</div>

										<div style={{ marginBottom: 10 }}>
											<strong>County Registered</strong><br />
											<span>{county || '-'}</span>
										</div>

										<div style={{ marginBottom: 10 }}>
											<strong>Jurisdiction (State)</strong><br />
											<span>{jurisdiction || '-'}</span>
										</div>
									</div>
								</div>
								<div>

									<div style={{ border: '1px solid #eee', borderRadius: 10, padding: 12 }}>
										<p style={{ fontWeight: 700, margin: '0 0 8px' }}>Official Mailing Contact</p>
										<div><strong>Contact Name:</strong> {sopName || '-'}</div>
										<div style={{ marginTop: 6 }}>
											<strong>Mailing Address:</strong>{' '}
											{sopAddr ? (
												<a href={this._mapsSearch(sopAddr)} target="_blank" rel="noopener noreferrer">
													{sopAddr}
												</a>
											) : (
												'-'
											)}
										</div>
										{esopName ? (
											<div style={{ marginTop: 8 }}>
												<strong>Electronic Delivery:</strong> {esopName}
											</div>
										) : null}
										<hr />
										<p style={{ fontWeight: 700, margin: '0 0 8px' }}>Registered Agent</p>
										<div><strong>Name:</strong> {raName || '-'}</div>
										<div style={{ marginTop: 6 }}>
											<strong>Address:</strong>{' '}
											{raAddr ? (
												<a href={this._mapsSearch(raAddr)} target="_blank" rel="noopener noreferrer">
													{raAddr}
												</a>
											) : (
												'-'
											)}
										</div>
									</div>

								</div>
							</div>
						</div>



						{/* Owner Extract */}
						{(ownerData || owner_loading) ? (
							<>
								<div className="skiptrace-profile-card" style={{ marginTop: 10 }}>
									<div className="skiptrace-section-title">
										<TaxIcon style={{ marginTop: -3, marginRight: 5 }} />
										<span>NYC Tax Bill Analysis</span>
									</div>
									<div className="skiptrace-section-subtitle">
										Ownership, billing, and exemption signals derived from New York City property tax records.
									</div>
									<div className="skiptrace-profile-divider" />

									<div className="skiptrace-profile-body">
										{owner_loading ? (
											<LinearLoading />
										) : (
											<div>
												<div><strong>Owner Name:</strong> {_safeStr(ownerData.owner_name) || '-'}</div>
												<div style={{ marginTop: 6 }}>
													<strong>Mailing Address:</strong> {_safeStr(ownerData.mailing_address) || '-'}
												</div>
											</div>
										)}
									</div>
								</div>
							</>
						) : null}

					</div>
				</div>
			</div>
		);
	}


	// =====================================
	// Owners behind LLC section (INLINE TITLE)
	// =====================================
	_renderAcrisOwnersSection() {
		var loading = this.state.acris_loading;
		var err = this.state.acris_error;
		var result = this.state.acris_result;
		var streaming = this.state.acris_streaming;

		var summary = result && result.summary ? result.summary : null;
		var peopleContacts = result && result.summary_people_contacts ? result.summary_people_contacts : null;

		function _cleanVal(v) {
			if (v === null || typeof v === 'undefined') return '';
			if (typeof v === 'string') return v.trim();
			return String(v);
		}

		function _formatKeyLabel(key) {
			if (!key) return '';
			return String(key)
				.replace(/([a-z])([A-Z0-9])/g, '$1 $2')
				.replace(/([0-9])([A-Z])/g, '$1 $2')
				.trim();
		}

		function _summaryRows(obj) {
			if (!obj) return [];
			var out = [];
			var k;
			for (k in obj) {
				if (!obj.hasOwnProperty(k)) continue;
				var val = _cleanVal(obj[k]);
				if (!val) continue;
				out.push({ key: _formatKeyLabel(k), value: val, rawKey: k });
			}
			return out;
		}

		function _toDateMs(mmddyyyy) {
			if (!mmddyyyy) return 0;
			var s = String(mmddyyyy);
			var parts = s.split('/');
			if (!parts || parts.length < 3) return 0;
			var mm = parseInt(parts[0], 10);
			var dd = parseInt(parts[1], 10);
			var yy = parseInt(parts[2], 10);
			if (!mm || !dd || !yy) return 0;
			var d = new Date(yy, mm - 1, dd);
			var t = d.getTime();
			return isNaN(t) ? 0 : t;
		}

		function _cleanPhoneDigits(phone) {
			var s = String(phone || '');
			s = s.replace(/[^0-9]/g, '');
			if (s.length === 11 && s.charAt(0) === '1') return s;
			if (s.length === 10) return '1' + s;
			return s;
		}

		function _uniqueStrings(arr) {
			var out = [];
			var seen = {};
			var i;
			for (i = 0; i < (arr || []).length; i++) {
				var v = _cleanVal(arr[i]);
				if (!v) continue;
				var key = v.toLowerCase();
				if (seen[key]) continue;
				seen[key] = true;
				out.push(v);
			}
			return out;
		}

		function _rankPhones(phones) {
			var list = (phones || []).slice(0);

			function _score(p) {
				p = p || {};
				var num = p.number || p.phone || '';
				if (!num) return -1;

				var isConn = p.isConnected === true ? 1 : 0;
				var lastMs = _toDateMs(p.lastReportedDate);
				var type = String(p.type || '').toLowerCase();
				var typeScore = 0;
				if (type === 'mobile' || type === 'wireless') typeScore = 2;
				else if (type === 'landline') typeScore = 1;

				return (isConn * 1000000000) + (lastMs) + (typeScore * 1000);
			}

			list.sort(function (a, b) {
				return _score(b) - _score(a);
			});

			return list;
		}

		function _rankEmails(emails) {
			var list = (emails || []).slice(0);

			function _score(e, idx) {
				e = e || {};
				var addr = e.email || e.address || '';
				if (!addr || String(addr).indexOf('@') === -1) return -1;

				var isVal = e.isValidated === true ? 1 : 0;
				var isBiz = e.isBusiness === true ? 1 : 0;

				return (isVal * 100) + (isBiz * 10) + (100 - idx);
			}

			list.sort(function (a, b) {
				// stable-ish: compute scores using original index by attaching temp _idx
				var sa = _score(a, a && typeof a._idx !== 'undefined' ? a._idx : 0);
				var sb = _score(b, b && typeof b._idx !== 'undefined' ? b._idx : 0);
				return sb - sa;
			});

			return list;
		}

		function _extractContactCard(roleKey, roleLabel) {
			if (!peopleContacts || !peopleContacts[roleKey]) return null;

			var node = peopleContacts[roleKey] || {};
			var personNode = node.contact && node.contact.person ? node.contact.person : null;

			var phones = personNode && personNode.phones ? personNode.phones : [];
			var emails = personNode && personNode.emails ? personNode.emails : [];

			// keep original order indices for email scoring
			var i;
			for (i = 0; i < emails.length; i++) {
				if (emails[i]) emails[i]._idx = i;
			}

			var topPhones = _rankPhones(phones)
				.map(function (p) {
					if (!p) return null;
					var num = p.number || p.phone || '';
					if (!num) return null;

					var digits = _cleanPhoneDigits(num);
					var metaBits = [];
					if (p.type) metaBits.push(String(p.type));
					//if (p.lastReportedDate) metaBits.push('last seen ' + String(p.lastReportedDate));
					var meta = metaBits.length ? metaBits.join(' · ') : '';

					return { number: String(num), digits: digits, meta: meta };
				})
				.filter(function (x) { return x && x.number; });

			// unique by number (case-insensitive is fine)
			var seenP = {};
			var uniqPhones = [];
			for (i = 0; i < topPhones.length; i++) {
				var pn = topPhones[i].number;
				var k = pn.replace(/\s+/g, '').toLowerCase();
				if (seenP[k]) continue;
				seenP[k] = true;
				uniqPhones.push(topPhones[i]);
				if (uniqPhones.length >= 3) break;
			}

			var topEmails = _rankEmails(emails)
				.map(function (e) {
					if (!e) return null;
					var addr = e.email || e.address || '';
					if (!addr || String(addr).indexOf('@') === -1) return null;
					return String(addr);
				})
				.filter(function (x) { return x; });

			var uniqEmails = _uniqueStrings(topEmails).slice(0, 3);

			var name = node.name || '';
			if (!name && personNode && personNode.name) {
				var n = personNode.name;
				name = [n.firstName, n.middleName, n.lastName].filter(function (x) { return x; }).join(' ');
			}

			if (!name && (!uniqPhones.length) && (!uniqEmails.length)) return null;

			return {
				roleKey: roleKey,
				roleLabel: roleLabel,
				name: name,
				phones: uniqPhones,
				emails: uniqEmails
			};
		}

		function _buildAcrisDocUrl(docId) {
			if (!docId) return '';
			return 'https://a836-acris.nyc.gov/DS/DocumentSearch/DocumentImageView?doc_id=' + encodeURIComponent(String(docId));
		}

		var rows = _summaryRows(summary);

		// Contact cards (match email roles)
		var contactCards = [];
		var c1 = _extractContactCard('AuthorizedSignatory', 'Authorized signatory');
		var c2 = _extractContactCard('BuyerPersonName', 'Buyer person name');
		if (c1) contactCards.push(c1);
		if (c2) contactCards.push(c2);

		var docId = (this.props && this.props.doc_id) ? this.props.doc_id : '';
		if (!docId && summary && summary.doc_id) docId = summary.doc_id;
		if (!docId && summary && summary.DocId) docId = summary.DocId;
		if (!docId && result && result.doc_id) docId = result.doc_id;

		var docUrl = _buildAcrisDocUrl(docId);

		if ((!loading && !streaming && !err) && (!rows || rows.length === 0) && (!contactCards || contactCards.length === 0)) {
			return null;
		}

		return (
			<div style={{ marginTop: 18 }}>
				<div className="skiptrace-profile-card skiptrace-profile-card--ai" style={{ marginTop: 10 }}>
					{/* Header */}
					<div className="">
						<div className="skiptrace-profile-header-main">
							<div className="skiptrace-section-title">
								<ACRISIcon style={{ marginTop: -3, marginRight: 5 }} />
								Financial Document Analysis (AI Research)
							</div>

							<div className="skiptrace-profile-meta-row">
								<span className="skiptrace-profile-meta-label">
									AI-assisted review of financial and legal documents to identify ownership, control, and financial relationships.
								</span>
							</div>
						</div>
					</div>

					<div className="skiptrace-profile-divider" />

					{/* Body */}
					{(loading || streaming) ? (
						<div className="skiptrace-profile-body skiptrace-profile-body--loading">
							<div style={{ width: "100%" }}>
								<LinearLoading />

								<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: 8, gap: 12 }}>
									<div style={{ flex: 1 }}>
										<p className="skiptrace-loading-text" style={{ marginBottom: 10 }}>
											{this.state.acris_status || "Reviewing documents and mapping relationships…"}
										</p>
									</div>
								</div>

								<div className="skiptrace-background-action">
									<Button
										variant="contained"
										size=""
										color="primary"
										onClick={function (e) {
											e.preventDefault();
											e.stopPropagation();
											this._sendAcrisToBackground({ closeModal: true });
										}.bind(this)}
										style={{ whiteSpace: "nowrap" }}
									>
										Run in background
									</Button>

									<div style={{ fontSize: 16, color: "#6b7280", lineHeight: "1.35" }}>
										Continue working while we finish the analysis. Results are saved to your account and emailed when ready.
									</div>
								</div>
							</div>
						</div>
					) : null}

					{err ? (
						<div className="skiptrace-profile-body" style={{ paddingTop: 10 }}>
							<div style={{ color: "red" }}>{err}</div>
						</div>
					) : null}

					{/* Doc ID link (same as email) */}
					{(!loading && !streaming && !err && docId && docUrl) ? (
						<div className="skiptrace-profile-body" style={{ marginTop: 6 }}>
							<div style={{ fontSize: 13, color: "#6b7280" }}>
								Doc ID:{" "}
								<a
									href={docUrl}
									target="_blank"
									rel="noopener noreferrer"
									onClick={function (e) { e.stopPropagation(); }}
									style={{ color: "#111827", textDecoration: "underline", fontWeight: 700 }}
								>
									{docId}
								</a>
							</div>
						</div>
					) : null}

					{/* Contacts (match email content) */}
					{(!loading && !streaming && !err && contactCards && contactCards.length > 0) ? (
						<div className="skiptrace-profile-body" style={{ marginTop: 6 }}>
							<div>

								<div style={{ display: "flex", gap: 10 }}>
									{contactCards.map(function (c, idx) {
										return (
											<div
												key={"acris_contact_" + idx}
												style={{
													border: "1px solid #e5e7eb",
													borderRadius: 12,
													padding: 12,
													background: "#fff",
													minWidth: 200,
													background: '#F5F7FA'
												}}
											>
												<div style={{ fontSize: 13, fontWeight: 800 }}>{c.roleLabel}</div>
												{c.name ? (
													<div style={{ marginTop: 6, fontSize: 14, fontWeight: 700 }}>{c.name}</div>
												) : null}

												<div style={{ marginTop: 8, fontSize: 13, color: "#374151", lineHeight: "1.6" }}>
													<div>
														<span style={{ fontWeight: 800 }}>Phones:</span>{" "}
														{c.phones && c.phones.length ? (
															<span>
																{c.phones.slice(0, 3).map(function (p, pidx) {
																	var href = p.digits ? ("tel:+" + p.digits) : null;

																	return (
																		<span key={"acris_phone_" + idx + "_" + pidx}>
																			{pidx > 0 ? ", " : ""}
																			{href ? (
																				<a
																					href={href}
																					onClick={function (e) { e.stopPropagation(); }}
																					style={{ color: "#111827", textDecoration: "underline" }}
																				>
																					{p.number}
																				</a>
																			) : (
																				<span>{p.number}</span>
																			)}
																			{p.meta ? (
																				<span style={{ color: "#6b7280" }}>{" "}({p.meta})</span>
																			) : null}
																		</span>
																	);
																})}
															</span>
														) : (
															<span style={{ color: "#6b7280" }}>Not found</span>
														)}
													</div>

													<div style={{ marginTop: 6 }}>
														<span style={{ fontWeight: 800 }}>Emails:</span>{" "}
														{c.emails && c.emails.length ? (
															<span>
																{c.emails.slice(0, 3).map(function (em, eidx) {
																	return (
																		<span key={"acris_email_" + idx + "_" + eidx}>
																			{eidx > 0 ? ", " : ""}
																			<a
																				href={"mailto:" + em}
																				onClick={function (e) { e.stopPropagation(); }}
																				style={{ color: "#111827", textDecoration: "underline" }}
																			>
																				{em}
																			</a>
																		</span>
																	);
																})}
															</span>
														) : (
															<span style={{ color: "#6b7280" }}>Not found</span>
														)}
													</div>
												</div>
											</div>
										);
									})}
								</div>
							</div>
						</div>
					) : null}

					<hr />

					{/* Summary */}
					{(!loading && !streaming && rows && rows.length > 0) ? (
						<div className="skiptrace-profile-body" style={{ marginTop: 6 }}>
							<div>


								<div style={{ display: "grid", gridTemplateColumns: "1fr 1.4fr", gap: 10 }}>
									{rows.map(function (r, idx) {
										return (
											<Fragment key={"acris_row_" + idx}>
												<div style={{ fontWeight: 600 }}>{r.key}</div>
												<div>{r.value}</div>
											</Fragment>
										);
									})}
								</div>
							</div>
						</div>
					) : null}

					{(!loading && !streaming && !err && (!rows || rows.length === 0) && (!contactCards || contactCards.length === 0)) ? (
						<div className="skiptrace-profile-body">
							<div style={{ fontSize: 13, color: "#6b7280" }}>
								No owner details found yet.
							</div>
						</div>
					) : null}
				</div>
			</div>
		);
	}





	_initPersonFlow() {
		var self = this;
		this.setState(function (prev) {
			var next = self._resetPersonState();
			next.request_state = self.props.state || '';
			// clear company block
			next.company_loading = false;
			next.company_error = null;
			next.company_result = null;
			return next;
		});
	}

	// ===============================
	// Company flow
	// ===============================
	_fmtDate(iso) {
		if (!iso) return '';
		var d = new Date(iso);
		if (isNaN(d.getTime())) return '';
		var mm = (d.getMonth() + 1); if (mm < 10) mm = '0' + mm;
		var dd = d.getDate(); if (dd < 10) dd = '0' + dd;
		return d.getFullYear() + '-' + mm + '-' + dd;
	}

	_runCompanyLookup() {
		var self = this;

		// If already started, treat as done (init flow resets state anyway)
		if (self.state.company_lookup_started) {
			return Promise.resolve(self.state.company_result || null);
		}

		self.setState({ company_lookup_started: true });

		var name = (self.props.triggerDisplay || '').trim();
		if (!name) {
			self.setState({ company_error: 'Missing company name.', company_loading: false });
			return Promise.reject(new Error('Missing company name'));
		}

		self.setState({ company_loading: true, company_error: null, company_result: null });

		var userData = {
			url: apiRoot + '/skip/ny-dos/entity-search?cache=true',
			method: 'post',
			query: { search_value: name }
		};

		return _axiosCall(userData)
			.then(function (res) {
				var data = res && res.data ? res.data : res;

				return new Promise(function (resolve) {
					if (data && data.totalMatchingCount && data.totalMatchingCount > 0) {
						self.setState(
							{ company_result: data || {}, company_loading: false },
							function () { resolve(data || {}); }
						);
					} else {
						self.setState(
							{ company_result: false, company_loading: false },
							function () { resolve(false); }
						);
					}
				});
			})
			.catch(function (error) {
				var msg = error && error.message ? error.message : 'Request failed';
				if (error && error.data) { try { msg = JSON.stringify(error.data); } catch (e) { } }

				return new Promise(function (resolve, reject) {
					self.setState({ company_error: msg, company_loading: false }, function () {
						reject(error);
					});
				});
			});
	}



	_padLeft(num, size) {
		num = String(num || '');
		while (num.length < size) num = '0' + num;
		return num;
	}

	_runCompanyOwnerLookup() {
		var self = this;

		// If already started, treat as done
		if (self.state.owner_lookup_started) {
			return Promise.resolve(self.state.company_result || null);
		}

		var borough = self.props.borough_code || '';
		var block = self._padLeft(self.props.block, 5);
		var lot = self._padLeft(self.props.lot, 4);
		if (!borough || !block || !lot) {
			if (typeof console !== 'undefined' && console.warn) {
				console.warn('Missing borough/block/lot for owner lookup');
			}
			return Promise.reject(new Error('Missing borough/block/lot for owner lookup'));
		}

		var bbl = borough + block + lot;
		if (self.state.last_owner_bbl === bbl) {
			// already did this BBL
			return Promise.resolve(self.state.company_result || null);
		}

		self.setState({ owner_lookup_started: true, last_owner_bbl: bbl, owner_loading: true });

		var stmtUrl =
			'https://a836-edms.nyc.gov/dctm-rest/repositories/dofedmspts/StatementSearch?bbl=' +
			bbl +
			'&stmtDate=20250816&stmtType=SOA';

		var userData = {
			url: (aiAnalyzeRoot + '/analyze-pdf-url'),
			method: 'post',
			query: {
				url: stmtUrl,
				message: 'Extract the owner name and mailing address from this statement.'
			}
		};

		return _axiosCall(userData)
			.then(function (res) {
				var updated = Object.assign({}, self.state.company_result || {});
				updated.ownerExtract = res;

				return new Promise(function (resolve) {
					self.setState({ company_result: updated, owner_loading: false }, function () {
						resolve(updated);
					});
				});
			})
			.catch(function (err) {
				if (typeof console !== 'undefined' && console.warn) console.warn('Owner lookup failed', err);
				// Still stop loading even if failed
				self.setState({ owner_loading: false });
				return Promise.reject(err);
			});
	}


	_runCompanyLookupThenOwnerThenAcris() {
		var self = this;

		// If you already have saved hydration logic, you can short-circuit here.
		// For example, if acris_lookup_started is true and you don't want reruns.
		if (self.state.acris_loading) return;

		self._runCompanyLookup()
			.then(function () {
				return self._runCompanyOwnerLookup();
			})
			.then(function () {
				// IMPORTANT: run AFTER the owner lookup setState callback has fired
				self._runAcrisAnalyze();
			})
			.catch(function (err) {
				console.log('company flow failed:', err && err.message ? err.message : err);
				// optionally set an error
				self.setState({
					company_error: (err && err.message) ? err.message : 'Company flow failed'
				});
			});
	}






	// ===============================
	// Person flow
	// ===============================
	_runSimple(doFull, requestId) {
		const creditType = 'contact';
		var requiredCredits = this._getRequiredCreditsForContact(creditType);
		var body = {
			first_name: this.props.first_name || '',
			last_name: this.props.last_name || '',
			address_1: this.props.address_1 || '',
			address_2: this.props.address_2 || '',
			city: this.props.city || '',
			county: this.props.county || '',
			state: this.props.state || '',
			zip: this.props.zip || '',
			credits_used: requiredCredits,
			credit_type: 'premium',
			premium_service_id: creditType,
			user: this.props.user
		};

		var userData = {
			url: (this.props.simpleUrl && this.props.simpleUrl.trim().length > 0)
				? this.props.simpleUrl
				: apiRoot + '/skip/skip-trace-simple?cache=true',
			method: 'post',
			query: body
		};

		var self = this;
		this.setState({ simple_loading: true, simple_error: null, simple_person: null, hasSearched: true });

		_axiosCall(userData)
			.then(function (res) {
				var payload = res && res.person ? res : (res && res.data ? res.data : res) || {};
				var person = payload.person || null;

				if (person) {
					self.setState({ simple_person: person, simple_loading: false });

					if (doFull) {
						self._runWorkplaceTrace(person);
					} else {
						// request guard: do not save if a new request started
						if (self.state.active_request_id !== requestId) return;

						// save guard: do not save twice
						if (self.state.saved_this_request) return;

						self.setState({ saved_this_request: true });
						self._saveSkipTraceToAccount('contact', {
							simple_person: person,
							// optional: include any raw response you want for “view later”
							// raw_simple_response: res
						}).then(function () {
							return self._deductCreditsAfterSave('profile');
						})
							.catch(function (err) {
								console.log('save skip trace error:', err && err.message ? err.message : err);
							});
					}
				} else {
					self.setState({ simple_loading: false });
					self._runDeep(doFull, requestId);
				}

			})
			.catch(function (error) {
				var msg = error && error.message ? error.message : 'Request failed';
				if (error && error.data) { try { msg = JSON.stringify(error.data); } catch (e) { } }
				self.setState({ simple_error: msg, simple_loading: false, hasSearched: true }, function () {
					// On error, try deep as a fallback
					self._runDeep();
				});
			});
	}


	_runDeep(doFull, requestId) {
		const creditType = 'contact';
		var requiredCredits = this._getRequiredCreditsForContact(creditType);
		if (this.state.deep_loading) return;

		var sp = this.state.simple_person || null;
		var ageVal = (sp && typeof sp.age !== 'undefined' && sp.age !== null) ? String(sp.age) : '';
		var ageRange = ageVal ? (ageVal + '-' + ageVal) : '';
		var emailVal = '';
		if (sp && sp.emails && sp.emails.length > 0) {
			emailVal = sp.emails[0] && sp.emails[0].email ? sp.emails[0].email : '';
		}
		var phoneVal = '';
		if (sp && sp.phones && sp.phones.length > 0) {
			var rawPhone = (sp.phones[0] && sp.phones[0].number) ? sp.phones[0].number : '';
			var digits = rawPhone.replace(/\D/g, '');
			if (digits.length === 11 && digits.indexOf('1') === 0) digits = digits.substring(1);
			if (digits.length === 10) {
				phoneVal = '(' + digits.substring(0, 3) + ') ' + digits.substring(3, 6) + '-' + digits.substring(6);
			} else {
				phoneVal = rawPhone;
			}
		}

		var body = {
			first_name: this.props.first_name || '',
			last_name: this.props.last_name || '',
			address_1: this.props.address_1 || '',
			address_2: this.props.address_2 || '',
			city: this.props.city || '',
			county: this.props.county || '',
			state: this.props.state || '',
			zip: this.props.zip || '',
			age: ageRange,
			email: emailVal,
			phone: phoneVal,
			credits_used: requiredCredits,
			credit_type: 'premium',
			premium_service_id: creditType,
			user: this.props.user
		};

		var self = this;
		self.setState({ deep_loading: true, deep_error: null, hasSearched: true });

		var userData = {
			url: apiRoot + '/skip/skip-trace?cache=true',
			method: 'post',
			query: body
		};

		_axiosCall(userData)
			.then(function (res) {
				var persons = res && res.persons ? res.persons : [];
				if (persons.length > 0) {
					var filtered = pickBestPerson(
						persons,
						body.first_name,
						body.last_name,
						body.state,
						body.address_1,
						body.address_2,
						body.city,
						body.zip
					);

					console.log(filtered)

					let owner = mapPersonToOwnerFormat(filtered);

					self.setState({ simple_person: owner, simple_loading: false, deep_loading: false });


					if (doFull) {
						self._runWorkplaceTrace(owner);
					} else {

						if (self.state.active_request_id !== requestId) return;

						// save guard: do not save twice
						if (self.state.saved_this_request) return;

						self.setState({ saved_this_request: true });
						self._saveSkipTraceToAccount('contact', {
							simple_person: owner,
							// optional: include any raw response you want for “view later”
							// raw_simple_response: res
						}).then(function () {
							return self._deductCreditsAfterSave('contact');
						})
							.catch(function (err) {
								console.log('save skip trace error:', err && err.message ? err.message : err);
							});;
					}
				} else {
					self.setState({ deep_persons: persons, simple_loading: false, deep_loading: false });
				}


			})
			.catch(function (error) {
				var msg = error && error.message ? error.message : 'Request failed';
				if (error && error.data) { try { msg = JSON.stringify(error.data); } catch (e) { } }
				self.setState({ deep_error: msg, deep_loading: false });
			});
	}

	// Workplace Deep Search
	// Run workplace trace, but call PDL first using the basic-search person
	_runWorkplaceTrace(personFromBasicSearch) {
		var self = this;
		var sp = personFromBasicSearch || this.state.simple_person || null;

		// If we already have a PDL result, skip workplaceTrace and just build full profile
		if (this.state.pdl_result && this.state.pdl_result.experience && this.state.pdl_result.experience.length > 0) {
			if (this.state.lookup_mode === 'full') {
				this._runProfileAI();
			}
			return;
		}

		// 1) Try PDL first, using the basic-search person as the primary input
		this._loadPDL(sp).then(function (pdlData) {
			var hasPDL =
				pdlData &&
				(
					typeof pdlData.first_name !== 'undefined' && pdlData.experience && pdlData.experience.length > 0
				);

			// If PDL found something, skip workplaceTrace and go straight to AI (for full mode)
			if (hasPDL) {
				if (self.state.lookup_mode === 'full') {
					self._runProfileAI();
				}
				return;
			}

			// 2) No PDL match, run existing workplaceTrace flow as a fallback
			const creditType = 'profile';
			var requiredCredits = !hasPDL ? self._getRequiredCreditsForContact(creditType) : 0;
			if (self.state.workplace_loading) return;

			var firstName = self.props.first_name || '';
			var lastName = self.props.last_name || '';
			var city = self.props.city || '';
			var state = self.props.state || '';

			// Prefer name and address from basic-search person if present
			if (sp && sp.name) {
				if (sp.name.firstName) firstName = sp.name.firstName;
				if (sp.name.lastName) lastName = sp.name.lastName;
			}

			if (sp && sp.addresses && sp.addresses.length > 0) {
				var a0 = sp.addresses[0] || {};
				if (a0.city) city = a0.city;
				if (a0.state) state = a0.state;
			}

			// Phone from basic-search person if possible
			var phone = '';
			if (sp && sp.phones && sp.phones.length > 0) {
				var rawPhone = sp.phones[0] && sp.phones[0].number ? sp.phones[0].number : '';
				var digits = rawPhone.replace(/\D/g, '');
				if (digits.length === 11 && digits.indexOf('1') === 0) digits = digits.substring(1);
				if (digits.length === 10) {
					phone = '(' + digits.substring(0, 3) + ') ' + digits.substring(3, 6) + '-' + digits.substring(6);
				} else {
					phone = rawPhone;
				}
			}

			var body = {
				first_name: firstName,
				//middle_name: middle,
				last_name: lastName,
				city: city,
				state: state,
				//zip: zip,
				phone: phone,
				business_name: (self.props.business_name || '').trim(),
				page: 1,
				results_per_page: 10,
				credits_used: requiredCredits,
				credit_type: 'premium',
				premium_service_id: creditType,
				user: self.props.user
			};

			self.setState({ workplace_loading: true, workplace_error: null, hasSearched: true });

			var userData = {
				url: apiRoot + '/skip/skip-trace-workplace?cache=true',
				method: 'post',
				query: body
			};

			_axiosCall(userData)
				.then(function (res) {
					var data = res && res.data ? res.data : res;
					var records = data && data.workplaceRecords ? data.workplaceRecords : [];
					if (records.length > 0) {
						body['phone'] = phone;
						var bestRecord = pickBestWorkplaceRecord(body, records);
						self.setState({ workplace_records: [bestRecord], workplace_loading: false });

					} else {
						self.setState({ workplace_records: records, workplace_loading: false });
					}

					if (self.state.lookup_mode === 'full') {
						self._runProfileAI();
					}
				})
				.catch(function (error) {
					var msg = error && error.message ? error.message : 'Request failed';
					if (error && error.data) {
						try { msg = JSON.stringify(error.data); } catch (e) { }
					}
					self.setState({ workplace_error: msg, workplace_loading: false });
				});
		});
	}

	// PDL lookup; now accepts personLike and returns a Promise
	_loadPDL(personLike) {
		if (this.state.pdl_loading) {
			return Promise.resolve(null);
		}
		var self = this;
		const creditType = 'profile';
		var requiredCredits = self._getRequiredCreditsForContact(creditType);

		var p = personLike || {};
		var nameObj = p.name || {};
		var primaryAddr = null;
		if (p.addresses && p.addresses.length > 0) {
			primaryAddr = p.addresses[0];
		}

		var primaryEmail = '';
		if (p.emails && p.emails.length > 0) {
			var e0 = p.emails[0];
			if (e0 && e0.email) {
				primaryEmail = e0.email;
			}
		}

		var primaryPhone = '';
		if (p.phones && p.phones.length > 0) {
			var rawPhone = p.phones[0] && p.phones[0].number ? p.phones[0].number : '';
			var digits = rawPhone.replace(/\D/g, '');
			if (digits.length === 11 && digits.indexOf('1') === 0) digits = digits.substring(1);
			if (digits.length === 10) {
				primaryPhone = '(' + digits.substring(0, 3) + ') ' + digits.substring(3, 6) + '-' + digits.substring(6);
			} else {
				primaryPhone = rawPhone;
			}
		}

		var addr1 =
			(primaryAddr && (primaryAddr.street || primaryAddr.addressLine1 || primaryAddr.AddressLine1)) ||
			this.props.address_1 ||
			'';
		var city =
			(primaryAddr && (primaryAddr.city || primaryAddr.City)) ||
			this.props.city ||
			'';
		var state =
			(primaryAddr && (primaryAddr.state || primaryAddr.State)) ||
			this.props.state ||
			'';
		var zip =
			(primaryAddr &&
				(primaryAddr.zip ||
					primaryAddr.Zip ||
					primaryAddr.postalCode ||
					primaryAddr.PostalCode)) ||
			this.props.zip ||
			'';

		var body = {
			first_name: this.props.first_name || '',
			last_name: this.props.last_name || '',
			address_1: addr1,
			address_2: this.props.address_2 || '',
			city: city,
			state: state,
			zip: zip,
			email: primaryEmail || this.props.email || '',
			phone: primaryPhone || this.props.phone || '',
			location: this.props.location || '',
			company: this.props.company || '',
			linkedin_url: this.props.linkedin_url || '',
			credits_used: requiredCredits,
			credit_type: 'premium',
			premium_service_id: creditType,
			user: self.props.user
		};

		var userData = {
			url: (this.props.url && this.props.url.trim().length > 0)
				? this.props.url
				: apiRoot + '/skip/skip-trace-pdl?cache=true',
			method: 'post',
			query: body
		};

		var self = this;
		this.setState({
			pdl_loading: true,
			error: null,
			pdl_result: null
		});

		return _axiosCall(userData)
			.then(function (res) {
				var data = res && res.data ? res.data : res;
				var hasMatch = false;
				console.log(data)
				if (res && typeof res.likelihood !== 'undefined') {
					hasMatch = true;
				}
				if (!hasMatch && data && data.data && typeof data.data.likelihood !== 'undefined') {
					hasMatch = true;
				}

				if (hasMatch) {

					self.setState({
						pdl_result: data,
						pdl_loading: false,
						error: null
					});
					return data;
				}

				self.setState({
					pdl_loading: false,
					error: 'No People Data Labs match found.',
					pdl_result: null
				});
				return null;
			})
			.catch(function (error) {
				var msg = error && error.message ? error.message : 'Request failed';
				if (error && error.data) {
					try { msg = JSON.stringify(error.data); } catch (e) { }
				}
				self.setState({
					pdl_loading: false,
					error: msg,
					pdl_result: null
				});
				return null;
			});
	}


	// Fire both deep lookups
	_runDeepAll() {
		if (!this.state.workplace_loading) this._runWorkplaceTrace();
		if (!this.state.deep_loading) this._runDeep();
	}

	_toggleDeepRow(idx) {
		var expanded = Object.assign({}, this.state.deep_expanded);
		expanded[idx] = !expanded[idx];
		this.setState({ deep_expanded: expanded });
	}

	// Runs workplace trace for a specific deep result index
	_runWorkplaceForIndex(idx) {
		if (this.state.wp_loading_index === idx) return;

		var p = (this.state.deep_persons && this.state.deep_persons[idx]) ? this.state.deep_persons[idx] : null;
		if (!p) return;

		// Pull best-guess fields from this deep person
		var firstName = (p.name && p.name.firstName) ? p.name.firstName : (this.props.first_name || '');
		var lastName = (p.name && p.name.lastName) ? p.name.lastName : (this.props.last_name || '');
		var middle = (p.name && p.name.middleName) ? p.name.middleName : '';
		var a0 = (p.addresses && p.addresses[0]) ? p.addresses[0] : {};
		var city = a0.city || a0.City || this.props.city || '';
		var state = a0.state || a0.State || this.props.state || '';
		var zip = a0.zip || a0.Zip || a0.postalCode || a0.PostalCode || this.props.zip || '';

		var phone = '';
		if (p.phoneNumbers && p.phoneNumbers.length > 0) {
			var rawPhone = p.phoneNumbers[0] && (p.phoneNumbers[0].phoneNumber || p.phoneNumbers[0].number) ? (p.phoneNumbers[0].phoneNumber || p.phoneNumbers[0].number) : '';
			var digits = rawPhone.replace(/\D/g, '');
			if (digits.length === 11 && digits.indexOf('1') === 0) digits = digits.substring(1);
			if (digits.length === 10) {
				phone = '(' + digits.substring(0, 3) + ') ' + digits.substring(3, 6) + '-' + digits.substring(6);
			} else {
				phone = rawPhone;
			}
		}

		var body = {
			first_name: firstName,
			middle_name: middle,
			last_name: lastName,
			city: city,
			state: state,
			zip: zip,
			phone: phone,
			business_name: (this.props.business_name || '').trim(),
			page: 1,
			results_per_page: 10
		};

		var self = this;
		var userData = {
			url: apiRoot + '/skip/skip-trace-workplace?cache=true',
			method: 'post',
			query: body
		};

		this.setState({ wp_loading_index: idx }, function () {
			_axiosCall(userData)
				.then(function (res) {
					var data = res && res.data ? res.data : res;
					var records = data && data.workplaceRecords ? data.workplaceRecords : [];
					var map = Object.assign({}, self.state.wp_by_index);
					map[idx] = records;
					var errs = Object.assign({}, self.state.wp_error_by_index);
					delete errs[idx];
					self.setState({ wp_by_index: map, wp_loading_index: null, wp_error_by_index: errs });
				})
				.catch(function (error) {
					var msg = error && error.message ? error.message : 'Request failed';
					if (error && error.data) { try { msg = JSON.stringify(error.data); } catch (e) { } }
					var errs = Object.assign({}, self.state.wp_error_by_index);
					errs[idx] = msg;
					self.setState({ wp_error_by_index: errs, wp_loading_index: null });
				});
		});
	}

	_renderDeepResultsList() {
		var self = this;
		var persons = this.state.deep_persons || [];
		if (!persons.length) return <p style={{ fontSize: 15, marginBottom: 0 }}>No matching persons</p>;

		return persons.slice(0, 5).map(function (p, idx) {
			// Basic summary fields (similar to SkipTraceModal)
			var first = p && p.name && p.name.firstName ? p.name.firstName : '';
			var last = p && p.name && p.name.lastName ? p.name.lastName : '';
			var age = p.age || (p.dob && p.dob.age) || '';

			var lastAddr = '';
			var addrs = p && p.addresses ? p.addresses : [];
			if (addrs && addrs.length > 0) {
				var a = addrs[0] || {};
				var line = a.fullAddress || a.FullAddress || '';
				if (!line) {
					var a1 = a.addressLine1 || a.AddressLine1 || a.streetLine1 || '';
					var a2 = a.addressLine2 || a.AddressLine2 || a.streetLine2 || '';
					var city = a.city || a.City || '';
					var state = a.state || a.State || '';
					var zip = a.zip || a.Zip || a.postalCode || a.PostalCode || '';
					var parts = [];
					if (a1) parts.push(a1);
					if (a2) parts.push(a2);
					var loc = [];
					if (city) loc.push(city);
					if (state) loc.push(state);
					var locStr = loc.join(', ');
					if (locStr) parts.push(locStr + (zip ? ' ' + zip : ''));
					line = parts.join(', ');
				}
				lastAddr = line || '';
			}

			var isOpen = !!self.state.deep_expanded[idx];

			return (
				<div
					key={'deep_row_' + idx}
					style={{ border: '1px solid #ddd', borderRadius: 8, padding: 12, marginBottom: 10 }}
				>
					{/* Main row */}
					<div
						style={{
							display: 'grid',
							gridTemplateColumns: '0.8fr 0.8fr 2.2fr 0.8fr auto',
							gap: 8,
							alignItems: 'start'
						}}
					>
						<div style={{ fontSize: 14 }}>
							<strong>First Name:</strong><br /> {first || '-'}
						</div>
						<div style={{ fontSize: 14 }}>
							<strong>Last Name:</strong><br /> {last || '-'}
						</div>
						<div style={{ fontSize: 14 }}>
							<strong>Last Address:</strong><br /> {lastAddr || '-'}
						</div>
						<div style={{ fontSize: 14 }}>
							<strong>Age:</strong><br /> {age || '-'}
						</div>
						<div style={{ textAlign: 'right', alignSelf: 'center' }}>
							<Button
								size="small"
								variant="outlined"
								onClick={function (e) { e.preventDefault(); self._toggleDeepRow(idx); }}
							>
								{isOpen ? 'Hide' : 'Details'}
							</Button>
						</div>
					</div>

					{/* Expanded */}
					{isOpen && (
						<div style={{ marginTop: 12, padding: '12px 16px', background: '#fafafa', borderRadius: 8 }}>
							{/* Simple-style summary card built from deep person */}
							{self._renderSimpleContactCard(self._toSimpleShapeFromDeep(p))}

							{/* Per-row workplace search */}
							<div className={"dashboard"} style={{ textAlign: 'center', marginTop: 8 }}>
								{self.state.wp_loading_index === idx ? (
									<div style={{ maxWidth: 260, margin: '0 auto' }}>
										<LinearLoading />
										<p>Running search…</p>
									</div>
								) : (
									<Button
										onClick={function (e) { e.preventDefault(); self._runWorkplaceForIndex(idx); }}
										variant="contained"
										color="secondary"
										className="buyersList__secondary-button"
										startIcon={<CompanyIcon />}
										style={{ minWidth: 175 }}
									>
										Get Work and Education
									</Button>
								)}
								{self.state.wp_error_by_index[idx] ? <p style={{ color: 'red' }}>{self.state.wp_error_by_index[idx]}</p> : null}
							</div>

							{/* Inline workplace results for this row */}
							{(self.state.wp_by_index[idx] && self.state.wp_by_index[idx].length > 0)
								? self._renderWorkplaceSection(self.state.wp_by_index[idx])
								: null}

							{/* Optional link to reveal the original detailed deep profile */}
							{self._renderShowFullProfileLink(idx, p)}
						</div>
					)}
				</div>
			);
		});
	}



	// ===============================
	// Shared formatting + links
	// ===============================
	_formatAddressSimple(a) {
		if (!a) return '';
		var street = a.street || '';
		var unit = a.unit || '';
		var city = a.city || '';
		var state = a.state || '';
		var zip = a.zip || '';
		var parts = [];
		if (street) parts.push(street + (unit ? ', ' + unit : ''));
		if (city || state) parts.push(city + (city && state ? ', ' : '') + state);
		if (zip) parts.push(zip);
		return parts.join(', ');
	}

	_mailto(email) {
		var e = (email || '').trim();
		return 'mailto:' + encodeURIComponent(e);
	}
	_tel(num) {
		var s = (num || '').trim();
		var cleaned = s.replace(/(?!^\+)[^\d]/g, '');
		return 'tel:' + cleaned;
	}
	_mapsSearch(addrObj) {
		var q = (addrObj && addrObj.street) ? this._formatAddressSimple(addrObj) : addrObj;
		return 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(q);
	}
	_formatPhoneDisplay(num) {
		var s = (num || '').replace(/[^\d]/g, '');
		if (s.length === 11 && s.indexOf('1') === 0) s = s.substring(1);
		if (s.length === 10) return '(' + s.substring(0, 3) + ') ' + s.substring(3, 6) + '-' + s.substring(6);
		return num || '-';
	}

	// small presentational helper
	_ListItem(props) {
		var icon = props.icon;
		var href = props.href;
		var target = props.target || (href && href.indexOf('http') === 0 ? '_blank' : null);
		var rel = target === '_blank' ? 'noopener noreferrer' : null;
		var meta = props.meta;
		var noBullet = props.noBullet;
		return (
			<li style={{ listStyle: 'none', margin: '6px 0' }}>
				<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
					{!noBullet ? <ChevronRightIcon size={16} color="#9aa4b2" /> : null}
					{icon}
					<div>
						{href
							? <a href={href} target={target} rel={rel} className={'link-text'} style={{ textDecoration: 'none', whiteSpace: 'nowrap' }}>{props.children}</a>
							: <span>{props.children}</span>}
						{meta ? <div>{meta}</div> : null}
					</div>
				</div>
			</li>
		);
	}

	// deep person format helpers
	_formatAddressFullDeep(addr) {
		if (!addr) return '';
		var a1 = addr.addressLine1 || addr.AddressLine1 || addr.streetLine1 || '';
		var a2 = addr.addressLine2 || addr.AddressLine2 || addr.streetLine2 || '';
		var city = addr.city || addr.City || '';
		var state = addr.state || addr.State || '';
		var zip = addr.zip || addr.Zip || addr.postalCode || '';
		var full = addr.fullAddress || addr.FullAddress || '';
		var line = full && full.trim().length > 0
			? full
			: (a1 + (a2 ? ', ' + a2 : '') + (city ? ', ' + city : '') +
				(state ? ', ' + state : '') + (zip ? ' ' + zip : ''));
		var f = addr.firstReportedDate || '';
		var l = addr.lastReportedDate || '';
		var range = (f || l) ? (' [' + (f || '') + ' - ' + (l || '') + ']') : '';
		return line + range;
	}

	_formatPhoneLine(ph) {
		if (!ph) return '-';
		var num = ph.phoneNumber || ph.number || '-';
		var type = ph.phoneType || ph.type || '';
		var co = ph.company || '';
		var connected = typeof ph.isConnected === 'boolean'
			? (ph.isConnected ? 'active' : 'inactive') : '';
		var f = ph.firstReportedDate || '';
		var l = ph.lastReportedDate || '';
		var bits = [];
		bits.push(num);
		if (type) bits.push('(' + type + ')');
		if (co) bits.push(co);
		if (connected) bits.push(connected);
		if (f || l) bits.push('[' + (f || '') + ' - ' + (l || '') + ']');
		return bits.join(' ');
	}

	_renderList(arr, renderItem) {
		if (!arr || arr.length === 0) return (<p style={{ margin: 0 }}>-</p>);
		return (
			<ul style={{ paddingLeft: 16, margin: 0 }}>
				{arr.map(function (item, i) { return (<li key={i}>{renderItem(item, i)}</li>); })}
			</ul>
		);
	}

	// workplace render helpers
	_renderEmployment(arr, title) {
		if (!arr || arr.length === 0) return null;
		return (
			<div style={{ marginTop: 14 }}>
				<p style={{ fontWeight: 600, margin: '0 0 6px' }}>{title}</p>
				<div>
					{arr.map(function (job, i) {
						var employer = job && job.employer ? job.employer : '';
						var jobTitle = job && job.jobTitle ? job.jobTitle : '';
						var dept = job && job.department ? job.department : '';
						var level = job && job.level ? job.level : '';
						var address = job && job.fullAddress ? job.fullAddress : ((job && (job.city || job.state)) ? (job.city + (job.city && job.state ? ', ' : '') + job.state) : '');
						var dur = job && job.duration ? job.duration : '';
						var startD = job && job.startDate ? job.startDate : '';
						var endD = job && job.endDate ? job.endDate : '';
						var website = job && job.website ? job.website : '';
						var social = job && job.social ? job.social : '';
						var size = job && job.size ? job.size : '';
						var revenue = job && job.revenueRange ? job.revenueRange : '';
						var industry = job && job.industry ? job.industry : '';
						var sic = job && job.sic ? job.sic : '';
						var naics = job && job.naics ? job.naics : '';

						return (
							<div key={'emp_' + i} style={{ border: '1px solid #f0f0f0', borderRadius: 8, padding: 10, marginBottom: 8 }}>
								<div style={{ display: 'grid', gridTemplateColumns: '1.2fr 1.2fr 1fr', gap: 8 }}>
									<div>
										<strong>{employer || '-'}</strong><br />
										<span>{jobTitle || '-'}</span>{level ? (', ' + level) : ''}{dept ? (' - ' + dept) : ''}
									</div>
									<div>
										<strong>Address</strong><br />
										<span>{address || '-'}</span>
									</div>
									<div>
										<strong>Tenure</strong><br />
										<span>{dur || ((startD || endD) ? ((startD || '') + (endD ? ' - ' + endD : '')) : '-')}</span>
									</div>
								</div>
								{(industry || size || revenue || sic || naics || website || social) ? (
									<div style={{ marginTop: 8, display: 'flex', flexWrap: 'wrap', gap: 12 }}>
										{industry ? <span><strong>Industry:</strong> {industry}</span> : null}
										{size ? <span><strong>Size:</strong> {size}</span> : null}
										{revenue ? <span><strong>Revenue:</strong> {revenue}</span> : null}
										{sic ? <span><strong>SIC:</strong> {sic}</span> : null}
										{naics ? <span><strong>NAICS:</strong> {naics}</span> : null}
										{website ? <a href={website} target="_blank" rel="noopener noreferrer">Website</a> : null}
										{social ? <a href={social} target="_blank" rel="noopener noreferrer">Company Social</a> : null}
									</div>
								) : null}
							</div>
						);
					})}
				</div>
			</div>
		);
	}

	_normalizeWorkExp(workExperience) {
		if (!workExperience || !workExperience.length) return [];
		var sorted = workExperience.slice().sort(function (a, b) {
			var ao = a && a.expJobOrder ? Number(a.expJobOrder) : 0;
			var bo = b && b.expJobOrder ? Number(b.expJobOrder) : 0;
			return ao - bo;
		});
		return sorted.map(function (w) {
			var co = w && w.company ? w.company : {};
			var employer = w && w.expCompany ? w.expCompany : (co && co.companyName ? co.companyName : '');
			var jobTitle = w && w.expJobTitle ? w.expJobTitle : '';
			var duration = w && w.expDuration ? w.expDuration : '';
			var startDate = w && w.expStartDate ? w.expStartDate : '';
			var endDate = w && w.expEndDate ? w.expEndDate : '';
			var fullAddress = co && (co.fullAddress || co.companyAddress1) ? (co.fullAddress || co.companyAddress1) : '';
			if (!fullAddress) {
				var c = co && co.companyCity ? co.companyCity : '';
				var s = co && co.companyState ? co.companyState : '';
				fullAddress = (c || s) ? (c + (c && s ? ', ' : '') + s) : '';
			}
			return {
				employer: employer,
				jobTitle: jobTitle,
				department: '',
				level: '',
				fullAddress: fullAddress,
				city: co && co.companyCity ? co.companyCity : '',
				state: co && co.companyState ? co.companyState : '',
				duration: duration,
				startDate: startDate,
				endDate: endDate,
				website: co && co.companyWebSite ? co.companyWebSite : '',
				social: co && co.companySocialUrl ? co.companySocialUrl : '',
				size: co && co.companySize ? co.companySize : '',
				revenueRange: co && co.revenueRange ? co.revenueRange : '',
				industry: co && (co.companyIndustry || co.industry) ? (co.companyIndustry || co.industry) : '',
				sic: (co && co.sicCode) ? (co.sicCode + (co.sicDescription ? ' ' + co.sicDescription : '')) : '',
				naics: (co && co.naics) ? (co.naics + (co.naicsDescription ? ' ' + co.naicsDescription : '')) : ''
			};
		});
	}

	_renderEducation(education) {
		if (!education || !education.length) return null;

		// Accepts YYYY, YYYY-MM, or YYYY-MM-DD (optionally with time after it).
		// Rejects years < 1900 and zero dates like 0000-.. or 0001-..
		function normalizeDate(val) {
			if (!val) return '';
			if (typeof val !== 'string') val = String(val);

			// Strip any time portion (e.g., "2020-05-01T00:00:00")
			var core = val.split('T')[0].trim();

			// Match YYYY, YYYY-MM, or YYYY-MM-DD
			var m = core.match(/^(\d{4})(?:-(\d{2})(?:-(\d{2}))?)?$/);
			if (!m) return '';

			var year = parseInt(m[1], 10);
			var month = m[2] ? parseInt(m[2], 10) : null;
			var day = m[3] ? parseInt(m[3], 10) : null;

			// Reject zero/placeholder or ancient years
			if (!year || year < 1900) return '';

			// Basic range checks
			if (month !== null && (month < 1 || month > 12)) return '';
			if (day !== null && (day < 1 || day > 31)) return '';

			// Rebuild normalized display (keep the same granularity)
			var out = String(year);
			if (month !== null) out += '-' + (month < 10 ? '0' + month : month);
			if (day !== null) out += '-' + (day < 10 ? '0' + day : day);
			return out;
		}

		return (
			<div style={{ marginTop: 14 }}>
				<p style={{ fontWeight: 600, margin: '0 0 6px' }}>Education</p>
				<div>
					{education.map(function (ed, i) {
						var school = ed && ed.school ? ed.school : '';
						var degree = ed && ed.degree ? ed.degree : '';
						var major = ed && ed.major ? ed.major : '';

						var rawStart = ed && (ed.startDate || ed.schoolStartDate) ? (ed.startDate || ed.schoolStartDate) : '';
						var rawEnd = ed && (ed.endDate || ed.schoolEndDate) ? (ed.endDate || ed.schoolEndDate) : '';

						var start = normalizeDate(rawStart);
						var end = normalizeDate(rawEnd);

						var time = (start || end) ? (start + (end ? ' - ' + end : '')) : '';

						return (
							<div key={'edu_' + i} style={{ border: '1px solid #f0f0f0', borderRadius: 8, padding: 10, marginBottom: 8 }}>
								<div style={{ display: 'grid', gridTemplateColumns: '1.5fr 1fr 1fr', gap: 8 }}>
									<div><strong>{school || '-'}</strong></div>
									<div><strong>Degree</strong><br />{degree || '-'}</div>
									<div><strong>Major</strong><br />{major || '-'}</div>
								</div>
								{time ? (<div className="small-text light-text" style={{ marginTop: 6 }}>{time}</div>) : null}
							</div>
						);
					})}
				</div>
			</div>
		);
	}



	_renderWorkplaceSection(records) {
		if (!records || records.length === 0) return null;

		var self = this;

		return (
			<div className="skiptrace-section skiptrace-section--work">
				<div className="skiptrace-work-title">
					Work and Education
				</div>

				{records.slice(0, 5).map(function (rec, idx) {
					var fullName = rec && rec.fullName ? rec.fullName : '';
					var titles = rec && rec.professionalTitles ? rec.professionalTitles : '';
					var emails = rec && rec.emailAddresses ? rec.emailAddresses : [];
					var phones = rec && rec.phoneNumbers ? rec.phoneNumbers : [];
					var addresses = rec && rec.addresses ? rec.addresses : [];
					var personUrls = rec && rec.personUrls ? rec.personUrls : [];
					var socialConnections = rec && rec.socialConnections ? rec.socialConnections : '';
					var companies = rec && rec.companies ? rec.companies : [];
					var currentEmployment = rec && rec.currentEmployment ? rec.currentEmployment : [];
					var workExperience = rec && rec.workExperience ? rec.workExperience : [];
					var pastEmployment = this._normalizeWorkExp(workExperience);
					var education = rec && rec.education ? rec.education : [];

					return (
						<div key={'wr_' + idx} className="skiptrace-work-block" style={{ marginBottom: 20 }}>

							{/* Header */}
							<div className="skiptrace-work-header" style={{ marginBottom: 12 }}>
								<div style={{ fontWeight: 600 }}>{fullName || '-'}</div>
								<div style={{ fontSize: 13, color: '#6b7280' }}>{titles || '-'}</div>
							</div>

							{/* Profiles */}
							{personUrls && personUrls.length > 0 ? (
								<div className="skiptrace-section">
									<div className="skiptrace-section-title">Profiles</div>
									<ul className="skiptrace-list">
										{personUrls.map(function (u, i) {
											return (
												<self._ListItem
													key={'pu_' + i}
													href={u}
													target="_blank"
													meta={
														socialConnections
															? <span className="small-text light-text">({socialConnections})</span>
															: null
													}
												>
													{u}
												</self._ListItem>
											);
										})}
									</ul>
								</div>
							) : null}

							{/* Phones */}
							<div className="skiptrace-section">
								<div className="skiptrace-section-title">
									<PhoneIcon size={18} /> Phones
								</div>
								<ul className="skiptrace-list">
									{phones && phones.length > 0
										? phones.map(function (p, i) {
											return (
												<self._ListItem key={'wp_p_' + i} href={self._tel(p)} target="_blank">
													{self._formatPhoneDisplay(p)}
												</self._ListItem>
											);
										})
										: <li className="skiptrace-empty">-</li>}
								</ul>
							</div>

							{/* Emails */}
							<div className="skiptrace-section">
								<div className="skiptrace-section-title">
									<EmailOutlineIcon size={18} /> Emails
								</div>
								<ul className="skiptrace-list">
									{emails && emails.length > 0
										? emails.map(function (e, i) {
											return (
												<self._ListItem key={'wp_e_' + i} href={self._mailto(e)} target="_blank">
													{e}
												</self._ListItem>
											);
										})
										: <li className="skiptrace-empty">-</li>}
								</ul>
							</div>

							{/* Workplace Addresses */}
							<div className="skiptrace-section">
								<div className="skiptrace-section-title">
									<MapMarkerIcon size={18} /> Workplace Addresses
								</div>
								<ul className="skiptrace-list">
									{addresses && addresses.length > 0
										? addresses.map(function (a, i) {
											var full = a.fullAddress || a.addressLine1 || '';
											return (
												<li key={'wp_addr_' + i}>{full || '-'}</li>
											);
										})
										: <li className="skiptrace-empty">-</li>}
								</ul>
							</div>

							{/* Current Employment */}
							{this._renderEmployment(currentEmployment, 'Current Employment')}

							{/* Past Employment */}
							{this._renderEmployment(pastEmployment, 'Past Employment')}

							{/* Education */}
							{this._renderEducation(education)}
						</div>
					);
				}.bind(this))}
			</div>
		);
	}


	_renderDeepSection(person) {
		if (!person) return null;

		var first = person.name && person.name.firstName ? person.name.firstName : '';
		var last = person.name && person.name.lastName ? person.name.lastName : '';
		var age = person.age || (person.dob && person.dob.age) || '';
		var primaryAddr = person.addresses && person.addresses[0] ? this._formatAddressFullDeep(person.addresses[0]) : '-';

		var phones = person.phoneNumbers || [];
		var emails = person.emailAddresses || [];
		var addrs = person.addresses || [];
		var akas = person.akas || [];
		var locs = person.locations || [];
		var rels = person.relativesSummary || [];
		var assocS = person.associatesSummary || [];
		var assocF = person.associates || [];

		return (
			<div style={{ marginTop: 20 }}>
				<hr />
				<h5 style={{ textTransform: 'uppercase', fontWeight: 800, marginBottom: 10 }}>Person Profile</h5>

				<div style={{ border: '1px solid #eee', borderRadius: 8, padding: 12 }}>
					<div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 2fr', gap: 8 }}>
						<div><strong>First Name:</strong><br />{first || '-'}</div>
						<div><strong>Last Name:</strong><br />{last || '-'}</div>
						<div><strong>Age:</strong><br />{age || '-'}</div>
						<div><strong>Primary Address:</strong><br />{primaryAddr}</div>
					</div>

					<div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginTop: 16 }}>
						<div>
							<p style={{ fontWeight: 600, margin: '0 0 6px' }}>Phones</p>
							<ul style={{ paddingLeft: 0, margin: 0 }}>
								{phones && phones.length > 0 ? phones.map(function (ph, i) {
									var raw = (ph && (ph.phoneNumber || ph.number)) ? (ph.phoneNumber || ph.number) : '';
									var href = raw ? this._tel(raw) : null;
									return (
										<this._ListItem key={'dp_p_' + i} href={href} target="_blank">
											{this._formatPhoneLine(ph)}
										</this._ListItem>
									);
								}.bind(this)) : <li>-</li>}
							</ul>
						</div>
						<div>
							<p style={{ fontWeight: 600, margin: '0 0 6px' }}>Emails</p>
							<ul style={{ paddingLeft: 0, margin: 0 }}>
								{emails && emails.length > 0 ? emails.map(function (em, i) {
									var val = em && em.emailAddress ? em.emailAddress : '';
									var href = val ? this._mailto(val) : null;
									return (
										<this._ListItem key={'dp_e_' + i} href={href} target="_blank">
											{val || '-'}
										</this._ListItem>
									);
								}.bind(this)) : <li>-</li>}
							</ul>
						</div>
					</div>

					<div style={{ marginTop: 14 }}>
						<p style={{ fontWeight: 600, margin: '0 0 6px' }}>Address History</p>
						<ul style={{ paddingLeft: 0, margin: 0 }}>
							{addrs && addrs.length > 0 ? addrs.map(function (a, i) {
								var line = this._formatAddressFullDeep(a);
								var href = line ? ('https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(line)) : null;
								return (
									<this._ListItem key={'dp_a_' + i} href={href} target="_blank">
										{line || '-'}
									</this._ListItem>
								);
							}.bind(this)) : <li>-</li>}
						</ul>
					</div>

					<div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginTop: 16 }}>
						<div>
							<p style={{ fontWeight: 600, margin: '0 0 6px' }}>AKAs</p>
							{this._renderList(akas, function (a) {
								var af = a && a.firstName ? a.firstName : '';
								var al = a && a.lastName ? a.lastName : '';
								return (af + ' ' + al).trim() || '-';
							})}
						</div>
						<div>
							<p style={{ fontWeight: 600, margin: '0 0 6px' }}>Locations</p>
							{this._renderList(locs, function (l) {
								var c = l && l.city ? l.city : '';
								var s = l && l.state ? l.state : '';
								return (c || s) ? (c + (c && s ? ', ' : '') + s) : '-';
							})}
						</div>
					</div>

					<div style={{ marginTop: 14 }}>
						<p style={{ fontWeight: 600, margin: '0 0 6px' }}>Relatives</p>
						{this._renderList(rels, function (r) {
							var nm = (r && r.firstName ? r.firstName : '') + ' ' + (r && r.lastName ? r.lastName : '');
							var rt = r && r.relativeType ? ' (' + r.relativeType + ')' : '';
							var dob = r && r.dob ? ' - DOB: ' + r.dob : '';
							return (nm.trim() || '-') + rt + dob;
						})}
					</div>

					{assocS && assocS.length > 0 ? (
						<div style={{ marginTop: 14 }}>
							<p style={{ fontWeight: 600, margin: '0 0 6px' }}>Associates</p>
							{this._renderList(assocS, function (a) {
								var nm = (a && a.firstName ? a.firstName : '') + ' ' + (a && a.lastName ? a.lastName : '');
								return nm.trim() || '-';
							})}
						</div>
					) : null}

					{assocF && assocF.length > 0 ? (
						<div style={{ marginTop: 14 }}>
							<p style={{ fontWeight: 600, margin: '0 0 6px' }}>Associates (Details)</p>
							<div>
								{assocF.slice(0, 10).map(function (a, i) {
									var fn = a && a.name && a.name.firstName ? a.name.firstName : '';
									var ln = a && a.name && a.name.lastName ? a.name.lastName : '';
									var aPhones = a && a.phoneNumbers ? a.phoneNumbers : [];
									var aEmails = a && a.emailAddresses ? a.emailAddresses : [];
									var aAddrs = a && a.addresses ? a.addresses : [];
									return (
										<div key={i} style={{ border: '1px solid #f0f0f0', borderRadius: 8, padding: 10, marginBottom: 8 }}>
											<p style={{ margin: '0 0 6px' }}><strong>{(fn + ' ' + ln).trim() || '-'}</strong></p>
											<div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
												<div>
													<p style={{ fontWeight: 600, margin: '0 0 6px' }}>Phones</p>
													<ul style={{ paddingLeft: 0, margin: 0 }}>
														{aPhones && aPhones.length > 0 ? aPhones.map(function (ph, j) {
															var raw = (ph && (ph.phoneNumber || ph.number)) ? (ph.phoneNumber || ph.number) : '';
															var href = raw ? this._tel(raw) : null;
															return (
																<this._ListItem key={'assoc_p_' + i + '_' + j} href={href} target="_blank">
																	{this._formatPhoneLine(ph)}
																</this._ListItem>
															);
														}.bind(this)) : <li>-</li>}
													</ul>
												</div>
												<div>
													<p style={{ fontWeight: 600, margin: '0 0 6px' }}>Emails</p>
													<ul style={{ paddingLeft: 0, margin: 0 }}>
														{aEmails && aEmails.length > 0 ? aEmails.map(function (em, j) {
															var val = em && em.emailAddress ? em.emailAddress : '';
															var href = val ? this._mailto(val) : null;
															return (
																<this._ListItem key={'assoc_e_' + i + '_' + j} href={href} target="_blank">
																	{val || '-'}
																</this._ListItem>
															);
														}.bind(this)) : <li>-</li>}
													</ul>
												</div>
											</div>
											<div style={{ marginTop: 8 }}>
												<p style={{ fontWeight: 600, margin: '0 0 6px' }}>Addresses</p>
												<ul style={{ paddingLeft: 0, margin: 0 }}>
													{aAddrs && aAddrs.length > 0 ? aAddrs.map(function (ad, j) {
														var line = this._formatAddressFullDeep(ad);
														var href = line ? ('https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(line)) : null;
														return (
															<this._ListItem key={'assoc_a_' + i + '_' + j} href={href} target="_blank">
																{line || '-'}
															</this._ListItem>
														);
													}.bind(this)) : <li>-</li>}
												</ul>
											</div>
										</div>
									);
								}.bind(this))}
							</div>
						</div>
					) : null}
				</div>
			</div>
		);
	}





	_renderPremiumCredits() {
		return;
		var user = this.props.user || {};
		var availableCredits = this._getUserPremiumCredits(user);
		var contactCredits = this._getRequiredCreditsForContact('contact');
		var profileCredits = this._getRequiredCreditsForContact('profile');
		var fullCredits = contactCredits + profileCredits;
		var hasContact = availableCredits >= contactCredits;
		var hasFull = availableCredits >= fullCredits;
		return (
			<div
				style={{
					flex: '1 1 260px',
					border: '1px solid #e5e7eb',
					borderRadius: 8,
					padding: 12,
					marginBottom: 20
				}}
				className="billing-credits__card billing-credits__card--premium"
			>
				<div style={{ fontSize: 18, marginBottom: 8, color: '#4b5563' }}>
					<PremiumCreditIcon size={26} style={{ marginTop: -2 }} /> Premium credits available: <strong>{availableCredits}</strong>
				</div>

				<p className="billing-credits__section-description">
					Premium Credits are required to access <strong>contact information</strong> such as emails, phone numbers, detailed profiles, and company research. They <strong>never expire</strong> and are purchased separately from your subscription.

				</p>

				<div style={{ marginTop: 6, fontSize: 12 }}>
					<a
						href="javascript:void(0)"
						className="link-text"
						onClick={function (e) { e.preventDefault(); e.stopPropagation(); this._openPremiumCreditsModal(); }.bind(this)}
					>
						Buy more credits
					</a>
				</div>
			</div>
		)
	}

	_renderOwnerInfoPicker(opts) {
		opts = opts || {};

		var creditsSummary = opts.creditsSummary || null;

		var availableCredits = Number(opts.availableCredits || 0);
		var contactCredits = Number(opts.contactCredits || 0);
		var profileCredits = Number(opts.profileCredits || 0);
		var fullCredits = Number(opts.fullCredits || (contactCredits + profileCredits));

		var hasContact = !!opts.hasContact;
		var hasFull = !!opts.hasFull;

		var onContact = opts.onContact;
		var onFull = opts.onFull;
		var onTopUp = opts.onTopUp;

		function _onCardClick(fn, enabled, e) {
			if (e && e.preventDefault) e.preventDefault();
			if (!enabled) return;
			if (fn) fn();
		}

		function _onKeyDown(fn, enabled, e) {
			if (!e) return;
			if (e.key === 'Enter' || e.key === ' ') {
				if (e.preventDefault) e.preventDefault();
				_onCardClick(fn, enabled, e);
			}
		}

		return (
			<div className="premium-dashboard">
				{/*creditsSummary*/}

				{/* <div className="premium-pickerHeader">
		  <div className="premium-pickerHeader__title">Choose Owner Info</div>
		  <div className="premium-pickerHeader__sub">
			Pick the depth you need. Credits are only used when we find results.
		  </div>
		</div> */}

				<div className="premium-grid3">
					{/* Left benefits column */}
					<div className="premium-benefits">
						<div className="premium-benefits__brandRow">
							<div className="premium-benefits__badge">{this.props.property.building_name ? _capitalizeText(this.props.property.building_name) : _capitalizeText(this.props.property.display_full_street_address)}{this.props.property.address_2_normalized ? `, ${this.props.property.address_2_normalized.toUpperCase().replace("APT", "Apt")}` : ""}</div>
						</div>

						<div className="premium-benefits__title">{this.props.triggerDisplay}</div>

						<ul className="premium-benefits__list">
							<li>
								<span className="premium-check">✓</span>
								Multi-source skip trace
							</li>
							<li>
								<span className="premium-check">✓</span>
								Verified property ownership
							</li>
							<li>
								<span className="premium-check">✓</span>
								Intelligent name and address matching
							</li>
							<li>
								<span className="premium-check">✓</span>
								Results saved for export anytime
							</li>

						</ul>
						<hr />
						<div className="premium-credit_avail">


							Premium Credits: <strong>{availableCredits}</strong>
							<a
								href="javascript:void(0)"
								className="link-text top-credit"
								onClick={function (e) { e.preventDefault(); e.stopPropagation(); this._openPremiumCreditsModal(); }.bind(this)}
							>
								Purchase Credits
							</a>

						</div>
						<QuickStartGuide
							link="http://help.marketproof.com/en/articles/13454433-understanding-credits-in-marketproof-pro"
							copy="What are premium credits?"
							linkCopy="Learn More"
						/>
					</div>

					{/* Contact card */}
					<div
						className={
							'premium-miniCard premium-miniCard--contact' +
							(hasContact ? '' : ' premium-miniCard--disabled')
						}
						role="button"
						tabIndex={0}

					>
						<div className="premium-miniCard__top">
							<div className="premium-miniCard__logoRow">
								<div className="premium-miniCard__icon">
									<svg width="40" height="40" viewBox="0 0 24 24" fill="none" aria-hidden="true">
										<path d="M4 6h16v12H4V6z" stroke="currentColor" strokeWidth="1.8" />
										<path d="M4.5 7l7.5 6 7.5-6" stroke="currentColor" strokeWidth="1.8" />
									</svg>
								</div>
								<div className="premium-miniCard__label">CONTACT INFO</div>
							</div>

							<div className="premium-miniCard__desc">
								Email and phone for quick outreach.
							</div>

							{/* <div className="premium-miniCard__priceBlock">
				<div className="premium-miniCard__price">{contactCredits}</div>
				<div className="premium-miniCard__priceMeta">
				  credit{contactCredits === 1 ? '' : 's'} per lookup
				</div>
			  </div> */}

							<ul className="premium-miniCard__bullets">
								<li>Email + phone</li>
								<li>Address history</li>
								<li>Age (when available)</li>
								<li>1 premium credit</li>
							</ul>
						</div>
						<div className="premium-context-desc">Unlock contact for {this.props.triggerDisplay}</div>

						<div className="premium-miniCard__bottom">
							{hasContact ? <Button
								onClick={function (e) {
									e.preventDefault();
									e.stopPropagation();
									if (hasContact && onContact) onContact();
								}}
								variant="contained"
								color="primary"
								className="premium-miniCard__cta"
								disabled={!hasContact}
							>
								Get Contact Info
							</Button> : (
								<>
									<Button
										variant="contained"
										color="primary"
										className="premium-miniCard__cta"
										onClick={function (e) {
											e.preventDefault();
											e.stopPropagation();
											if (onTopUp) onTopUp();
										}}
									>
										Get Premium Credits
									</Button>

								</>
							)}
						</div>
					</div>

					{/* Full card */}
					<div
						className={
							'premium-miniCard premium-miniCard--full' +
							(hasFull ? '' : ' premium-miniCard--disabled')
						}
						role="button"
						tabIndex={0}
						onClick={_onCardClick.bind(null, onFull, hasFull)}
						onKeyDown={_onKeyDown.bind(null, onFull, hasFull)}
					>
						<div className="premium-miniCard__top">
							<div className="premium-miniCard__logoRow">
								<div className="premium-miniCard__icon">
									<svg width="40" height="40" viewBox="0 0 24 24" fill="none" aria-hidden="true">
										<path d="M3 8l9-4 9 4-9 4-9-4z" stroke="currentColor" strokeWidth="1.8" />
										<path d="M7 10v6c0 1 2 3 5 3s5-2 5-3v-6" stroke="currentColor" strokeWidth="1.8" />
									</svg>
								</div>
								<div className="premium-miniCard__label">FULL PROFILE</div>
							</div>

							<div className="premium-miniCard__desc">
								Work and education for tailored outreach.
							</div>

							{/* <div className="premium-miniCard__priceBlock">
				<div className="premium-miniCard__price">{fullCredits}</div>
				<div className="premium-miniCard__priceMeta">
				  credits per lookup
				</div>
				<div className="premium-miniCard__priceNote">
				  contact {contactCredits} + profile {profileCredits}
				</div>
			  </div> */}

							<ul className="premium-miniCard__bullets">
								<li>Everything in Contact Info</li>
								<li>Employment + education + social</li>
								<li>AI enhanced summary</li>
								<li>6 premium credits</li>
							</ul>
						</div>
						<div className="premium-context-desc">Unlock details for {this.props.triggerDisplay}</div>
						<div className="premium-miniCard__bottom">
							{hasFull ? <Button
								onClick={function (e) {
									e.preventDefault();
									e.stopPropagation();
									if (hasFull && onFull) onFull();
								}}
								variant="contained"
								color="primary"
								className="premium-miniCard__cta"
								disabled={!hasFull}
							>
								Get Full Profile
							</Button> : (
								<>
									<Button
										variant="contained"
										color="primary"
										className="premium-miniCard__cta"
										onClick={function (e) {
											e.preventDefault();
											e.stopPropagation();
											if (onTopUp) onTopUp();
										}}
									>
										Get Premium Credits
									</Button>

								</>
							)}

						</div>
					</div>
				</div>
			</div>
		);
	}



	_renderPersonFlow() {
		var s_loading = this.state.simple_loading;
		var s_error = this.state.simple_error;
		var s_person = this.state.simple_person;
		var g_loading = this.state.saved_loading;

		var d_loading = this.state.deep_loading;
		var d_error = this.state.deep_error;
		var d_persons = this.state.deep_persons || [];
		var ai_loading = this.state.ai_loading;
		var ai_profile = this.state.ai_profile;
		var wp_loading = this.state.workplace_loading;
		var wp_error = this.state.workplace_error;
		var wp_records = this.state.workplace_records || [];

		var user = this.props.user || {};
		var availableCredits = this._getUserPremiumCredits(user);
		var contactCredits = this._getRequiredCreditsForContact('contact');
		var profileCredits = this._getRequiredCreditsForContact('profile');
		var fullCredits = contactCredits + profileCredits;
		var hasContact = availableCredits >= contactCredits;
		var hasFull = availableCredits >= fullCredits;
		var isFull = this.state.lookup_mode === 'full';
		if (s_loading || d_loading || wp_loading || ai_loading || g_loading) {
			var mode = isFull ? 'full' : 'search';
			return (
				<div>
					{this._renderSearchContextBanner()}
					<ProfileLoadingCard
						data={this.props}
						messageType={mode}
						stepMs={2500}
						capitalizeText={this._capitalizeText}
						getInitials={this._getInitialsFromPerson}
						formatAddress={formatAddress}
						LinearLoading={LinearLoading}
						MapMarkerIcon={MapMarkerIcon}
					/>

				</div>
			);
		}

		var self = this;
		// After search has run, still show available credits summary
		var creditsSummary = self._renderPremiumCredits();
		var isSavedView = !!(this.props.saved_record && this.props.saved_record.data);

		// Initial state: let user pick mode and show credits
		if (!this.state.hasSearched && !s_person && (!d_persons || d_persons.length === 0) && !s_error && !d_error && !isSavedView) {
			return this._renderOwnerInfoPicker({
				creditsSummary: creditsSummary,
				availableCredits: availableCredits,
				contactCredits: contactCredits,
				profileCredits: profileCredits,
				fullCredits: fullCredits,
				hasContact: hasContact,
				hasFull: hasFull,
				onContact: this._handleStartContactOnly,
				onFull: this._handleStartFullProfile,
				onTopUp: this._openPremiumCreditsModal.bind(this)
			});
		}


		// If simple found, show SUMMARY first, then lists + workplace
		// If simple found, show SUMMARY first, then lists + workplace
		if (s_person) {

			var hasAI = !!this.state.ai_profile;
			var isAILoading = this.state.ai_loading;

			// FULL PROFILE FLOW: show only loading or AI card
			if (isFull) {
				// While AI is loading or result not yet present, show loading card only
				if (!ai_profile) {
					return (
						<div>
							{self._renderSearchContextBanner()}
							<ProfileLoadingCard
								data={this.props}
								messageType={mode}
								stepMs={2500}
								capitalizeText={this._capitalizeText}
								getInitials={this._getInitialsFromPerson}
								formatAddress={formatAddress}
								LinearLoading={LinearLoading}
								MapMarkerIcon={MapMarkerIcon}
							/>
						</div>
					);
				}

				// Once AI result is ready, show AI profile card only
				return (
					<div>
						{self._renderSearchContextBanner()}
						{this._renderAIFullProfileCard()}
					</div>
				);
			}

			// NON-FULL FLOW: keep existing simple + workplace behavior
			return (
				<div>
					{self._renderSearchContextBanner()}

					{this._renderSimpleContactCard(s_person)}

					{/* Workplace section (user can still opt in later) */}
					{!isSavedView && (!wp_records || wp_records.length <= 0) ? (
						<div
							className="dashboard"
							style={{ textAlign: 'center', marginTop: 16 }}
						>
							{wp_loading ? (
								<div style={{ maxWidth: 260, margin: '0 auto' }}>
									<LinearLoading />
									<p>Running search…</p>
								</div>
							) : (
								<>

									<div className="premium-context-desc">Unlock details for {this.props.triggerDisplay}.  Uses <strong>{profileCredits}</strong> premium credits</div>.
									<Button
										onClick={this._handleStartFullProfile}
										variant="contained"
										color="primary"
										className="premium-miniCard__cta"
										disabled={!hasFull}
										style={{ minWidth: 200, width: 250 }}
									>
										{hasFull ? 'Get Full Profile' : 'Not enough credits'}
									</Button>

								</>
							)}
							{wp_error ? <p style={{ color: 'red' }}>{wp_error}</p> : null}
						</div>
					) : null}

					{wp_records && wp_records.length > 0
						? this._renderWorkplaceSection(wp_records)
						: null}
				</div>
			);
		}




		if (d_error) return (
			<div>
				{creditsSummary}
				<p style={{ color: 'red' }}>{d_error}</p>
			</div>
		);
		if (d_persons && d_persons.length > 0) {
			return (
				<div>
					{creditsSummary}
					<h4 style={{ textTransform: 'uppercase', fontWeight: 800, marginTop: 10 }}>Deep Search Results</h4>
					{this._renderDeepResultsList()}
				</div>
			);
		}
		if (s_error) return (
			<div>
				{creditsSummary}
				<p style={{ color: 'red' }}>{s_error}</p>
			</div>
		);
		return (
			<div>
				{creditsSummary}

				<div className="skiptrace-profile-card skiptrace-profile-card--empty">
					<div style={{ padding: '12px 4px' }}>
						<h4
							style={{
								fontSize: 18,
								fontWeight: 600,
								margin: '0 0 6px',
								color: '#111827'
							}}
						>
							No Matching Contact Found
						</h4>

						<p
							style={{
								fontSize: 14,
								color: '#4b5563',
								margin: '0 0 6px',
								lineHeight: 1.45
							}}
						>
							We were unable to find a matching contact.
						</p>

						<p
							style={{
								fontSize: 14,
								color: '#6b7280',
								margin: 0,
								lineHeight: 1.4
							}}
						>
							<strong>No premium credits were deducted.</strong>
						</p>
					</div>
				</div>
			</div>
		);
	}



	// Helper to check if entity is a trust or other non-NYS DOS entity
	_isUnsupportedEntityType(name) {
		if (!name || typeof name !== 'string') return false;
		var upperName = name.toUpperCase();
		var unsupportedPatterns = [
			'TRUST',
			'ESTATE OF',
			'THE ESTATE OF',
			'FAMILY TRUST',
			'LIVING TRUST',
			'REVOCABLE TRUST',
			'IRREVOCABLE TRUST'
		];
		return unsupportedPatterns.some(function(pattern) {
			return upperName.includes(pattern);
		});
	}

	// ===============================
	// Render
	// ===============================
	render() {
		var user = this.props.user;
		var triggerDisplay = this.props.triggerDisplay;
		var isControlled = typeof this.props.isOpen === 'boolean';
		var isOpen = isControlled ? this.props.isOpen : this.state.modal;
		var property = this.props.property;

		if (!_hasPermission(user, 'skip-trace')) {
			return (
				<span style={{ fontSize: 13, whiteSpace: 'nowrap', marginRight: 5 }}>
					{triggerDisplay}
				</span>
			);
		}

		if (!triggerDisplay || triggerDisplay.length < 2) {
			return (
				<span style={{ whiteSpace: 'nowrap' }}>
					--
				</span>
			);
		}

		var isCompany = isCompanyName(triggerDisplay);

		// Check if it's an unsupported entity type (trust, estate, etc.)
		if (isCompany && this._isUnsupportedEntityType(triggerDisplay)) {
			return (
				<div className="skip-trace-owner company skip-trace-owner--disabled">
					<Tooltip title="This type of entity is not supported">
						<span>
							<IconButton size="small" disabled>
								<>
									<CompanyIcon size={14} />
									{triggerDisplay && triggerDisplay.length > 27 ? triggerDisplay.substring(0, 27) + '...' : triggerDisplay}
								</>
							</IconButton>
						</span>
					</Tooltip>
				</div>
			);
		}

		var isSavedView = !!(this.props.saved_record && this.props.saved_record.data);

		if (!isSavedView && (!property || (!property.borough && isCompany))) {
			return (
				<span style={{ whiteSpace: 'nowrap' }}>
					{triggerDisplay}
				</span>
			);

		}

		var self = this;

		return (
			<Fragment>
				<SnackBar
					snackShow={this.state.snackShow}
					snackClose={() => this.setState({ snackShow: false })}
					snackMessage={this.state.snackMessage}
					snackDuration={this.state.snackDuration}
					snackType={this.state.snackType}
				/>

				{/* Trigger */}
				<div
					className={`skip-trace-owner ${isCompany ? 'company' : 'person'}`}
					onClick={function (e) { self._handleTriggerClick(e, isCompany); }}
				>

					<Tooltip title={isCompany ? `Research who is behind ${triggerDisplay}` : `Get emails, phones, work, education and more.`}>
						<IconButton size="small">
							<>
								{isCompany
									? <CompanyIcon size={14} />
									: null}
								{triggerDisplay && triggerDisplay.length > 27 ? triggerDisplay.substring(0, 27) + '...' : triggerDisplay}
							</>
						</IconButton>

					</Tooltip>

				</div>

				<Modal
					isOpen={isOpen}
					modalClassName="ltr-support"
					className="modal-dialog--primary modal-dialog--header"
					toggle={this.toggle}
					style={{ minWidth: 1200 }}
					scrollable={true}
				>
					<div className="modal__header">
						<button className="lnr lnr-cross modal__close-btn" onClick={this.toggle} />
						<h4 className="modal__title">
							<ActiveIcon size={22} /> {isCompany ? 'Company Insights' : 'Contact Insights'} - {triggerDisplay}
						</h4>
					</div>

					<div className="modal__body">
						{isCompany ? this._renderCompanyFlow() : this._renderPersonFlow()}
					</div>

					<ButtonToolbar className="modal__footer offering-status">
						<hr />
						<Button
							className="modal_ok btn btn-primary"
							onClick={this.toggle}
							color="primary"
						>
							Close
						</Button>
					</ButtonToolbar>
				</Modal>

				{/* Hidden Premium Credits purchase modal; opened programmatically */}
				<PremiumCreditsPurchaseModal
					ref={function (ref) { self.premiumCreditsModal = ref; }}
					renderButton={function () {
						// No visible "Buy" button here; we open via ref
						return null;
					}}
					onConfirm={this._handlePremiumPurchaseConfirm}
				/>
			</Fragment>
		);
	}

}

SkipTraceUnifiedModal.propTypes = {
	triggerDisplay: PropTypes.string.isRequired,
	user: PropTypes.object,
	isOpen: PropTypes.bool,
	onClose: PropTypes.func,
	onOpen: PropTypes.func,
	first_name: PropTypes.string,
	last_name: PropTypes.string,
	address_1: PropTypes.string,
	address_2: PropTypes.string,
	city: PropTypes.string,
	county: PropTypes.string,
	state: PropTypes.string,
	zip: PropTypes.string,
	simpleUrl: PropTypes.string,
	state: PropTypes.string,
	business_name: PropTypes.string,
	borough_code: PropTypes.string,
	block: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	lot: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	property: PropTypes.object
};


export default connect(function (state) {
	return {
		user: state.user,
	};
})(SkipTraceUnifiedModal);
